(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("prop-types"), require("react-router-dom"));
	else if(typeof define === 'function' && define.amd)
		define("p1s-common-react", ["react", "prop-types", "react-router-dom"], factory);
	else if(typeof exports === 'object')
		exports["p1s-common-react"] = factory(require("react"), require("prop-types"), require("react-router-dom"));
	else
		root["p1s-common-react"] = factory(root["react"], root["prop-types"], root["react-router-dom"]);
})(typeof self !== 'undefined' ? self : this, (__WEBPACK_EXTERNAL_MODULE__9155__, __WEBPACK_EXTERNAL_MODULE__1949__, __WEBPACK_EXTERNAL_MODULE__4442__) => {
return /******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 6543:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
  if (true) module.exports = factory(__webpack_require__(9155));else {}
})(this, function (__WEBPACK_EXTERNAL_MODULE_1__) {
  return /******/function (modules) {
    // webpackBootstrap
    /******/ // The module cache
    /******/
    var installedModules = {};

    /******/ // The require function
    /******/
    function __nested_webpack_require_624__(moduleId) {
      /******/ // Check if module is in cache
      /******/if (installedModules[moduleId]) /******/return installedModules[moduleId].exports;

      /******/ // Create a new module (and put it into the cache)
      /******/
      var module = installedModules[moduleId] = {
        /******/exports: {},
        /******/id: moduleId,
        /******/loaded: false
        /******/
      };

      /******/ // Execute the module function
      /******/
      modules[moduleId].call(module.exports, module, module.exports, __nested_webpack_require_624__);

      /******/ // Flag the module as loaded
      /******/
      module.loaded = true;

      /******/ // Return the exports of the module
      /******/
      return module.exports;
      /******/
    }

    /******/ // expose the modules object (__webpack_modules__)
    /******/
    __nested_webpack_require_624__.m = modules;

    /******/ // expose the module cache
    /******/
    __nested_webpack_require_624__.c = installedModules;

    /******/ // __webpack_public_path__
    /******/
    __nested_webpack_require_624__.p = "";

    /******/ // Load entry module and return exports
    /******/
    return __nested_webpack_require_624__(0);
    /******/
  }
  /************************************************************************/
  /******/([(/* 0 */
  /***/function (module, exports, __nested_webpack_require_1965__) {
    'use strict';

    var _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    function _objectWithoutProperties(obj, keys) {
      var target = {};
      for (var i in obj) {
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
      }
      return target;
    }
    var React = __nested_webpack_require_1965__(1); // eslint-disable-line no-unused-vars
    var CreateReactClass = __nested_webpack_require_1965__(2);
    var NumeralFormatter = __nested_webpack_require_1965__(10);
    var DateFormatter = __nested_webpack_require_1965__(11);
    var TimeFormatter = __nested_webpack_require_1965__(12);
    var PhoneFormatter = __nested_webpack_require_1965__(13);
    var CreditCardDetector = __nested_webpack_require_1965__(14);
    var Util = __nested_webpack_require_1965__(15);
    var DefaultProperties = __nested_webpack_require_1965__(16);
    var cleaveReactClass = CreateReactClass({
      componentDidMount: function componentDidMount() {
        this.init();
      },
      componentDidUpdate: function componentDidUpdate(prevProps) {
        var owner = this,
          phoneRegionCode = (owner.props.options || {}).phoneRegionCode,
          newValue = owner.props.value,
          pps = owner.properties;
        owner.updateRegisteredEvents(owner.props);
        if (prevProps.value !== newValue && newValue !== undefined && newValue !== null) {
          newValue = newValue.toString();
          if (newValue !== owner.properties.result) {
            owner.properties.initValue = newValue;
            owner.onInput(newValue, true);
          }
        }

        // update phone region code
        var prevPhoneRegionCode = (prevProps.options || {}).phoneRegionCode;
        if (prevPhoneRegionCode !== phoneRegionCode && phoneRegionCode && phoneRegionCode !== owner.properties.phoneRegionCode) {
          owner.properties.phoneRegionCode = phoneRegionCode;
          owner.initPhoneFormatter();
          owner.onInput(owner.properties.result);
        }
        Util.setSelection(owner.element, owner.state.cursorPosition, pps.document);
      },
      updateRegisteredEvents: function updateRegisteredEvents(props) {
        var owner = this,
          _owner$registeredEven = owner.registeredEvents,
          onKeyDown = _owner$registeredEven.onKeyDown,
          onChange = _owner$registeredEven.onChange,
          onFocus = _owner$registeredEven.onFocus,
          onBlur = _owner$registeredEven.onBlur,
          onInit = _owner$registeredEven.onInit;
        if (props.onInit && props.onInit !== onInit) owner.registeredEvents.onInit = props.onInit;
        if (props.onChange && props.onChange !== onChange) owner.registeredEvents.onChange = props.onChange;
        if (props.onFocus && props.onFocus !== onFocus) owner.registeredEvents.onFocus = props.onFocus;
        if (props.onBlur && props.onBlur !== onBlur) owner.registeredEvents.onBlur = props.onBlur;
        if (props.onKeyDown && props.onKeyDown !== onKeyDown) owner.registeredEvents.onKeyDown = props.onKeyDown;
      },
      getInitialState: function getInitialState() {
        var owner = this,
          _owner$props = owner.props,
          value = _owner$props.value,
          options = _owner$props.options,
          onKeyDown = _owner$props.onKeyDown,
          onChange = _owner$props.onChange,
          onFocus = _owner$props.onFocus,
          onBlur = _owner$props.onBlur,
          onInit = _owner$props.onInit;
        owner.registeredEvents = {
          onInit: onInit || Util.noop,
          onChange: onChange || Util.noop,
          onFocus: onFocus || Util.noop,
          onBlur: onBlur || Util.noop,
          onKeyDown: onKeyDown || Util.noop
        };
        if (!options) {
          options = {};
        }
        options.initValue = value;
        owner.properties = DefaultProperties.assign({}, options);
        return {
          value: owner.properties.result,
          cursorPosition: 0
        };
      },
      init: function init() {
        var owner = this,
          pps = owner.properties;

        // so no need for this lib at all
        if (!pps.numeral && !pps.phone && !pps.creditCard && !pps.time && !pps.date && pps.blocksLength === 0 && !pps.prefix) {
          owner.onInput(pps.initValue);
          owner.registeredEvents.onInit(owner);
          return;
        }
        pps.maxLength = Util.getMaxLength(pps.blocks);
        owner.isAndroid = Util.isAndroid();
        owner.initPhoneFormatter();
        owner.initDateFormatter();
        owner.initTimeFormatter();
        owner.initNumeralFormatter();

        // avoid touch input field if value is null
        // otherwise Firefox will add red box-shadow for <input required />
        if (pps.initValue || pps.prefix && !pps.noImmediatePrefix) {
          owner.onInput(pps.initValue);
        }
        owner.registeredEvents.onInit(owner);
      },
      initNumeralFormatter: function initNumeralFormatter() {
        var owner = this,
          pps = owner.properties;
        if (!pps.numeral) {
          return;
        }
        pps.numeralFormatter = new NumeralFormatter(pps.numeralDecimalMark, pps.numeralIntegerScale, pps.numeralDecimalScale, pps.numeralThousandsGroupStyle, pps.numeralPositiveOnly, pps.stripLeadingZeroes, pps.prefix, pps.signBeforePrefix, pps.tailPrefix, pps.delimiter);
      },
      initTimeFormatter: function initTimeFormatter() {
        var owner = this,
          pps = owner.properties;
        if (!pps.time) {
          return;
        }
        pps.timeFormatter = new TimeFormatter(pps.timePattern, pps.timeFormat);
        pps.blocks = pps.timeFormatter.getBlocks();
        pps.blocksLength = pps.blocks.length;
        pps.maxLength = Util.getMaxLength(pps.blocks);
      },
      initDateFormatter: function initDateFormatter() {
        var owner = this,
          pps = owner.properties;
        if (!pps.date) {
          return;
        }
        pps.dateFormatter = new DateFormatter(pps.datePattern, pps.dateMin, pps.dateMax);
        pps.blocks = pps.dateFormatter.getBlocks();
        pps.blocksLength = pps.blocks.length;
        pps.maxLength = Util.getMaxLength(pps.blocks);
      },
      initPhoneFormatter: function initPhoneFormatter() {
        var owner = this,
          pps = owner.properties;
        if (!pps.phone) {
          return;
        }

        // Cleave.AsYouTypeFormatter should be provided by
        // external google closure lib
        try {
          pps.phoneFormatter = new PhoneFormatter(new pps.root.Cleave.AsYouTypeFormatter(pps.phoneRegionCode), pps.delimiter);
        } catch (ex) {
          throw new Error('Please include phone-type-formatter.{country}.js lib');
        }
      },
      setRawValue: function setRawValue(value) {
        var owner = this,
          pps = owner.properties;
        value = value !== undefined && value !== null ? value.toString() : '';
        if (pps.numeral) {
          value = value.replace('.', pps.numeralDecimalMark);
        }
        pps.postDelimiterBackspace = false;
        owner.onChange({
          target: {
            value: value
          },
          // Methods to better resemble a SyntheticEvent
          stopPropagation: Util.noop,
          preventDefault: Util.noop,
          persist: Util.noop
        });
      },
      getRawValue: function getRawValue() {
        var owner = this,
          pps = owner.properties,
          rawValue = pps.result;
        if (pps.rawValueTrimPrefix) {
          rawValue = Util.getPrefixStrippedValue(rawValue, pps.prefix, pps.prefixLength, pps.result, pps.delimiter, pps.delimiters, pps.noImmediatePrefix, pps.tailPrefix, pps.signBeforePrefix);
        }
        if (pps.numeral) {
          rawValue = pps.numeralFormatter ? pps.numeralFormatter.getRawValue(rawValue) : '';
        } else {
          rawValue = Util.stripDelimiters(rawValue, pps.delimiter, pps.delimiters);
        }
        return rawValue;
      },
      getISOFormatDate: function getISOFormatDate() {
        var owner = this,
          pps = owner.properties;
        return pps.date ? pps.dateFormatter.getISOFormatDate() : '';
      },
      getISOFormatTime: function getISOFormatTime() {
        var owner = this,
          pps = owner.properties;
        return pps.time ? pps.timeFormatter.getISOFormatTime() : '';
      },
      onInit: function onInit(owner) {
        return owner;
      },
      onKeyDown: function onKeyDown(event) {
        var owner = this,
          pps = owner.properties,
          charCode = event.which || event.keyCode;
        owner.lastInputValue = pps.result;
        owner.isBackward = charCode === 8;
        owner.registeredEvents.onKeyDown(event);
      },
      onFocus: function onFocus(event) {
        var owner = this,
          pps = owner.properties;
        if (pps.prefix && pps.noImmediatePrefix && !event.target.value) {
          owner.onInput(pps.prefix);
        }
        event.target.rawValue = owner.getRawValue();
        event.target.value = pps.result;
        owner.registeredEvents.onFocus(event);
        Util.fixPrefixCursor(owner.element, pps.prefix, pps.delimiter, pps.delimiters);
      },
      onBlur: function onBlur(event) {
        var owner = this,
          pps = owner.properties;
        event.target.rawValue = owner.getRawValue();
        event.target.value = pps.result;
        owner.registeredEvents.onBlur(event);
      },
      onChange: function onChange(event) {
        var owner = this,
          pps = owner.properties;
        owner.isBackward = owner.isBackward || event.inputType === 'deleteContentBackward';
        // hit backspace when last character is delimiter
        var postDelimiter = Util.getPostDelimiter(owner.lastInputValue, pps.delimiter, pps.delimiters);
        if (owner.isBackward && postDelimiter) {
          pps.postDelimiterBackspace = postDelimiter;
        } else {
          pps.postDelimiterBackspace = false;
        }
        owner.onInput(event.target.value);
        event.target.rawValue = owner.getRawValue();
        event.target.value = pps.result;
        owner.registeredEvents.onChange(event);
      },
      onInput: function onInput(value, fromProps) {
        var owner = this,
          pps = owner.properties;

        // case 1: delete one more character "4"
        // 1234*| -> hit backspace -> 123|
        // case 2: last character is not delimiter which is:
        // 12|34* -> hit backspace -> 1|34*
        var postDelimiterAfter = Util.getPostDelimiter(value, pps.delimiter, pps.delimiters);
        if (!fromProps && !pps.numeral && pps.postDelimiterBackspace && !postDelimiterAfter) {
          value = Util.headStr(value, value.length - pps.postDelimiterBackspace.length);
        }

        // phone formatter
        if (pps.phone) {
          if (pps.prefix && (!pps.noImmediatePrefix || value.length)) {
            pps.result = pps.prefix + pps.phoneFormatter.format(value).slice(pps.prefix.length);
          } else {
            pps.result = pps.phoneFormatter.format(value);
          }
          owner.updateValueState();
          return;
        }

        // numeral formatter
        if (pps.numeral) {
          // Do not show prefix when noImmediatePrefix is specified
          // This mostly because we need to show user the native input placeholder
          if (pps.prefix && pps.noImmediatePrefix && value.length === 0) {
            pps.result = '';
          } else {
            pps.result = pps.numeralFormatter.format(value);
          }
          owner.updateValueState();
          return;
        }

        // date
        if (pps.date) {
          value = pps.dateFormatter.getValidatedDate(value);
        }

        // time
        if (pps.time) {
          value = pps.timeFormatter.getValidatedTime(value);
        }

        // strip delimiters
        value = Util.stripDelimiters(value, pps.delimiter, pps.delimiters);

        // strip prefix
        value = Util.getPrefixStrippedValue(value, pps.prefix, pps.prefixLength, pps.result, pps.delimiter, pps.delimiters, pps.noImmediatePrefix, pps.tailPrefix, pps.signBeforePrefix);

        // strip non-numeric characters
        value = pps.numericOnly ? Util.strip(value, /[^\d]/g) : value;

        // convert case
        value = pps.uppercase ? value.toUpperCase() : value;
        value = pps.lowercase ? value.toLowerCase() : value;

        // prevent from showing prefix when no immediate option enabled with empty input value
        if (pps.prefix) {
          if (pps.tailPrefix) {
            value = value + pps.prefix;
          } else {
            value = pps.prefix + value;
          }

          // no blocks specified, no need to do formatting
          if (pps.blocksLength === 0) {
            pps.result = value;
            owner.updateValueState();
            return;
          }
        }

        // update credit card props
        if (pps.creditCard) {
          owner.updateCreditCardPropsByValue(value);
        }

        // strip over length characters
        value = pps.maxLength > 0 ? Util.headStr(value, pps.maxLength) : value;

        // apply blocks
        pps.result = Util.getFormattedValue(value, pps.blocks, pps.blocksLength, pps.delimiter, pps.delimiters, pps.delimiterLazyShow);
        owner.updateValueState();
      },
      updateCreditCardPropsByValue: function updateCreditCardPropsByValue(value) {
        var owner = this,
          pps = owner.properties,
          creditCardInfo;

        // At least one of the first 4 characters has changed
        if (Util.headStr(pps.result, 4) === Util.headStr(value, 4)) {
          return;
        }
        creditCardInfo = CreditCardDetector.getInfo(value, pps.creditCardStrictMode);
        pps.blocks = creditCardInfo.blocks;
        pps.blocksLength = pps.blocks.length;
        pps.maxLength = Util.getMaxLength(pps.blocks);

        // credit card type changed
        if (pps.creditCardType !== creditCardInfo.type) {
          pps.creditCardType = creditCardInfo.type;
          pps.onCreditCardTypeChanged.call(owner, pps.creditCardType);
        }
      },
      updateValueState: function updateValueState() {
        var owner = this,
          pps = owner.properties;
        if (!owner.element) {
          owner.setState({
            value: pps.result
          });
          return;
        }
        var endPos = owner.element.selectionEnd;
        var oldValue = owner.element.value;
        var newValue = pps.result;
        owner.lastInputValue = newValue;
        endPos = Util.getNextCursorPosition(endPos, oldValue, newValue, pps.delimiter, pps.delimiters);
        if (owner.isAndroid) {
          window.setTimeout(function () {
            owner.setState({
              value: newValue,
              cursorPosition: endPos
            });
          }, 1);
          return;
        }
        owner.setState({
          value: newValue,
          cursorPosition: endPos
        });
      },
      render: function render() {
        var owner = this;
        // eslint-disable-next-line

        var _owner$props2 = owner.props,
          value = _owner$props2.value,
          options = _owner$props2.options,
          onKeyDown = _owner$props2.onKeyDown,
          onFocus = _owner$props2.onFocus,
          onBlur = _owner$props2.onBlur,
          onChange = _owner$props2.onChange,
          onInit = _owner$props2.onInit,
          htmlRef = _owner$props2.htmlRef,
          propsToTransfer = _objectWithoutProperties(_owner$props2, ['value', 'options', 'onKeyDown', 'onFocus', 'onBlur', 'onChange', 'onInit', 'htmlRef']);
        return React.createElement('input', _extends({
          type: 'text',
          ref: function ref(_ref) {
            owner.element = _ref;
            if (!htmlRef) {
              return;
            }
            htmlRef.apply(this, arguments);
          },
          value: owner.state.value,
          onKeyDown: owner.onKeyDown,
          onChange: owner.onChange,
          onFocus: owner.onFocus,
          onBlur: owner.onBlur
        }, propsToTransfer));
      }
    });
    module.exports = cleaveReactClass;

    /***/
  }), (/* 1 */
  /***/function (module, exports) {
    module.exports = __WEBPACK_EXTERNAL_MODULE_1__;

    /***/
  }), (/* 2 */
  /***/function (module, exports, __nested_webpack_require_18542__) {
    /**
     * Copyright (c) 2013-present, Facebook, Inc.
     *
     * This source code is licensed under the MIT license found in the
     * LICENSE file in the root directory of this source tree.
     *
     */

    'use strict';

    var React = __nested_webpack_require_18542__(1);
    var factory = __nested_webpack_require_18542__(3);
    if (typeof React === 'undefined') {
      throw Error('create-react-class could not find the React object. If you are using script tags, ' + 'make sure that React is being loaded before create-react-class.');
    }

    // Hack to grab NoopUpdateQueue from isomorphic React
    var ReactNoopUpdateQueue = new React.Component().updater;
    module.exports = factory(React.Component, React.isValidElement, ReactNoopUpdateQueue);

    /***/
  }), (/* 3 */
  /***/function (module, exports, __nested_webpack_require_19372__) {
    /* WEBPACK VAR INJECTION */(function (process) {
      /**
      * Copyright (c) 2013-present, Facebook, Inc.
      *
      * This source code is licensed under the MIT license found in the
      * LICENSE file in the root directory of this source tree.
      *
      */

      'use strict';

      var _assign = __nested_webpack_require_19372__(5);
      var emptyObject = __nested_webpack_require_19372__(6);
      var _invariant = __nested_webpack_require_19372__(7);
      if (process.env.NODE_ENV !== 'production') {
        var warning = __nested_webpack_require_19372__(8);
      }
      var MIXINS_KEY = 'mixins';

      // Helper function to allow the creation of anonymous functions which do not
      // have .name set to the name of the variable being assigned to.
      function identity(fn) {
        return fn;
      }
      var ReactPropTypeLocationNames;
      if (process.env.NODE_ENV !== 'production') {
        ReactPropTypeLocationNames = {
          prop: 'prop',
          context: 'context',
          childContext: 'child context'
        };
      } else {
        ReactPropTypeLocationNames = {};
      }
      function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
        /**
         * Policies that describe methods in `ReactClassInterface`.
         */

        var injectedMixins = [];

        /**
         * Composite components are higher-level components that compose other composite
         * or host components.
         *
         * To create a new type of `ReactClass`, pass a specification of
         * your new class to `React.createClass`. The only requirement of your class
         * specification is that you implement a `render` method.
         *
         *   var MyComponent = React.createClass({
         *     render: function() {
         *       return <div>Hello World</div>;
         *     }
         *   });
         *
         * The class specification supports a specific protocol of methods that have
         * special meaning (e.g. `render`). See `ReactClassInterface` for
         * more the comprehensive protocol. Any other properties and methods in the
         * class specification will be available on the prototype.
         *
         * @interface ReactClassInterface
         * @internal
         */
        var ReactClassInterface = {
          /**
           * An array of Mixin objects to include when defining your component.
           *
           * @type {array}
           * @optional
           */
          mixins: 'DEFINE_MANY',
          /**
           * An object containing properties and methods that should be defined on
           * the component's constructor instead of its prototype (static methods).
           *
           * @type {object}
           * @optional
           */
          statics: 'DEFINE_MANY',
          /**
           * Definition of prop types for this component.
           *
           * @type {object}
           * @optional
           */
          propTypes: 'DEFINE_MANY',
          /**
           * Definition of context types for this component.
           *
           * @type {object}
           * @optional
           */
          contextTypes: 'DEFINE_MANY',
          /**
           * Definition of context types this component sets for its children.
           *
           * @type {object}
           * @optional
           */
          childContextTypes: 'DEFINE_MANY',
          // ==== Definition methods ====

          /**
           * Invoked when the component is mounted. Values in the mapping will be set on
           * `this.props` if that prop is not specified (i.e. using an `in` check).
           *
           * This method is invoked before `getInitialState` and therefore cannot rely
           * on `this.state` or use `this.setState`.
           *
           * @return {object}
           * @optional
           */
          getDefaultProps: 'DEFINE_MANY_MERGED',
          /**
           * Invoked once before the component is mounted. The return value will be used
           * as the initial value of `this.state`.
           *
           *   getInitialState: function() {
           *     return {
           *       isOn: false,
           *       fooBaz: new BazFoo()
           *     }
           *   }
           *
           * @return {object}
           * @optional
           */
          getInitialState: 'DEFINE_MANY_MERGED',
          /**
           * @return {object}
           * @optional
           */
          getChildContext: 'DEFINE_MANY_MERGED',
          /**
           * Uses props from `this.props` and state from `this.state` to render the
           * structure of the component.
           *
           * No guarantees are made about when or how often this method is invoked, so
           * it must not have side effects.
           *
           *   render: function() {
           *     var name = this.props.name;
           *     return <div>Hello, {name}!</div>;
           *   }
           *
           * @return {ReactComponent}
           * @required
           */
          render: 'DEFINE_ONCE',
          // ==== Delegate methods ====

          /**
           * Invoked when the component is initially created and about to be mounted.
           * This may have side effects, but any external subscriptions or data created
           * by this method must be cleaned up in `componentWillUnmount`.
           *
           * @optional
           */
          componentWillMount: 'DEFINE_MANY',
          /**
           * Invoked when the component has been mounted and has a DOM representation.
           * However, there is no guarantee that the DOM node is in the document.
           *
           * Use this as an opportunity to operate on the DOM when the component has
           * been mounted (initialized and rendered) for the first time.
           *
           * @param {DOMElement} rootNode DOM element representing the component.
           * @optional
           */
          componentDidMount: 'DEFINE_MANY',
          /**
           * Invoked before the component receives new props.
           *
           * Use this as an opportunity to react to a prop transition by updating the
           * state using `this.setState`. Current props are accessed via `this.props`.
           *
           *   componentWillReceiveProps: function(nextProps, nextContext) {
           *     this.setState({
           *       likesIncreasing: nextProps.likeCount > this.props.likeCount
           *     });
           *   }
           *
           * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
           * transition may cause a state change, but the opposite is not true. If you
           * need it, you are probably looking for `componentWillUpdate`.
           *
           * @param {object} nextProps
           * @optional
           */
          componentWillReceiveProps: 'DEFINE_MANY',
          /**
           * Invoked while deciding if the component should be updated as a result of
           * receiving new props, state and/or context.
           *
           * Use this as an opportunity to `return false` when you're certain that the
           * transition to the new props/state/context will not require a component
           * update.
           *
           *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
           *     return !equal(nextProps, this.props) ||
           *       !equal(nextState, this.state) ||
           *       !equal(nextContext, this.context);
           *   }
           *
           * @param {object} nextProps
           * @param {?object} nextState
           * @param {?object} nextContext
           * @return {boolean} True if the component should update.
           * @optional
           */
          shouldComponentUpdate: 'DEFINE_ONCE',
          /**
           * Invoked when the component is about to update due to a transition from
           * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
           * and `nextContext`.
           *
           * Use this as an opportunity to perform preparation before an update occurs.
           *
           * NOTE: You **cannot** use `this.setState()` in this method.
           *
           * @param {object} nextProps
           * @param {?object} nextState
           * @param {?object} nextContext
           * @param {ReactReconcileTransaction} transaction
           * @optional
           */
          componentWillUpdate: 'DEFINE_MANY',
          /**
           * Invoked when the component's DOM representation has been updated.
           *
           * Use this as an opportunity to operate on the DOM when the component has
           * been updated.
           *
           * @param {object} prevProps
           * @param {?object} prevState
           * @param {?object} prevContext
           * @param {DOMElement} rootNode DOM element representing the component.
           * @optional
           */
          componentDidUpdate: 'DEFINE_MANY',
          /**
           * Invoked when the component is about to be removed from its parent and have
           * its DOM representation destroyed.
           *
           * Use this as an opportunity to deallocate any external resources.
           *
           * NOTE: There is no `componentDidUnmount` since your component will have been
           * destroyed by that point.
           *
           * @optional
           */
          componentWillUnmount: 'DEFINE_MANY',
          /**
           * Replacement for (deprecated) `componentWillMount`.
           *
           * @optional
           */
          UNSAFE_componentWillMount: 'DEFINE_MANY',
          /**
           * Replacement for (deprecated) `componentWillReceiveProps`.
           *
           * @optional
           */
          UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',
          /**
           * Replacement for (deprecated) `componentWillUpdate`.
           *
           * @optional
           */
          UNSAFE_componentWillUpdate: 'DEFINE_MANY',
          // ==== Advanced methods ====

          /**
           * Updates the component's currently mounted DOM representation.
           *
           * By default, this implements React's rendering and reconciliation algorithm.
           * Sophisticated clients may wish to override this.
           *
           * @param {ReactReconcileTransaction} transaction
           * @internal
           * @overridable
           */
          updateComponent: 'OVERRIDE_BASE'
        };

        /**
         * Similar to ReactClassInterface but for static methods.
         */
        var ReactClassStaticInterface = {
          /**
           * This method is invoked after a component is instantiated and when it
           * receives new props. Return an object to update state in response to
           * prop changes. Return null to indicate no change to state.
           *
           * If an object is returned, its keys will be merged into the existing state.
           *
           * @return {object || null}
           * @optional
           */
          getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
        };

        /**
         * Mapping from class specification keys to special processing functions.
         *
         * Although these are declared like instance properties in the specification
         * when defining classes using `React.createClass`, they are actually static
         * and are accessible on the constructor instead of the prototype. Despite
         * being static, they must be defined outside of the "statics" key under
         * which all other static methods are defined.
         */
        var RESERVED_SPEC_KEYS = {
          displayName: function (Constructor, displayName) {
            Constructor.displayName = displayName;
          },
          mixins: function (Constructor, mixins) {
            if (mixins) {
              for (var i = 0; i < mixins.length; i++) {
                mixSpecIntoComponent(Constructor, mixins[i]);
              }
            }
          },
          childContextTypes: function (Constructor, childContextTypes) {
            if (process.env.NODE_ENV !== 'production') {
              validateTypeDef(Constructor, childContextTypes, 'childContext');
            }
            Constructor.childContextTypes = _assign({}, Constructor.childContextTypes, childContextTypes);
          },
          contextTypes: function (Constructor, contextTypes) {
            if (process.env.NODE_ENV !== 'production') {
              validateTypeDef(Constructor, contextTypes, 'context');
            }
            Constructor.contextTypes = _assign({}, Constructor.contextTypes, contextTypes);
          },
          /**
           * Special case getDefaultProps which should move into statics but requires
           * automatic merging.
           */
          getDefaultProps: function (Constructor, getDefaultProps) {
            if (Constructor.getDefaultProps) {
              Constructor.getDefaultProps = createMergedResultFunction(Constructor.getDefaultProps, getDefaultProps);
            } else {
              Constructor.getDefaultProps = getDefaultProps;
            }
          },
          propTypes: function (Constructor, propTypes) {
            if (process.env.NODE_ENV !== 'production') {
              validateTypeDef(Constructor, propTypes, 'prop');
            }
            Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
          },
          statics: function (Constructor, statics) {
            mixStaticSpecIntoComponent(Constructor, statics);
          },
          autobind: function () {}
        };
        function validateTypeDef(Constructor, typeDef, location) {
          for (var propName in typeDef) {
            if (typeDef.hasOwnProperty(propName)) {
              // use a warning instead of an _invariant so components
              // don't show up in prod but only in __DEV__
              if (process.env.NODE_ENV !== 'production') {
                warning(typeof typeDef[propName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', Constructor.displayName || 'ReactClass', ReactPropTypeLocationNames[location], propName);
              }
            }
          }
        }
        function validateMethodOverride(isAlreadyDefined, name) {
          var specPolicy = ReactClassInterface.hasOwnProperty(name) ? ReactClassInterface[name] : null;

          // Disallow overriding of base class methods unless explicitly allowed.
          if (ReactClassMixin.hasOwnProperty(name)) {
            _invariant(specPolicy === 'OVERRIDE_BASE', 'ReactClassInterface: You are attempting to override ' + '`%s` from your class specification. Ensure that your method names ' + 'do not overlap with React methods.', name);
          }

          // Disallow defining methods more than once unless explicitly allowed.
          if (isAlreadyDefined) {
            _invariant(specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED', 'ReactClassInterface: You are attempting to define ' + '`%s` on your component more than once. This conflict may be due ' + 'to a mixin.', name);
          }
        }

        /**
         * Mixin helper which handles policy validation and reserved
         * specification keys when building React classes.
         */
        function mixSpecIntoComponent(Constructor, spec) {
          if (!spec) {
            if (process.env.NODE_ENV !== 'production') {
              var typeofSpec = typeof spec;
              var isMixinValid = typeofSpec === 'object' && spec !== null;
              if (process.env.NODE_ENV !== 'production') {
                warning(isMixinValid, "%s: You're attempting to include a mixin that is either null " + 'or not an object. Check the mixins included by the component, ' + 'as well as any mixins they include themselves. ' + 'Expected object but got %s.', Constructor.displayName || 'ReactClass', spec === null ? null : typeofSpec);
              }
            }
            return;
          }
          _invariant(typeof spec !== 'function', "ReactClass: You're attempting to " + 'use a component class or function as a mixin. Instead, just use a ' + 'regular object.');
          _invariant(!isValidElement(spec), "ReactClass: You're attempting to " + 'use a component as a mixin. Instead, just use a regular object.');
          var proto = Constructor.prototype;
          var autoBindPairs = proto.__reactAutoBindPairs;

          // By handling mixins before any other properties, we ensure the same
          // chaining order is applied to methods with DEFINE_MANY policy, whether
          // mixins are listed before or after these methods in the spec.
          if (spec.hasOwnProperty(MIXINS_KEY)) {
            RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
          }
          for (var name in spec) {
            if (!spec.hasOwnProperty(name)) {
              continue;
            }
            if (name === MIXINS_KEY) {
              // We have already handled mixins in a special case above.
              continue;
            }
            var property = spec[name];
            var isAlreadyDefined = proto.hasOwnProperty(name);
            validateMethodOverride(isAlreadyDefined, name);
            if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
              RESERVED_SPEC_KEYS[name](Constructor, property);
            } else {
              // Setup methods on prototype:
              // The following member methods should not be automatically bound:
              // 1. Expected ReactClass methods (in the "interface").
              // 2. Overridden methods (that were mixed in).
              var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
              var isFunction = typeof property === 'function';
              var shouldAutoBind = isFunction && !isReactClassMethod && !isAlreadyDefined && spec.autobind !== false;
              if (shouldAutoBind) {
                autoBindPairs.push(name, property);
                proto[name] = property;
              } else {
                if (isAlreadyDefined) {
                  var specPolicy = ReactClassInterface[name];

                  // These cases should already be caught by validateMethodOverride.
                  _invariant(isReactClassMethod && (specPolicy === 'DEFINE_MANY_MERGED' || specPolicy === 'DEFINE_MANY'), 'ReactClass: Unexpected spec policy %s for key %s ' + 'when mixing in component specs.', specPolicy, name);

                  // For methods which are defined more than once, call the existing
                  // methods before calling the new property, merging if appropriate.
                  if (specPolicy === 'DEFINE_MANY_MERGED') {
                    proto[name] = createMergedResultFunction(proto[name], property);
                  } else if (specPolicy === 'DEFINE_MANY') {
                    proto[name] = createChainedFunction(proto[name], property);
                  }
                } else {
                  proto[name] = property;
                  if (process.env.NODE_ENV !== 'production') {
                    // Add verbose displayName to the function, which helps when looking
                    // at profiling tools.
                    if (typeof property === 'function' && spec.displayName) {
                      proto[name].displayName = spec.displayName + '_' + name;
                    }
                  }
                }
              }
            }
          }
        }
        function mixStaticSpecIntoComponent(Constructor, statics) {
          if (!statics) {
            return;
          }
          for (var name in statics) {
            var property = statics[name];
            if (!statics.hasOwnProperty(name)) {
              continue;
            }
            var isReserved = name in RESERVED_SPEC_KEYS;
            _invariant(!isReserved, 'ReactClass: You are attempting to define a reserved ' + 'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' + 'as an instance property instead; it will still be accessible on the ' + 'constructor.', name);
            var isAlreadyDefined = name in Constructor;
            if (isAlreadyDefined) {
              var specPolicy = ReactClassStaticInterface.hasOwnProperty(name) ? ReactClassStaticInterface[name] : null;
              _invariant(specPolicy === 'DEFINE_MANY_MERGED', 'ReactClass: You are attempting to define ' + '`%s` on your component more than once. This conflict may be ' + 'due to a mixin.', name);
              Constructor[name] = createMergedResultFunction(Constructor[name], property);
              return;
            }
            Constructor[name] = property;
          }
        }

        /**
         * Merge two objects, but throw if both contain the same key.
         *
         * @param {object} one The first object, which is mutated.
         * @param {object} two The second object
         * @return {object} one after it has been mutated to contain everything in two.
         */
        function mergeIntoWithNoDuplicateKeys(one, two) {
          _invariant(one && two && typeof one === 'object' && typeof two === 'object', 'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.');
          for (var key in two) {
            if (two.hasOwnProperty(key)) {
              _invariant(one[key] === undefined, 'mergeIntoWithNoDuplicateKeys(): ' + 'Tried to merge two objects with the same key: `%s`. This conflict ' + 'may be due to a mixin; in particular, this may be caused by two ' + 'getInitialState() or getDefaultProps() methods returning objects ' + 'with clashing keys.', key);
              one[key] = two[key];
            }
          }
          return one;
        }

        /**
         * Creates a function that invokes two functions and merges their return values.
         *
         * @param {function} one Function to invoke first.
         * @param {function} two Function to invoke second.
         * @return {function} Function that invokes the two argument functions.
         * @private
         */
        function createMergedResultFunction(one, two) {
          return function mergedResult() {
            var a = one.apply(this, arguments);
            var b = two.apply(this, arguments);
            if (a == null) {
              return b;
            } else if (b == null) {
              return a;
            }
            var c = {};
            mergeIntoWithNoDuplicateKeys(c, a);
            mergeIntoWithNoDuplicateKeys(c, b);
            return c;
          };
        }

        /**
         * Creates a function that invokes two functions and ignores their return vales.
         *
         * @param {function} one Function to invoke first.
         * @param {function} two Function to invoke second.
         * @return {function} Function that invokes the two argument functions.
         * @private
         */
        function createChainedFunction(one, two) {
          return function chainedFunction() {
            one.apply(this, arguments);
            two.apply(this, arguments);
          };
        }

        /**
         * Binds a method to the component.
         *
         * @param {object} component Component whose method is going to be bound.
         * @param {function} method Method to be bound.
         * @return {function} The bound method.
         */
        function bindAutoBindMethod(component, method) {
          var boundMethod = method.bind(component);
          if (process.env.NODE_ENV !== 'production') {
            boundMethod.__reactBoundContext = component;
            boundMethod.__reactBoundMethod = method;
            boundMethod.__reactBoundArguments = null;
            var componentName = component.constructor.displayName;
            var _bind = boundMethod.bind;
            boundMethod.bind = function (newThis) {
              for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                args[_key - 1] = arguments[_key];
              }

              // User is trying to bind() an autobound method; we effectively will
              // ignore the value of "this" that the user is trying to use, so
              // let's warn.
              if (newThis !== component && newThis !== null) {
                if (process.env.NODE_ENV !== 'production') {
                  warning(false, 'bind(): React component methods may only be bound to the ' + 'component instance. See %s', componentName);
                }
              } else if (!args.length) {
                if (process.env.NODE_ENV !== 'production') {
                  warning(false, 'bind(): You are binding a component method to the component. ' + 'React does this for you automatically in a high-performance ' + 'way, so you can safely remove this call. See %s', componentName);
                }
                return boundMethod;
              }
              var reboundMethod = _bind.apply(boundMethod, arguments);
              reboundMethod.__reactBoundContext = component;
              reboundMethod.__reactBoundMethod = method;
              reboundMethod.__reactBoundArguments = args;
              return reboundMethod;
            };
          }
          return boundMethod;
        }

        /**
         * Binds all auto-bound methods in a component.
         *
         * @param {object} component Component whose method is going to be bound.
         */
        function bindAutoBindMethods(component) {
          var pairs = component.__reactAutoBindPairs;
          for (var i = 0; i < pairs.length; i += 2) {
            var autoBindKey = pairs[i];
            var method = pairs[i + 1];
            component[autoBindKey] = bindAutoBindMethod(component, method);
          }
        }
        var IsMountedPreMixin = {
          componentDidMount: function () {
            this.__isMounted = true;
          }
        };
        var IsMountedPostMixin = {
          componentWillUnmount: function () {
            this.__isMounted = false;
          }
        };

        /**
         * Add more to the ReactClass base class. These are all legacy features and
         * therefore not already part of the modern ReactComponent.
         */
        var ReactClassMixin = {
          /**
           * TODO: This will be deprecated because state should always keep a consistent
           * type signature and the only use case for this, is to avoid that.
           */
          replaceState: function (newState, callback) {
            this.updater.enqueueReplaceState(this, newState, callback);
          },
          /**
           * Checks whether or not this composite component is mounted.
           * @return {boolean} True if mounted, false otherwise.
           * @protected
           * @final
           */
          isMounted: function () {
            if (process.env.NODE_ENV !== 'production') {
              warning(this.__didWarnIsMounted, '%s: isMounted is deprecated. Instead, make sure to clean up ' + 'subscriptions and pending requests in componentWillUnmount to ' + 'prevent memory leaks.', this.constructor && this.constructor.displayName || this.name || 'Component');
              this.__didWarnIsMounted = true;
            }
            return !!this.__isMounted;
          }
        };
        var ReactClassComponent = function () {};
        _assign(ReactClassComponent.prototype, ReactComponent.prototype, ReactClassMixin);

        /**
         * Creates a composite component class given a class specification.
         * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
         *
         * @param {object} spec Class specification (which must define `render`).
         * @return {function} Component constructor function.
         * @public
         */
        function createClass(spec) {
          // To keep our warnings more understandable, we'll use a little hack here to
          // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
          // unnecessarily identify a class without displayName as 'Constructor'.
          var Constructor = identity(function (props, context, updater) {
            // This constructor gets overridden by mocks. The argument is used
            // by mocks to assert on what gets mounted.

            if (process.env.NODE_ENV !== 'production') {
              warning(this instanceof Constructor, 'Something is calling a React component directly. Use a factory or ' + 'JSX instead. See: https://fb.me/react-legacyfactory');
            }

            // Wire up auto-binding
            if (this.__reactAutoBindPairs.length) {
              bindAutoBindMethods(this);
            }
            this.props = props;
            this.context = context;
            this.refs = emptyObject;
            this.updater = updater || ReactNoopUpdateQueue;
            this.state = null;

            // ReactClasses doesn't have constructors. Instead, they use the
            // getInitialState and componentWillMount methods for initialization.

            var initialState = this.getInitialState ? this.getInitialState() : null;
            if (process.env.NODE_ENV !== 'production') {
              // We allow auto-mocks to proceed as if they're returning null.
              if (initialState === undefined && this.getInitialState._isMockFunction) {
                // This is probably bad practice. Consider warning here and
                // deprecating this convenience.
                initialState = null;
              }
            }
            _invariant(typeof initialState === 'object' && !Array.isArray(initialState), '%s.getInitialState(): must return an object or null', Constructor.displayName || 'ReactCompositeComponent');
            this.state = initialState;
          });
          Constructor.prototype = new ReactClassComponent();
          Constructor.prototype.constructor = Constructor;
          Constructor.prototype.__reactAutoBindPairs = [];
          injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
          mixSpecIntoComponent(Constructor, IsMountedPreMixin);
          mixSpecIntoComponent(Constructor, spec);
          mixSpecIntoComponent(Constructor, IsMountedPostMixin);

          // Initialize the defaultProps property after all mixins have been merged.
          if (Constructor.getDefaultProps) {
            Constructor.defaultProps = Constructor.getDefaultProps();
          }
          if (process.env.NODE_ENV !== 'production') {
            // This is a tag to indicate that the use of these method names is ok,
            // since it's used with createClass. If it's not, then it's likely a
            // mistake so we'll warn you to use the static property, property
            // initializer or constructor respectively.
            if (Constructor.getDefaultProps) {
              Constructor.getDefaultProps.isReactClassApproved = {};
            }
            if (Constructor.prototype.getInitialState) {
              Constructor.prototype.getInitialState.isReactClassApproved = {};
            }
          }
          _invariant(Constructor.prototype.render, 'createClass(...): Class specification must implement a `render` method.');
          if (process.env.NODE_ENV !== 'production') {
            warning(!Constructor.prototype.componentShouldUpdate, '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', spec.displayName || 'A component');
            warning(!Constructor.prototype.componentWillRecieveProps, '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', spec.displayName || 'A component');
            warning(!Constructor.prototype.UNSAFE_componentWillRecieveProps, '%s has a method called UNSAFE_componentWillRecieveProps(). ' + 'Did you mean UNSAFE_componentWillReceiveProps()?', spec.displayName || 'A component');
          }

          // Reduce time spent doing lookups by setting these on the prototype.
          for (var methodName in ReactClassInterface) {
            if (!Constructor.prototype[methodName]) {
              Constructor.prototype[methodName] = null;
            }
          }
          return Constructor;
        }
        return createClass;
      }
      module.exports = factory;

      /* WEBPACK VAR INJECTION */
    }).call(exports, __nested_webpack_require_19372__(4));

    /***/
  }), (/* 4 */
  /***/function (module, exports) {
    // shim for using process in browser
    var process = module.exports = {};

    // cached from whatever global is present so that test runners that stub it
    // don't break things.  But we need to wrap it in a try catch in case it is
    // wrapped in strict mode code which doesn't define any globals.  It's inside a
    // function because try/catches deoptimize in certain engines.

    var cachedSetTimeout;
    var cachedClearTimeout;
    function defaultSetTimout() {
      throw new Error('setTimeout has not been defined');
    }
    function defaultClearTimeout() {
      throw new Error('clearTimeout has not been defined');
    }
    (function () {
      try {
        if (typeof setTimeout === 'function') {
          cachedSetTimeout = setTimeout;
        } else {
          cachedSetTimeout = defaultSetTimout;
        }
      } catch (e) {
        cachedSetTimeout = defaultSetTimout;
      }
      try {
        if (typeof clearTimeout === 'function') {
          cachedClearTimeout = clearTimeout;
        } else {
          cachedClearTimeout = defaultClearTimeout;
        }
      } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
      }
    })();
    function runTimeout(fun) {
      if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
      }
      // if setTimeout wasn't available but was latter defined
      if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
      }
      try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
      } catch (e) {
        try {
          // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
          return cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
          // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
          return cachedSetTimeout.call(this, fun, 0);
        }
      }
    }
    function runClearTimeout(marker) {
      if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
      }
      // if clearTimeout wasn't available but was latter defined
      if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
      }
      try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
      } catch (e) {
        try {
          // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
          return cachedClearTimeout.call(null, marker);
        } catch (e) {
          // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
          // Some versions of I.E. have different rules for clearTimeout vs setTimeout
          return cachedClearTimeout.call(this, marker);
        }
      }
    }
    var queue = [];
    var draining = false;
    var currentQueue;
    var queueIndex = -1;
    function cleanUpNextTick() {
      if (!draining || !currentQueue) {
        return;
      }
      draining = false;
      if (currentQueue.length) {
        queue = currentQueue.concat(queue);
      } else {
        queueIndex = -1;
      }
      if (queue.length) {
        drainQueue();
      }
    }
    function drainQueue() {
      if (draining) {
        return;
      }
      var timeout = runTimeout(cleanUpNextTick);
      draining = true;
      var len = queue.length;
      while (len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
          if (currentQueue) {
            currentQueue[queueIndex].run();
          }
        }
        queueIndex = -1;
        len = queue.length;
      }
      currentQueue = null;
      draining = false;
      runClearTimeout(timeout);
    }
    process.nextTick = function (fun) {
      var args = new Array(arguments.length - 1);
      if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
          args[i - 1] = arguments[i];
        }
      }
      queue.push(new Item(fun, args));
      if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
      }
    };

    // v8 likes predictible objects
    function Item(fun, array) {
      this.fun = fun;
      this.array = array;
    }
    Item.prototype.run = function () {
      this.fun.apply(null, this.array);
    };
    process.title = 'browser';
    process.browser = true;
    process.env = {};
    process.argv = [];
    process.version = ''; // empty string to avoid regexp issues
    process.versions = {};
    function noop() {}
    process.on = noop;
    process.addListener = noop;
    process.once = noop;
    process.off = noop;
    process.removeListener = noop;
    process.removeAllListeners = noop;
    process.emit = noop;
    process.prependListener = noop;
    process.prependOnceListener = noop;
    process.listeners = function (name) {
      return [];
    };
    process.binding = function (name) {
      throw new Error('process.binding is not supported');
    };
    process.cwd = function () {
      return '/';
    };
    process.chdir = function (dir) {
      throw new Error('process.chdir is not supported');
    };
    process.umask = function () {
      return 0;
    };

    /***/
  }), (/* 5 */
  /***/function (module, exports) {
    /*
    object-assign
    (c) Sindre Sorhus
    @license MIT
    */

    'use strict';

    /* eslint-disable no-unused-vars */
    var getOwnPropertySymbols = Object.getOwnPropertySymbols;
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    var propIsEnumerable = Object.prototype.propertyIsEnumerable;
    function toObject(val) {
      if (val === null || val === undefined) {
        throw new TypeError('Object.assign cannot be called with null or undefined');
      }
      return Object(val);
    }
    function shouldUseNative() {
      try {
        if (!Object.assign) {
          return false;
        }

        // Detect buggy property enumeration order in older V8 versions.

        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
        test1[5] = 'de';
        if (Object.getOwnPropertyNames(test1)[0] === '5') {
          return false;
        }

        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for (var i = 0; i < 10; i++) {
          test2['_' + String.fromCharCode(i)] = i;
        }
        var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
          return test2[n];
        });
        if (order2.join('') !== '0123456789') {
          return false;
        }

        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
          test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
          return false;
        }
        return true;
      } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
      }
    }
    module.exports = shouldUseNative() ? Object.assign : function (target, source) {
      var from;
      var to = toObject(target);
      var symbols;
      for (var s = 1; s < arguments.length; s++) {
        from = Object(arguments[s]);
        for (var key in from) {
          if (hasOwnProperty.call(from, key)) {
            to[key] = from[key];
          }
        }
        if (getOwnPropertySymbols) {
          symbols = getOwnPropertySymbols(from);
          for (var i = 0; i < symbols.length; i++) {
            if (propIsEnumerable.call(from, symbols[i])) {
              to[symbols[i]] = from[symbols[i]];
            }
          }
        }
      }
      return to;
    };

    /***/
  }), (/* 6 */
  /***/function (module, exports, __nested_webpack_require_60403__) {
    /* WEBPACK VAR INJECTION */(function (process) {
      /**
      * Copyright (c) 2013-present, Facebook, Inc.
      *
      * This source code is licensed under the MIT license found in the
      * LICENSE file in the root directory of this source tree.
      *
      */

      'use strict';

      var emptyObject = {};
      if (process.env.NODE_ENV !== 'production') {
        Object.freeze(emptyObject);
      }
      module.exports = emptyObject;
      /* WEBPACK VAR INJECTION */
    }).call(exports, __nested_webpack_require_60403__(4));

    /***/
  }), (/* 7 */
  /***/function (module, exports, __nested_webpack_require_61022__) {
    /* WEBPACK VAR INJECTION */(function (process) {
      /**
      * Copyright (c) 2013-present, Facebook, Inc.
      *
      * This source code is licensed under the MIT license found in the
      * LICENSE file in the root directory of this source tree.
      *
      */

      'use strict';

      /**
       * Use invariant() to assert state which your program assumes to be true.
       *
       * Provide sprintf-style format (only %s is supported) and arguments
       * to provide information about what broke and what you were
       * expecting.
       *
       * The invariant message will be stripped in production, but the invariant
       * will remain to ensure logic does not differ in production.
       */
      var validateFormat = function validateFormat(format) {};
      if (process.env.NODE_ENV !== 'production') {
        validateFormat = function validateFormat(format) {
          if (format === undefined) {
            throw new Error('invariant requires an error message argument');
          }
        };
      }
      function invariant(condition, format, a, b, c, d, e, f) {
        validateFormat(format);
        if (!condition) {
          var error;
          if (format === undefined) {
            error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
          } else {
            var args = [a, b, c, d, e, f];
            var argIndex = 0;
            error = new Error(format.replace(/%s/g, function () {
              return args[argIndex++];
            }));
            error.name = 'Invariant Violation';
          }
          error.framesToPop = 1; // we don't care about invariant's own frame
          throw error;
        }
      }
      module.exports = invariant;
      /* WEBPACK VAR INJECTION */
    }).call(exports, __nested_webpack_require_61022__(4));

    /***/
  }), (/* 8 */
  /***/function (module, exports, __nested_webpack_require_63003__) {
    /* WEBPACK VAR INJECTION */(function (process) {
      /**
      * Copyright (c) 2014-present, Facebook, Inc.
      *
      * This source code is licensed under the MIT license found in the
      * LICENSE file in the root directory of this source tree.
      *
      */

      'use strict';

      var emptyFunction = __nested_webpack_require_63003__(9);

      /**
       * Similar to invariant but only logs a warning if the condition is not met.
       * This can be used to log issues in development environments in critical
       * paths. Removing the logging code for production environments will keep the
       * same logic and follow the same code paths.
       */

      var warning = emptyFunction;
      if (process.env.NODE_ENV !== 'production') {
        var printWarning = function printWarning(format) {
          for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            args[_key - 1] = arguments[_key];
          }
          var argIndex = 0;
          var message = 'Warning: ' + format.replace(/%s/g, function () {
            return args[argIndex++];
          });
          if (typeof console !== 'undefined') {
            console.error(message);
          }
          try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
          } catch (x) {}
        };
        warning = function warning(condition, format) {
          if (format === undefined) {
            throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
          }
          if (format.indexOf('Failed Composite propType: ') === 0) {
            return; // Ignore CompositeComponent proptype check.
          }
          if (!condition) {
            for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
              args[_key2 - 2] = arguments[_key2];
            }
            printWarning.apply(undefined, [format].concat(args));
          }
        };
      }
      module.exports = warning;
      /* WEBPACK VAR INJECTION */
    }).call(exports, __nested_webpack_require_63003__(4));

    /***/
  }), (/* 9 */
  /***/function (module, exports) {
    "use strict";

    /**
     * Copyright (c) 2013-present, Facebook, Inc.
     *
     * This source code is licensed under the MIT license found in the
     * LICENSE file in the root directory of this source tree.
     *
     * 
     */
    function makeEmptyFunction(arg) {
      return function () {
        return arg;
      };
    }

    /**
     * This function accepts and discards inputs; it has no side effects. This is
     * primarily useful idiomatically for overridable function endpoints which
     * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
     */
    var emptyFunction = function emptyFunction() {};
    emptyFunction.thatReturns = makeEmptyFunction;
    emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
    emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
    emptyFunction.thatReturnsNull = makeEmptyFunction(null);
    emptyFunction.thatReturnsThis = function () {
      return this;
    };
    emptyFunction.thatReturnsArgument = function (arg) {
      return arg;
    };
    module.exports = emptyFunction;

    /***/
  }), (/* 10 */
  /***/function (module, exports) {
    'use strict';

    var NumeralFormatter = function NumeralFormatter(numeralDecimalMark, numeralIntegerScale, numeralDecimalScale, numeralThousandsGroupStyle, numeralPositiveOnly, stripLeadingZeroes, prefix, signBeforePrefix, tailPrefix, delimiter) {
      var owner = this;
      owner.numeralDecimalMark = numeralDecimalMark || '.';
      owner.numeralIntegerScale = numeralIntegerScale > 0 ? numeralIntegerScale : 0;
      owner.numeralDecimalScale = numeralDecimalScale >= 0 ? numeralDecimalScale : 2;
      owner.numeralThousandsGroupStyle = numeralThousandsGroupStyle || NumeralFormatter.groupStyle.thousand;
      owner.numeralPositiveOnly = !!numeralPositiveOnly;
      owner.stripLeadingZeroes = stripLeadingZeroes !== false;
      owner.prefix = prefix || prefix === '' ? prefix : '';
      owner.signBeforePrefix = !!signBeforePrefix;
      owner.tailPrefix = !!tailPrefix;
      owner.delimiter = delimiter || delimiter === '' ? delimiter : ',';
      owner.delimiterRE = delimiter ? new RegExp('\\' + delimiter, 'g') : '';
    };
    NumeralFormatter.groupStyle = {
      thousand: 'thousand',
      lakh: 'lakh',
      wan: 'wan',
      none: 'none'
    };
    NumeralFormatter.prototype = {
      getRawValue: function getRawValue(value) {
        return value.replace(this.delimiterRE, '').replace(this.numeralDecimalMark, '.');
      },
      format: function format(value) {
        var owner = this,
          parts,
          partSign,
          partSignAndPrefix,
          partInteger,
          partDecimal = '';

        // strip alphabet letters
        value = value.replace(/[A-Za-z]/g, '')
        // replace the first decimal mark with reserved placeholder
        .replace(owner.numeralDecimalMark, 'M')

        // strip non numeric letters except minus and "M"
        // this is to ensure prefix has been stripped
        .replace(/[^\dM-]/g, '')

        // replace the leading minus with reserved placeholder
        .replace(/^\-/, 'N')

        // strip the other minus sign (if present)
        .replace(/\-/g, '')

        // replace the minus sign (if present)
        .replace('N', owner.numeralPositiveOnly ? '' : '-')

        // replace decimal mark
        .replace('M', owner.numeralDecimalMark);

        // strip any leading zeros
        if (owner.stripLeadingZeroes) {
          value = value.replace(/^(-)?0+(?=\d)/, '$1');
        }
        partSign = value.slice(0, 1) === '-' ? '-' : '';
        if (typeof owner.prefix != 'undefined') {
          if (owner.signBeforePrefix) {
            partSignAndPrefix = partSign + owner.prefix;
          } else {
            partSignAndPrefix = owner.prefix + partSign;
          }
        } else {
          partSignAndPrefix = partSign;
        }
        partInteger = value;
        if (value.indexOf(owner.numeralDecimalMark) >= 0) {
          parts = value.split(owner.numeralDecimalMark);
          partInteger = parts[0];
          partDecimal = owner.numeralDecimalMark + parts[1].slice(0, owner.numeralDecimalScale);
        }
        if (partSign === '-') {
          partInteger = partInteger.slice(1);
        }
        if (owner.numeralIntegerScale > 0) {
          partInteger = partInteger.slice(0, owner.numeralIntegerScale);
        }
        switch (owner.numeralThousandsGroupStyle) {
          case NumeralFormatter.groupStyle.lakh:
            partInteger = partInteger.replace(/(\d)(?=(\d\d)+\d$)/g, '$1' + owner.delimiter);
            break;
          case NumeralFormatter.groupStyle.wan:
            partInteger = partInteger.replace(/(\d)(?=(\d{4})+$)/g, '$1' + owner.delimiter);
            break;
          case NumeralFormatter.groupStyle.thousand:
            partInteger = partInteger.replace(/(\d)(?=(\d{3})+$)/g, '$1' + owner.delimiter);
            break;
        }
        if (owner.tailPrefix) {
          return partSign + partInteger.toString() + (owner.numeralDecimalScale > 0 ? partDecimal.toString() : '') + owner.prefix;
        }
        return partSignAndPrefix + partInteger.toString() + (owner.numeralDecimalScale > 0 ? partDecimal.toString() : '');
      }
    };
    module.exports = NumeralFormatter;

    /***/
  }), (/* 11 */
  /***/function (module, exports) {
    'use strict';

    var DateFormatter = function DateFormatter(datePattern, dateMin, dateMax) {
      var owner = this;
      owner.date = [];
      owner.blocks = [];
      owner.datePattern = datePattern;
      owner.dateMin = dateMin.split('-').reverse().map(function (x) {
        return parseInt(x, 10);
      });
      if (owner.dateMin.length === 2) owner.dateMin.unshift(0);
      owner.dateMax = dateMax.split('-').reverse().map(function (x) {
        return parseInt(x, 10);
      });
      if (owner.dateMax.length === 2) owner.dateMax.unshift(0);
      owner.initBlocks();
    };
    DateFormatter.prototype = {
      initBlocks: function initBlocks() {
        var owner = this;
        owner.datePattern.forEach(function (value) {
          if (value === 'Y') {
            owner.blocks.push(4);
          } else {
            owner.blocks.push(2);
          }
        });
      },
      getISOFormatDate: function getISOFormatDate() {
        var owner = this,
          date = owner.date;
        return date[2] ? date[2] + '-' + owner.addLeadingZero(date[1]) + '-' + owner.addLeadingZero(date[0]) : '';
      },
      getBlocks: function getBlocks() {
        return this.blocks;
      },
      getValidatedDate: function getValidatedDate(value) {
        var owner = this,
          result = '';
        value = value.replace(/[^\d]/g, '');
        owner.blocks.forEach(function (length, index) {
          if (value.length > 0) {
            var sub = value.slice(0, length),
              sub0 = sub.slice(0, 1),
              rest = value.slice(length);
            switch (owner.datePattern[index]) {
              case 'd':
                if (sub === '00') {
                  sub = '01';
                } else if (parseInt(sub0, 10) > 3) {
                  sub = '0' + sub0;
                } else if (parseInt(sub, 10) > 31) {
                  sub = '31';
                }
                break;
              case 'm':
                if (sub === '00') {
                  sub = '01';
                } else if (parseInt(sub0, 10) > 1) {
                  sub = '0' + sub0;
                } else if (parseInt(sub, 10) > 12) {
                  sub = '12';
                }
                break;
            }
            result += sub;

            // update remaining string
            value = rest;
          }
        });
        return this.getFixedDateString(result);
      },
      getFixedDateString: function getFixedDateString(value) {
        var owner = this,
          datePattern = owner.datePattern,
          date = [],
          dayIndex = 0,
          monthIndex = 0,
          yearIndex = 0,
          dayStartIndex = 0,
          monthStartIndex = 0,
          yearStartIndex = 0,
          day,
          month,
          year,
          fullYearDone = false;

        // mm-dd || dd-mm
        if (value.length === 4 && datePattern[0].toLowerCase() !== 'y' && datePattern[1].toLowerCase() !== 'y') {
          dayStartIndex = datePattern[0] === 'd' ? 0 : 2;
          monthStartIndex = 2 - dayStartIndex;
          day = parseInt(value.slice(dayStartIndex, dayStartIndex + 2), 10);
          month = parseInt(value.slice(monthStartIndex, monthStartIndex + 2), 10);
          date = this.getFixedDate(day, month, 0);
        }

        // yyyy-mm-dd || yyyy-dd-mm || mm-dd-yyyy || dd-mm-yyyy || dd-yyyy-mm || mm-yyyy-dd
        if (value.length === 8) {
          datePattern.forEach(function (type, index) {
            switch (type) {
              case 'd':
                dayIndex = index;
                break;
              case 'm':
                monthIndex = index;
                break;
              default:
                yearIndex = index;
                break;
            }
          });
          yearStartIndex = yearIndex * 2;
          dayStartIndex = dayIndex <= yearIndex ? dayIndex * 2 : dayIndex * 2 + 2;
          monthStartIndex = monthIndex <= yearIndex ? monthIndex * 2 : monthIndex * 2 + 2;
          day = parseInt(value.slice(dayStartIndex, dayStartIndex + 2), 10);
          month = parseInt(value.slice(monthStartIndex, monthStartIndex + 2), 10);
          year = parseInt(value.slice(yearStartIndex, yearStartIndex + 4), 10);
          fullYearDone = value.slice(yearStartIndex, yearStartIndex + 4).length === 4;
          date = this.getFixedDate(day, month, year);
        }

        // mm-yy || yy-mm
        if (value.length === 4 && (datePattern[0] === 'y' || datePattern[1] === 'y')) {
          monthStartIndex = datePattern[0] === 'm' ? 0 : 2;
          yearStartIndex = 2 - monthStartIndex;
          month = parseInt(value.slice(monthStartIndex, monthStartIndex + 2), 10);
          year = parseInt(value.slice(yearStartIndex, yearStartIndex + 2), 10);
          fullYearDone = value.slice(yearStartIndex, yearStartIndex + 2).length === 2;
          date = [0, month, year];
        }

        // mm-yyyy || yyyy-mm
        if (value.length === 6 && (datePattern[0] === 'Y' || datePattern[1] === 'Y')) {
          monthStartIndex = datePattern[0] === 'm' ? 0 : 4;
          yearStartIndex = 2 - 0.5 * monthStartIndex;
          month = parseInt(value.slice(monthStartIndex, monthStartIndex + 2), 10);
          year = parseInt(value.slice(yearStartIndex, yearStartIndex + 4), 10);
          fullYearDone = value.slice(yearStartIndex, yearStartIndex + 4).length === 4;
          date = [0, month, year];
        }
        date = owner.getRangeFixedDate(date);
        owner.date = date;
        var result = date.length === 0 ? value : datePattern.reduce(function (previous, current) {
          switch (current) {
            case 'd':
              return previous + (date[0] === 0 ? '' : owner.addLeadingZero(date[0]));
            case 'm':
              return previous + (date[1] === 0 ? '' : owner.addLeadingZero(date[1]));
            case 'y':
              return previous + (fullYearDone ? owner.addLeadingZeroForYear(date[2], false) : '');
            case 'Y':
              return previous + (fullYearDone ? owner.addLeadingZeroForYear(date[2], true) : '');
          }
        }, '');
        return result;
      },
      getRangeFixedDate: function getRangeFixedDate(date) {
        var owner = this,
          datePattern = owner.datePattern,
          dateMin = owner.dateMin || [],
          dateMax = owner.dateMax || [];
        if (!date.length || dateMin.length < 3 && dateMax.length < 3) return date;
        if (datePattern.find(function (x) {
          return x.toLowerCase() === 'y';
        }) && date[2] === 0) return date;
        if (dateMax.length && (dateMax[2] < date[2] || dateMax[2] === date[2] && (dateMax[1] < date[1] || dateMax[1] === date[1] && dateMax[0] < date[0]))) return dateMax;
        if (dateMin.length && (dateMin[2] > date[2] || dateMin[2] === date[2] && (dateMin[1] > date[1] || dateMin[1] === date[1] && dateMin[0] > date[0]))) return dateMin;
        return date;
      },
      getFixedDate: function getFixedDate(day, month, year) {
        day = Math.min(day, 31);
        month = Math.min(month, 12);
        year = parseInt(year || 0, 10);
        if (month < 7 && month % 2 === 0 || month > 8 && month % 2 === 1) {
          day = Math.min(day, month === 2 ? this.isLeapYear(year) ? 29 : 28 : 30);
        }
        return [day, month, year];
      },
      isLeapYear: function isLeapYear(year) {
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
      },
      addLeadingZero: function addLeadingZero(number) {
        return (number < 10 ? '0' : '') + number;
      },
      addLeadingZeroForYear: function addLeadingZeroForYear(number, fullYearMode) {
        if (fullYearMode) {
          return (number < 10 ? '000' : number < 100 ? '00' : number < 1000 ? '0' : '') + number;
        }
        return (number < 10 ? '0' : '') + number;
      }
    };
    module.exports = DateFormatter;

    /***/
  }), (/* 12 */
  /***/function (module, exports) {
    'use strict';

    var TimeFormatter = function TimeFormatter(timePattern, timeFormat) {
      var owner = this;
      owner.time = [];
      owner.blocks = [];
      owner.timePattern = timePattern;
      owner.timeFormat = timeFormat;
      owner.initBlocks();
    };
    TimeFormatter.prototype = {
      initBlocks: function initBlocks() {
        var owner = this;
        owner.timePattern.forEach(function () {
          owner.blocks.push(2);
        });
      },
      getISOFormatTime: function getISOFormatTime() {
        var owner = this,
          time = owner.time;
        return time[2] ? owner.addLeadingZero(time[0]) + ':' + owner.addLeadingZero(time[1]) + ':' + owner.addLeadingZero(time[2]) : '';
      },
      getBlocks: function getBlocks() {
        return this.blocks;
      },
      getTimeFormatOptions: function getTimeFormatOptions() {
        var owner = this;
        if (String(owner.timeFormat) === '12') {
          return {
            maxHourFirstDigit: 1,
            maxHours: 12,
            maxMinutesFirstDigit: 5,
            maxMinutes: 60
          };
        }
        return {
          maxHourFirstDigit: 2,
          maxHours: 23,
          maxMinutesFirstDigit: 5,
          maxMinutes: 60
        };
      },
      getValidatedTime: function getValidatedTime(value) {
        var owner = this,
          result = '';
        value = value.replace(/[^\d]/g, '');
        var timeFormatOptions = owner.getTimeFormatOptions();
        owner.blocks.forEach(function (length, index) {
          if (value.length > 0) {
            var sub = value.slice(0, length),
              sub0 = sub.slice(0, 1),
              rest = value.slice(length);
            switch (owner.timePattern[index]) {
              case 'h':
                if (parseInt(sub0, 10) > timeFormatOptions.maxHourFirstDigit) {
                  sub = '0' + sub0;
                } else if (parseInt(sub, 10) > timeFormatOptions.maxHours) {
                  sub = timeFormatOptions.maxHours + '';
                }
                break;
              case 'm':
              case 's':
                if (parseInt(sub0, 10) > timeFormatOptions.maxMinutesFirstDigit) {
                  sub = '0' + sub0;
                } else if (parseInt(sub, 10) > timeFormatOptions.maxMinutes) {
                  sub = timeFormatOptions.maxMinutes + '';
                }
                break;
            }
            result += sub;

            // update remaining string
            value = rest;
          }
        });
        return this.getFixedTimeString(result);
      },
      getFixedTimeString: function getFixedTimeString(value) {
        var owner = this,
          timePattern = owner.timePattern,
          time = [],
          secondIndex = 0,
          minuteIndex = 0,
          hourIndex = 0,
          secondStartIndex = 0,
          minuteStartIndex = 0,
          hourStartIndex = 0,
          second,
          minute,
          hour;
        if (value.length === 6) {
          timePattern.forEach(function (type, index) {
            switch (type) {
              case 's':
                secondIndex = index * 2;
                break;
              case 'm':
                minuteIndex = index * 2;
                break;
              case 'h':
                hourIndex = index * 2;
                break;
            }
          });
          hourStartIndex = hourIndex;
          minuteStartIndex = minuteIndex;
          secondStartIndex = secondIndex;
          second = parseInt(value.slice(secondStartIndex, secondStartIndex + 2), 10);
          minute = parseInt(value.slice(minuteStartIndex, minuteStartIndex + 2), 10);
          hour = parseInt(value.slice(hourStartIndex, hourStartIndex + 2), 10);
          time = this.getFixedTime(hour, minute, second);
        }
        if (value.length === 4 && owner.timePattern.indexOf('s') < 0) {
          timePattern.forEach(function (type, index) {
            switch (type) {
              case 'm':
                minuteIndex = index * 2;
                break;
              case 'h':
                hourIndex = index * 2;
                break;
            }
          });
          hourStartIndex = hourIndex;
          minuteStartIndex = minuteIndex;
          second = 0;
          minute = parseInt(value.slice(minuteStartIndex, minuteStartIndex + 2), 10);
          hour = parseInt(value.slice(hourStartIndex, hourStartIndex + 2), 10);
          time = this.getFixedTime(hour, minute, second);
        }
        owner.time = time;
        return time.length === 0 ? value : timePattern.reduce(function (previous, current) {
          switch (current) {
            case 's':
              return previous + owner.addLeadingZero(time[2]);
            case 'm':
              return previous + owner.addLeadingZero(time[1]);
            case 'h':
              return previous + owner.addLeadingZero(time[0]);
          }
        }, '');
      },
      getFixedTime: function getFixedTime(hour, minute, second) {
        second = Math.min(parseInt(second || 0, 10), 60);
        minute = Math.min(minute, 60);
        hour = Math.min(hour, 60);
        return [hour, minute, second];
      },
      addLeadingZero: function addLeadingZero(number) {
        return (number < 10 ? '0' : '') + number;
      }
    };
    module.exports = TimeFormatter;

    /***/
  }), (/* 13 */
  /***/function (module, exports) {
    'use strict';

    var PhoneFormatter = function PhoneFormatter(formatter, delimiter) {
      var owner = this;
      owner.delimiter = delimiter || delimiter === '' ? delimiter : ' ';
      owner.delimiterRE = delimiter ? new RegExp('\\' + delimiter, 'g') : '';
      owner.formatter = formatter;
    };
    PhoneFormatter.prototype = {
      setFormatter: function setFormatter(formatter) {
        this.formatter = formatter;
      },
      format: function format(phoneNumber) {
        var owner = this;
        owner.formatter.clear();

        // only keep number and +
        phoneNumber = phoneNumber.replace(/[^\d+]/g, '');

        // strip non-leading +
        phoneNumber = phoneNumber.replace(/^\+/, 'B').replace(/\+/g, '').replace('B', '+');

        // strip delimiter
        phoneNumber = phoneNumber.replace(owner.delimiterRE, '');
        var result = '',
          current,
          validated = false;
        for (var i = 0, iMax = phoneNumber.length; i < iMax; i++) {
          current = owner.formatter.inputDigit(phoneNumber.charAt(i));

          // has ()- or space inside
          if (/[\s()-]/g.test(current)) {
            result = current;
            validated = true;
          } else {
            if (!validated) {
              result = current;
            }
            // else: over length input
            // it turns to invalid number again
          }
        }

        // strip ()
        // e.g. US: 7161234567 returns (716) 123-4567
        result = result.replace(/[()]/g, '');
        // replace library delimiter with user customized delimiter
        result = result.replace(/[\s-]/g, owner.delimiter);
        return result;
      }
    };
    module.exports = PhoneFormatter;

    /***/
  }), (/* 14 */
  /***/function (module, exports) {
    'use strict';

    var CreditCardDetector = {
      blocks: {
        uatp: [4, 5, 6],
        amex: [4, 6, 5],
        diners: [4, 6, 4],
        discover: [4, 4, 4, 4],
        mastercard: [4, 4, 4, 4],
        dankort: [4, 4, 4, 4],
        instapayment: [4, 4, 4, 4],
        jcb15: [4, 6, 5],
        jcb: [4, 4, 4, 4],
        maestro: [4, 4, 4, 4],
        visa: [4, 4, 4, 4],
        mir: [4, 4, 4, 4],
        unionPay: [4, 4, 4, 4],
        general: [4, 4, 4, 4]
      },
      re: {
        // starts with 1; 15 digits, not starts with 1800 (jcb card)
        uatp: /^(?!1800)1\d{0,14}/,
        // starts with 34/37; 15 digits
        amex: /^3[47]\d{0,13}/,
        // starts with 6011/65/644-649; 16 digits
        discover: /^(?:6011|65\d{0,2}|64[4-9]\d?)\d{0,12}/,
        // starts with 300-305/309 or 36/38/39; 14 digits
        diners: /^3(?:0([0-5]|9)|[689]\d?)\d{0,11}/,
        // starts with 51-55/2221–2720; 16 digits
        mastercard: /^(5[1-5]\d{0,2}|22[2-9]\d{0,1}|2[3-7]\d{0,2})\d{0,12}/,
        // starts with 5019/4175/4571; 16 digits
        dankort: /^(5019|4175|4571)\d{0,12}/,
        // starts with 637-639; 16 digits
        instapayment: /^63[7-9]\d{0,13}/,
        // starts with 2131/1800; 15 digits
        jcb15: /^(?:2131|1800)\d{0,11}/,
        // starts with 2131/1800/35; 16 digits
        jcb: /^(?:35\d{0,2})\d{0,12}/,
        // starts with 50/56-58/6304/67; 16 digits
        maestro: /^(?:5[0678]\d{0,2}|6304|67\d{0,2})\d{0,12}/,
        // starts with 22; 16 digits
        mir: /^220[0-4]\d{0,12}/,
        // starts with 4; 16 digits
        visa: /^4\d{0,15}/,
        // starts with 62/81; 16 digits
        unionPay: /^(62|81)\d{0,14}/
      },
      getStrictBlocks: function getStrictBlocks(block) {
        var total = block.reduce(function (prev, current) {
          return prev + current;
        }, 0);
        return block.concat(19 - total);
      },
      getInfo: function getInfo(value, strictMode) {
        var blocks = CreditCardDetector.blocks,
          re = CreditCardDetector.re;

        // Some credit card can have up to 19 digits number.
        // Set strictMode to true will remove the 16 max-length restrain,
        // however, I never found any website validate card number like
        // this, hence probably you don't want to enable this option.
        strictMode = !!strictMode;
        for (var key in re) {
          if (re[key].test(value)) {
            var matchedBlocks = blocks[key];
            return {
              type: key,
              blocks: strictMode ? this.getStrictBlocks(matchedBlocks) : matchedBlocks
            };
          }
        }
        return {
          type: 'unknown',
          blocks: strictMode ? this.getStrictBlocks(blocks.general) : blocks.general
        };
      }
    };
    module.exports = CreditCardDetector;

    /***/
  }), (/* 15 */
  /***/function (module, exports) {
    'use strict';

    var Util = {
      noop: function noop() {},
      strip: function strip(value, re) {
        return value.replace(re, '');
      },
      getPostDelimiter: function getPostDelimiter(value, delimiter, delimiters) {
        // single delimiter
        if (delimiters.length === 0) {
          return value.slice(-delimiter.length) === delimiter ? delimiter : '';
        }

        // multiple delimiters
        var matchedDelimiter = '';
        delimiters.forEach(function (current) {
          if (value.slice(-current.length) === current) {
            matchedDelimiter = current;
          }
        });
        return matchedDelimiter;
      },
      getDelimiterREByDelimiter: function getDelimiterREByDelimiter(delimiter) {
        return new RegExp(delimiter.replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1'), 'g');
      },
      getNextCursorPosition: function getNextCursorPosition(prevPos, oldValue, newValue, delimiter, delimiters) {
        // If cursor was at the end of value, just place it back.
        // Because new value could contain additional chars.
        if (oldValue.length === prevPos) {
          return newValue.length;
        }
        return prevPos + this.getPositionOffset(prevPos, oldValue, newValue, delimiter, delimiters);
      },
      getPositionOffset: function getPositionOffset(prevPos, oldValue, newValue, delimiter, delimiters) {
        var oldRawValue, newRawValue, lengthOffset;
        oldRawValue = this.stripDelimiters(oldValue.slice(0, prevPos), delimiter, delimiters);
        newRawValue = this.stripDelimiters(newValue.slice(0, prevPos), delimiter, delimiters);
        lengthOffset = oldRawValue.length - newRawValue.length;
        return lengthOffset !== 0 ? lengthOffset / Math.abs(lengthOffset) : 0;
      },
      stripDelimiters: function stripDelimiters(value, delimiter, delimiters) {
        var owner = this;

        // single delimiter
        if (delimiters.length === 0) {
          var delimiterRE = delimiter ? owner.getDelimiterREByDelimiter(delimiter) : '';
          return value.replace(delimiterRE, '');
        }

        // multiple delimiters
        delimiters.forEach(function (current) {
          current.split('').forEach(function (letter) {
            value = value.replace(owner.getDelimiterREByDelimiter(letter), '');
          });
        });
        return value;
      },
      headStr: function headStr(str, length) {
        return str.slice(0, length);
      },
      getMaxLength: function getMaxLength(blocks) {
        return blocks.reduce(function (previous, current) {
          return previous + current;
        }, 0);
      },
      // strip prefix
      // Before type  |   After type    |     Return value
      // PEFIX-...    |   PEFIX-...     |     ''
      // PREFIX-123   |   PEFIX-123     |     123
      // PREFIX-123   |   PREFIX-23     |     23
      // PREFIX-123   |   PREFIX-1234   |     1234
      getPrefixStrippedValue: function getPrefixStrippedValue(value, prefix, prefixLength, prevResult, delimiter, delimiters, noImmediatePrefix, tailPrefix, signBeforePrefix) {
        // No prefix
        if (prefixLength === 0) {
          return value;
        }

        // Value is prefix
        if (value === prefix && value !== '') {
          return '';
        }
        if (signBeforePrefix && value.slice(0, 1) == '-') {
          var prev = prevResult.slice(0, 1) == '-' ? prevResult.slice(1) : prevResult;
          return '-' + this.getPrefixStrippedValue(value.slice(1), prefix, prefixLength, prev, delimiter, delimiters, noImmediatePrefix, tailPrefix, signBeforePrefix);
        }

        // Pre result prefix string does not match pre-defined prefix
        if (prevResult.slice(0, prefixLength) !== prefix && !tailPrefix) {
          // Check if the first time user entered something
          if (noImmediatePrefix && !prevResult && value) return value;
          return '';
        } else if (prevResult.slice(-prefixLength) !== prefix && tailPrefix) {
          // Check if the first time user entered something
          if (noImmediatePrefix && !prevResult && value) return value;
          return '';
        }
        var prevValue = this.stripDelimiters(prevResult, delimiter, delimiters);

        // New value has issue, someone typed in between prefix letters
        // Revert to pre value
        if (value.slice(0, prefixLength) !== prefix && !tailPrefix) {
          return prevValue.slice(prefixLength);
        } else if (value.slice(-prefixLength) !== prefix && tailPrefix) {
          return prevValue.slice(0, -prefixLength - 1);
        }

        // No issue, strip prefix for new value
        return tailPrefix ? value.slice(0, -prefixLength) : value.slice(prefixLength);
      },
      getFirstDiffIndex: function getFirstDiffIndex(prev, current) {
        var index = 0;
        while (prev.charAt(index) === current.charAt(index)) {
          if (prev.charAt(index++) === '') {
            return -1;
          }
        }
        return index;
      },
      getFormattedValue: function getFormattedValue(value, blocks, blocksLength, delimiter, delimiters, delimiterLazyShow) {
        var result = '',
          multipleDelimiters = delimiters.length > 0,
          currentDelimiter = '';

        // no options, normal input
        if (blocksLength === 0) {
          return value;
        }
        blocks.forEach(function (length, index) {
          if (value.length > 0) {
            var sub = value.slice(0, length),
              rest = value.slice(length);
            if (multipleDelimiters) {
              currentDelimiter = delimiters[delimiterLazyShow ? index - 1 : index] || currentDelimiter;
            } else {
              currentDelimiter = delimiter;
            }
            if (delimiterLazyShow) {
              if (index > 0) {
                result += currentDelimiter;
              }
              result += sub;
            } else {
              result += sub;
              if (sub.length === length && index < blocksLength - 1) {
                result += currentDelimiter;
              }
            }

            // update remaining string
            value = rest;
          }
        });
        return result;
      },
      // move cursor to the end
      // the first time user focuses on an input with prefix
      fixPrefixCursor: function fixPrefixCursor(el, prefix, delimiter, delimiters) {
        if (!el) {
          return;
        }
        var val = el.value,
          appendix = delimiter || delimiters[0] || ' ';
        if (!el.setSelectionRange || !prefix || prefix.length + appendix.length <= val.length) {
          return;
        }
        var len = val.length * 2;

        // set timeout to avoid blink
        setTimeout(function () {
          el.setSelectionRange(len, len);
        }, 1);
      },
      // Check if input field is fully selected
      checkFullSelection: function checkFullSelection(value) {
        try {
          var selection = window.getSelection() || document.getSelection() || {};
          return selection.toString().length === value.length;
        } catch (ex) {
          // Ignore
        }
        return false;
      },
      setSelection: function setSelection(element, position, doc) {
        if (element !== this.getActiveElement(doc)) {
          return;
        }

        // cursor is already in the end
        if (element && element.value.length <= position) {
          return;
        }
        if (element.createTextRange) {
          var range = element.createTextRange();
          range.move('character', position);
          range.select();
        } else {
          try {
            element.setSelectionRange(position, position);
          } catch (e) {
            // eslint-disable-next-line
            console.warn('The input element type does not support selection');
          }
        }
      },
      getActiveElement: function getActiveElement(parent) {
        var activeElement = parent.activeElement;
        if (activeElement && activeElement.shadowRoot) {
          return this.getActiveElement(activeElement.shadowRoot);
        }
        return activeElement;
      },
      isAndroid: function isAndroid() {
        return navigator && /android/i.test(navigator.userAgent);
      },
      // On Android chrome, the keyup and keydown events
      // always return key code 229 as a composition that
      // buffers the user’s keystrokes
      // see https://github.com/nosir/cleave.js/issues/147
      isAndroidBackspaceKeydown: function isAndroidBackspaceKeydown(lastInputValue, currentInputValue) {
        if (!this.isAndroid() || !lastInputValue || !currentInputValue) {
          return false;
        }
        return currentInputValue === lastInputValue.slice(0, -1);
      }
    };
    module.exports = Util;

    /***/
  }), (/* 16 */
  /***/function (module, exports) {
    /* WEBPACK VAR INJECTION */(function (global) {
      'use strict';

      /**
       * Props Assignment
       *
       * Separate this, so react module can share the usage
       */
      var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
        return typeof obj;
      } : function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
      var DefaultProperties = {
        // Maybe change to object-assign
        // for now just keep it as simple
        assign: function assign(target, opts) {
          target = target || {};
          opts = opts || {};

          // credit card
          target.creditCard = !!opts.creditCard;
          target.creditCardStrictMode = !!opts.creditCardStrictMode;
          target.creditCardType = '';
          target.onCreditCardTypeChanged = opts.onCreditCardTypeChanged || function () {};

          // phone
          target.phone = !!opts.phone;
          target.phoneRegionCode = opts.phoneRegionCode || 'AU';
          target.phoneFormatter = {};

          // time
          target.time = !!opts.time;
          target.timePattern = opts.timePattern || ['h', 'm', 's'];
          target.timeFormat = opts.timeFormat || '24';
          target.timeFormatter = {};

          // date
          target.date = !!opts.date;
          target.datePattern = opts.datePattern || ['d', 'm', 'Y'];
          target.dateMin = opts.dateMin || '';
          target.dateMax = opts.dateMax || '';
          target.dateFormatter = {};

          // numeral
          target.numeral = !!opts.numeral;
          target.numeralIntegerScale = opts.numeralIntegerScale > 0 ? opts.numeralIntegerScale : 0;
          target.numeralDecimalScale = opts.numeralDecimalScale >= 0 ? opts.numeralDecimalScale : 2;
          target.numeralDecimalMark = opts.numeralDecimalMark || '.';
          target.numeralThousandsGroupStyle = opts.numeralThousandsGroupStyle || 'thousand';
          target.numeralPositiveOnly = !!opts.numeralPositiveOnly;
          target.stripLeadingZeroes = opts.stripLeadingZeroes !== false;
          target.signBeforePrefix = !!opts.signBeforePrefix;
          target.tailPrefix = !!opts.tailPrefix;

          // others
          target.swapHiddenInput = !!opts.swapHiddenInput;
          target.numericOnly = target.creditCard || target.date || !!opts.numericOnly;
          target.uppercase = !!opts.uppercase;
          target.lowercase = !!opts.lowercase;
          target.prefix = target.creditCard || target.date ? '' : opts.prefix || '';
          target.noImmediatePrefix = !!opts.noImmediatePrefix;
          target.prefixLength = target.prefix.length;
          target.rawValueTrimPrefix = !!opts.rawValueTrimPrefix;
          target.copyDelimiter = !!opts.copyDelimiter;
          target.initValue = opts.initValue !== undefined && opts.initValue !== null ? opts.initValue.toString() : '';
          target.delimiter = opts.delimiter || opts.delimiter === '' ? opts.delimiter : opts.date ? '/' : opts.time ? ':' : opts.numeral ? ',' : opts.phone ? ' ' : ' ';
          target.delimiterLength = target.delimiter.length;
          target.delimiterLazyShow = !!opts.delimiterLazyShow;
          target.delimiters = opts.delimiters || [];
          target.blocks = opts.blocks || [];
          target.blocksLength = target.blocks.length;
          target.root = (typeof global === 'undefined' ? 'undefined' : _typeof(global)) === 'object' && global ? global : window;
          target.document = opts.document || target.root.document;
          target.maxLength = 0;
          target.backspace = false;
          target.result = '';
          target.onValueChanged = opts.onValueChanged || function () {};
          return target;
        }
      };
      module.exports = DefaultProperties;
      /* WEBPACK VAR INJECTION */
    }).call(exports, function () {
      return this;
    }());

    /***/
  }
  /******/)]);
});
;

/***/ }),

/***/ 8532:
/***/ ((module) => {

"use strict";


/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
// eslint-disable-next-line func-names
module.exports = function (useSourceMap) {
  var list = []; // return the list of modules as css string

  list.toString = function toString() {
    return this.map(function (item) {
      var content = cssWithMappingToString(item, useSourceMap);
      if (item[2]) {
        return "@media ".concat(item[2], " {").concat(content, "}");
      }
      return content;
    }).join('');
  }; // import a list of modules into the list
  // eslint-disable-next-line func-names

  list.i = function (modules, mediaQuery, dedupe) {
    if (typeof modules === 'string') {
      // eslint-disable-next-line no-param-reassign
      modules = [[null, modules, '']];
    }
    var alreadyImportedModules = {};
    if (dedupe) {
      for (var i = 0; i < this.length; i++) {
        // eslint-disable-next-line prefer-destructuring
        var id = this[i][0];
        if (id != null) {
          alreadyImportedModules[id] = true;
        }
      }
    }
    for (var _i = 0; _i < modules.length; _i++) {
      var item = [].concat(modules[_i]);
      if (dedupe && alreadyImportedModules[item[0]]) {
        // eslint-disable-next-line no-continue
        continue;
      }
      if (mediaQuery) {
        if (!item[2]) {
          item[2] = mediaQuery;
        } else {
          item[2] = "".concat(mediaQuery, " and ").concat(item[2]);
        }
      }
      list.push(item);
    }
  };
  return list;
};
function cssWithMappingToString(item, useSourceMap) {
  var content = item[1] || ''; // eslint-disable-next-line prefer-destructuring

  var cssMapping = item[3];
  if (!cssMapping) {
    return content;
  }
  if (useSourceMap && typeof btoa === 'function') {
    var sourceMapping = toComment(cssMapping);
    var sourceURLs = cssMapping.sources.map(function (source) {
      return "/*# sourceURL=".concat(cssMapping.sourceRoot || '').concat(source, " */");
    });
    return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
  }
  return [content].join('\n');
} // Adapted from convert-source-map (MIT)

function toComment(sourceMap) {
  // eslint-disable-next-line no-undef
  var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
  var data = "sourceMappingURL=data:application/json;charset=utf-8;base64,".concat(base64);
  return "/*# ".concat(data, " */");
}

/***/ }),

/***/ 5592:
/***/ ((module) => {

/**
 * When source maps are enabled, `style-loader` uses a link element with a data-uri to
 * embed the css on the page. This breaks all relative urls because now they are relative to a
 * bundle instead of the current page.
 *
 * One solution is to only use full urls, but that may be impossible.
 *
 * Instead, this function "fixes" the relative urls to be absolute according to the current page location.
 *
 * A rudimentary test suite is located at `test/fixUrls.js` and can be run via the `npm test` command.
 *
 */

module.exports = function (css) {
  // get current location
  var location = typeof window !== "undefined" && window.location;
  if (!location) {
    throw new Error("fixUrls requires window.location");
  }

  // blank or null?
  if (!css || typeof css !== "string") {
    return css;
  }
  var baseUrl = location.protocol + "//" + location.host;
  var currentDir = baseUrl + location.pathname.replace(/\/[^\/]*$/, "/");

  // convert each url(...)
  /*
  This regular expression is just a way to recursively match brackets within
  a string.
  	 /url\s*\(  = Match on the word "url" with any whitespace after it and then a parens
     (  = Start a capturing group
       (?:  = Start a non-capturing group
           [^)(]  = Match anything that isn't a parentheses
           |  = OR
           \(  = Match a start parentheses
               (?:  = Start another non-capturing groups
                   [^)(]+  = Match anything that isn't a parentheses
                   |  = OR
                   \(  = Match a start parentheses
                       [^)(]*  = Match anything that isn't a parentheses
                   \)  = Match a end parentheses
               )  = End Group
               *\) = Match anything and then a close parens
           )  = Close non-capturing group
           *  = Match anything
        )  = Close capturing group
   \)  = Match a close parens
  	 /gi  = Get all matches, not the first.  Be case insensitive.
   */
  var fixedCss = css.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function (fullMatch, origUrl) {
    // strip quotes (if they exist)
    var unquotedOrigUrl = origUrl.trim().replace(/^"(.*)"$/, function (o, $1) {
      return $1;
    }).replace(/^'(.*)'$/, function (o, $1) {
      return $1;
    });

    // already a full url? no change
    if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/|\s*$)/i.test(unquotedOrigUrl)) {
      return fullMatch;
    }

    // convert the url to a full url
    var newUrl;
    if (unquotedOrigUrl.indexOf("//") === 0) {
      //TODO: should we add protocol?
      newUrl = unquotedOrigUrl;
    } else if (unquotedOrigUrl.indexOf("/") === 0) {
      // path should be relative to the base url
      newUrl = baseUrl + unquotedOrigUrl; // already starts with '/'
    } else {
      // path should be relative to current directory
      newUrl = currentDir + unquotedOrigUrl.replace(/^\.\//, ""); // Strip leading './'
    }

    // send back the fixed url(...)
    return "url(" + JSON.stringify(newUrl) + ")";
  });

  // send back the fixed css
  return fixedCss;
};

/***/ }),

/***/ 2696:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ components_Accordion)
});

// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__(9155);
var external_react_default = /*#__PURE__*/__webpack_require__.n(external_react_);
// EXTERNAL MODULE: external "prop-types"
var external_prop_types_ = __webpack_require__(1949);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(3368);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/components/Accordion/_styles.scss
var _styles = __webpack_require__(9267);
// EXTERNAL MODULE: ./src/utilities/EventUtilities.js
var EventUtilities = __webpack_require__(5609);
;// CONCATENATED MODULE: ./src/components/Accordion/Accordion.jsx





var Accordion = function Accordion(props) {
  var onHeaderClick = function onHeaderClick() {
    var _props$onChange;
    (_props$onChange = props.onChange) === null || _props$onChange === void 0 || _props$onChange.call(props);
  };
  var onHeaderKeyDown = function onHeaderKeyDown(e) {
    if ((0,EventUtilities/* isEnterPressed */.DV)(e)) {
      e.preventDefault();
      onHeaderClick();
    }
  };
  return /*#__PURE__*/external_react_default().createElement("div", {
    className: classnames_default()("accordion", {
      "expanded": props.expanded
    })
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "accordion-header-container",
    id: props.id,
    onClick: onHeaderClick,
    onKeyDown: onHeaderKeyDown,
    "aria-controls": props.ariaControls,
    "aria-expanded": props.expanded,
    "aria-disabled": "false",
    role: "button",
    tabIndex: props.tabIndex
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "accordion-header"
  }, props.header), /*#__PURE__*/external_react_default().createElement("div", {
    className: "accordion-header-icon-container"
  }, /*#__PURE__*/external_react_default().createElement("span", {
    className: "ion-ios-arrow-down"
  }))), /*#__PURE__*/external_react_default().createElement("div", {
    className: "accordion-content-container",
    "aria-disabled": "false",
    "aria-hidden": "true"
  }, props.children));
};
 false ? 0 : void 0;
/* harmony default export */ const Accordion_Accordion = (Accordion);
;// CONCATENATED MODULE: ./src/components/Accordion/index.js

/* harmony default export */ const components_Accordion = (Accordion_Accordion);

/***/ }),

/***/ 1504:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* unused harmony export ActionButtonsPanel */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9155);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1949);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9305);
/* harmony import */ var _components_PendingButton__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7113);
/* harmony import */ var _utilities_EventUtilities__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5609);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }





var ActionButtonsPanel = /*#__PURE__*/function (_React$PureComponent) {
  function ActionButtonsPanel(props) {
    var _this;
    _classCallCheck(this, ActionButtonsPanel);
    _this = _callSuper(this, ActionButtonsPanel, [props]);
    _this.setFocus = _this.setFocus.bind(_this);
    _this.onCancelKeyDown = _this.onCancelKeyDown.bind(_this);
    _this.onSaveKeyDown = _this.onSaveKeyDown.bind(_this);
    _this.onAdditionalButtonKeyDown = _this.onAdditionalButtonKeyDown.bind(_this);
    return _this;
  }
  _inherits(ActionButtonsPanel, _React$PureComponent);
  return _createClass(ActionButtonsPanel, [{
    key: "setFocus",
    value: function setFocus() {
      this.cancelButton.setFocus();
    }
  }, {
    key: "setFocusToSave",
    value: function setFocusToSave() {
      this.saveButton.setFocus();
    }
  }, {
    key: "onCancelKeyDown",
    value: function onCancelKeyDown(event) {
      if (!(0,_utilities_EventUtilities__WEBPACK_IMPORTED_MODULE_2__/* .isTabPressed */ .Wz)(event) || (0,_utilities_EventUtilities__WEBPACK_IMPORTED_MODULE_2__/* .isShiftPressed */ .Hk)(event)) return;
      event.preventDefault();
      if (this.props.hasExternalFocus) {
        this.props.moveFocusBack && this.props.moveFocusBack();
      } else {
        this.saveButton.setFocus();
      }
    }
  }, {
    key: "onSaveKeyDown",
    value: function onSaveKeyDown(event) {
      if (!(0,_utilities_EventUtilities__WEBPACK_IMPORTED_MODULE_2__/* .isTabPressed */ .Wz)(event) || !(0,_utilities_EventUtilities__WEBPACK_IMPORTED_MODULE_2__/* .isShiftPressed */ .Hk)(event)) return;
      if (this.props.hasExternalFocus) {
        this.props.onSaveFocusBack && this.props.onSaveFocusBack();
      } else {
        event.preventDefault();
        this.cancelButton.setFocus();
      }
    }
  }, {
    key: "onAdditionalButtonKeyDown",
    value: function onAdditionalButtonKeyDown(event) {
      if (!(0,_utilities_EventUtilities__WEBPACK_IMPORTED_MODULE_2__/* .isTabPressed */ .Wz)(event) || !(0,_utilities_EventUtilities__WEBPACK_IMPORTED_MODULE_2__/* .isShiftPressed */ .Hk)(event)) return;
      if (this.props.hasExternalFocus) {
        this.props.onSaveFocusBack && this.props.onSaveFocusBack();
      } else {
        event.preventDefault();
        this.cancelButton.setFocus();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var shouldShowSave = !this.props.hideSave;
      var shouldShowAdditional = !this.props.hideAdditionalButton;
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
        className: this.props.className,
        name: "actionButtonsPanel"
      }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_Button__WEBPACK_IMPORTED_MODULE_3__["default"], {
        name: "cancelButton",
        className: "btn btn-default btn-mobile-cancel",
        tabIndex: 3,
        onClick: this.props.onCancel,
        onKeyDown: this.onCancelKeyDown,
        disabled: this.props.isSaving,
        ref: function ref(input) {
          return _this2.cancelButton = input;
        }
      }, "Cancel"), shouldShowAdditional && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_components_PendingButton__WEBPACK_IMPORTED_MODULE_4__["default"], {
        type: "button",
        name: "additionalButton",
        className: this.props.additionalButtonClassName,
        tabIndex: 1,
        title: this.props.additionalButtonTitle,
        onClick: this.props.onAdditionalButtonClick,
        onKeyDown: this.onAdditionalButtonKeyDown,
        ref: function ref(input) {
          return _this2.additionalButton = input;
        },
        disabled: this.props.isDisabled,
        iconName: this.props.additionalButtonIconName,
        iconClassName: this.props.additionalButtonIconClassName,
        isPending: this.props.isAdditionalButtonPending
      }), shouldShowSave && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_components_PendingButton__WEBPACK_IMPORTED_MODULE_4__["default"], {
        name: "saveButton",
        className: "btn btn-success",
        tabIndex: 2,
        title: this.props.saveTitle,
        isPending: this.props.isSaving,
        pendingTitle: this.props.savingTitle,
        onClick: this.props.onSave,
        onKeyDown: this.onSaveKeyDown,
        ref: function ref(input) {
          return _this2.saveButton = input;
        },
        disabled: this.props.isDisabled
      }));
    }
  }]);
}((react__WEBPACK_IMPORTED_MODULE_0___default().PureComponent));
ActionButtonsPanel.defaultProps = {
  onSave: function onSave() {},
  onCancel: function onCancel() {},
  onAdditionalButtonClick: function onAdditionalButtonClick() {},
  onSaveFocusBack: function onSaveFocusBack() {},
  saveTitle: "Done",
  savingTitle: "Saving",
  isSaving: false,
  isDisabled: false,
  className: "btn-control",
  moveFocusBack: function moveFocusBack() {},
  hideSave: false,
  hideAdditionalButton: true,
  additionalButtonClassName: "btn btn-warning",
  isAdditionalButtonPending: false
};
 false ? 0 : void 0;
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ActionButtonsPanel);

/***/ }),

/***/ 9305:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* unused harmony export Button */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9155);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1949);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }


var Button = /*#__PURE__*/function (_React$PureComponent) {
  function Button(props) {
    var _this;
    _classCallCheck(this, Button);
    _this = _callSuper(this, Button, [props]);
    _this.setFocus = _this.setFocus.bind(_this);
    return _this;
  }
  _inherits(Button, _React$PureComponent);
  return _createClass(Button, [{
    key: "setFocus",
    value: function setFocus() {
      this.button.focus();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var buttonProps = {};
      buttonProps["disabled"] = this.props.disabled;
      buttonProps["onKeyDown"] = this.props.onKeyDown;
      buttonProps["autoFocus"] = this.props.autoFocus;
      buttonProps["name"] = this.props.name;
      var children = this.props.title && this.props.title.length > 0 ? this.props.title : this.props.children;
      if (this.props.id) {
        buttonProps["id"] = this.props.id;
      }
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("button", _extends({
        ref: function ref(input) {
          _this2.button = input;
        },
        tabIndex: this.props.tabIndex,
        className: this.props.className,
        "aria-describedby": this.props.ariaDescribedBy
      }, buttonProps, {
        onClick: this.props.onClick
      }), children);
    }
  }]);
}((react__WEBPACK_IMPORTED_MODULE_0___default().PureComponent));
 false ? 0 : void 0;
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Button);

/***/ }),

/***/ 9692:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* unused harmony export CheckBox */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9155);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1949);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utilities_EventUtilities__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5609);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3368);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _styles_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3554);
/* harmony import */ var _styles_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_styles_scss__WEBPACK_IMPORTED_MODULE_3__);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }





var CheckBox = /*#__PURE__*/function (_Component) {
  function CheckBox(props) {
    var _this;
    _classCallCheck(this, CheckBox);
    _this = _callSuper(this, CheckBox, [props]);
    _this.setFocus = _this.setFocus.bind(_this);
    _this.onClick = _this.onClick.bind(_this);
    _this.onKeyPress = _this.onKeyPress.bind(_this);
    return _this;
  }
  _inherits(CheckBox, _Component);
  return _createClass(CheckBox, [{
    key: "setFocus",
    value: function setFocus() {
      this.checkbox.focus();
    }
  }, {
    key: "onClick",
    value: function onClick() {
      if (!this.props.disabled) this.props.onChange(this.props.value);
    }
  }, {
    key: "onKeyPress",
    value: function onKeyPress(e) {
      if (!this.props.disabled && (0,_utilities_EventUtilities__WEBPACK_IMPORTED_MODULE_4__/* .isSpacePressed */ .l_)(e)) {
        this.props.onChange(this.props.value);
        e.preventDefault();
      }
    }
  }, {
    key: "getIcon",
    value: function getIcon() {
      var _this$props = this.props,
        icon = _this$props.icon,
        iconContainerClass = _this$props.iconContainerClass;
      if (!icon) return null;
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
        className: "checkbox-icon " + iconContainerClass
      }, this.props.icon));
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var checkBoxProps = {};
      checkBoxProps["disabled"] = this.props.disabled;
      checkBoxProps["checked"] = this.props.checked;
      var tabProps = {};
      if (this.props.tabIndex && !this.props.disabled) tabProps["tabIndex"] = this.props.tabIndex;
      var resultedCheckBoxClass = this.props.className;
      resultedCheckBoxClass = resultedCheckBoxClass + " sl-checkbox";
      var iconClass = classnames__WEBPACK_IMPORTED_MODULE_2___default()({
        "ion-ios-checkbox": this.props.checked,
        "ion-md-square-outline": !this.props.checked,
        "inactive": this.props.disabled
      });
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
        className: resultedCheckBoxClass,
        onClick: this.onClick,
        name: "checkboxContainer"
      }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", _extends({
        className: "blueCheckBox",
        name: "checkbox"
      }, tabProps, {
        onKeyDown: this.props.onKeyDown,
        onKeyPress: this.onKeyPress,
        ref: function ref(checkbox) {
          _this2.checkbox = checkbox;
        },
        "data-checked": this.props.checked
      }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("input", _extends({
        type: "checkbox",
        name: this.props.name
      }, checkBoxProps, {
        onChange: this.onClick
      })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("i", {
        className: iconClass
      })), this.getIcon(), this.props.label && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
        className: this.props.labelContainerClassName
      }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("label", {
        className: this.props.labelClassName,
        name: "checkboxLabel"
      }, this.props.label)));
    }
  }]);
}(react__WEBPACK_IMPORTED_MODULE_0__.Component);
CheckBox.defaultProps = {
  iconContainerClass: "",
  className: "",
  disabled: false,
  onKeyDown: function onKeyDown() {}
};
 false ? 0 : void 0;
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (CheckBox);

/***/ }),

/***/ 1789:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9155);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var cleave_js_dist_cleave_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6543);
/* harmony import */ var cleave_js_dist_cleave_react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(cleave_js_dist_cleave_react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1949);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }



var DateInput = /*#__PURE__*/function (_Component) {
  function DateInput() {
    var _this;
    _classCallCheck(this, DateInput);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, DateInput, [].concat(args));
    _defineProperty(_this, "setFocus", function () {
      _this.dateInput.element.focus();
    });
    return _this;
  }
  _inherits(DateInput, _Component);
  return _createClass(DateInput, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var wrapperClass = "form-group";
      if (this.props.error && this.props.error.length > 0) {
        wrapperClass += " " + "has-error";
      }
      if (this.props.className) wrapperClass += " " + this.props.className;
      var labelId = this.props.name + "Label";
      var inputId = this.props.name + "Input";
      var componentName = this.props.name + "Field";
      var inputFinalClassName = this.props.inputClassName ? "form-control " + this.props.inputClassName : "form-control";
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
        className: wrapperClass,
        name: componentName
      }, this.props.label && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("label", {
        id: labelId,
        htmlFor: this.props.name
      }, this.props.label), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement((cleave_js_dist_cleave_react__WEBPACK_IMPORTED_MODULE_1___default()), {
        id: inputId,
        name: this.props.name,
        ref: function ref(_ref) {
          return _this2.dateInput = _ref;
        },
        value: this.props.value,
        placeholder: this.props.placeholder,
        className: inputFinalClassName,
        tabIndex: this.props.tabIndex,
        autoFocus: this.props.autoFocus,
        options: this.props.options,
        onChange: this.props.onChange,
        onKeyDown: this.props.onKeyDown,
        disabled: this.props.disabled
      }), this.props.error && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
        name: "dateError",
        className: "validate-error-message"
      }, this.props.error));
    }
  }]);
}(react__WEBPACK_IMPORTED_MODULE_0__.Component);
DateInput.defaultProps = {
  error: "",
  placeholder: "mm/dd/yyyy",
  options: {
    date: true,
    datePattern: ["m", "d", "Y"]
  }
};
 false ? 0 : void 0;
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (DateInput);

/***/ }),

/***/ 3615:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ components_DropDown)
});

// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__(9155);
var external_react_default = /*#__PURE__*/__webpack_require__.n(external_react_);
// EXTERNAL MODULE: external "prop-types"
var external_prop_types_ = __webpack_require__(1949);
// EXTERNAL MODULE: ./src/utilities/EventUtilities.js
var EventUtilities = __webpack_require__(5609);
;// CONCATENATED MODULE: ./src/components/DropDown/ItemRow.jsx


var ItemRow = function ItemRow(_ref) {
  var item = _ref.item,
    index = _ref.index,
    getRowContent = _ref.getRowContent,
    dataFieldName = _ref.dataFieldName,
    titleFieldName = _ref.titleFieldName,
    selectedItemIndex = _ref.selectedItemIndex,
    onItemSelected = _ref.onItemSelected,
    contentClassName = _ref.contentClassName,
    liRef = _ref.liRef;
  var showDefaultRow = !getRowContent;
  var displayedValue = dataFieldName && dataFieldName.length > 0 ? item[dataFieldName] : item;
  var title = titleFieldName && titleFieldName.length > 0 ? item[titleFieldName] : displayedValue;
  var isItemSelected = index === selectedItemIndex;
  var className = isItemSelected ? "selected" : "";
  var onMouseDown = function onMouseDown() {
    onItemSelected(item);
  };
  return /*#__PURE__*/external_react_default().createElement("li", {
    className: className,
    ref: isItemSelected ? liRef : null,
    onMouseDown: onMouseDown
  }, getContent(showDefaultRow, contentClassName, title, displayedValue, item, getRowContent));
};
var getContent = function getContent(showDefaultRow, contentClassName, title, displayedValue, item, getRowContent) {
  if (showDefaultRow) {
    return /*#__PURE__*/external_react_default().createElement("a", {
      href: "",
      className: contentClassName
    }, /*#__PURE__*/external_react_default().createElement("div", {
      className: "truncate",
      title: title
    }, /*#__PURE__*/external_react_default().createElement("span", null, displayedValue)));
  }
  return getRowContent(item);
};
 false ? 0 : void 0;
/* harmony default export */ const DropDown_ItemRow = (ItemRow);
;// CONCATENATED MODULE: ./src/components/DropDown/DropDown.jsx
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }




var DropDown = /*#__PURE__*/function (_React$Component) {
  function DropDown(props, context) {
    var _this;
    _classCallCheck(this, DropDown);
    _this = _callSuper(this, DropDown, [props, context]);
    _this.state = {
      selectedItemIndex: -1,
      dropdownIsActive: false
    };
    _this.onBlur = _this.onBlur.bind(_this);
    _this.onKeyDown = _this.onKeyDown.bind(_this);
    _this.onItemSelected = _this.onItemSelected.bind(_this);
    _this.getItemRow = _this.getItemRow.bind(_this);
    _this.setFocus = _this.setFocus.bind(_this);
    _this.toggleDropdown = _this.toggleDropdown.bind(_this);
    return _this;
  }
  _inherits(DropDown, _React$Component);
  return _createClass(DropDown, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.selectedItem) {
        var selectedItemIndex = this.getPropsSelectedItemIndex();
        if (selectedItemIndex >= 0) this.setState({
          selectedItemIndex: selectedItemIndex
        });
      }
      if (this.props.autoFocus) {
        this.setFocus();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.props.selectedItem && this.props.selectedItem !== prevProps.selectedItem) {
        var selectedItemIndex = this.getPropsSelectedItemIndex();
        if (selectedItemIndex >= 0) this.setState({
          selectedItemIndex: selectedItemIndex
        });
      }
      if (prevState.selectedItem !== this.state.selectedItemIndex && this.ul && this.li) {
        this.updateScrollingPosition();
      }
    }
  }, {
    key: "getPropsSelectedItemIndex",
    value: function getPropsSelectedItemIndex() {
      var _this2 = this;
      var selectedItemIndex = this.state.selectedItemIndex;
      if (!this.props.valueFieldName || this.props.valueFieldName == "") {
        selectedItemIndex = this.props.items.indexOf(this.props.selectedItem);
      } else {
        selectedItemIndex = this.props.items.findIndex(function (item) {
          return item[_this2.props.valueFieldName] === _this2.props.selectedItem[_this2.props.valueFieldName];
        });
      }
      return selectedItemIndex;
    }
  }, {
    key: "updateScrollingPosition",
    value: function updateScrollingPosition() {
      var ul = this.ul;
      var elementBottomPosition = this.li.offsetTop + this.li.scrollHeight;
      var elementTopPosition = this.li.offsetTop;
      var ulBottomPosition = ul.offsetHeight + ul.scrollTop;
      if (elementBottomPosition > ulBottomPosition) {
        ul.scrollTop = elementBottomPosition - ul.offsetHeight;
      } else if (elementTopPosition < ul.scrollTop) {
        ul.scrollTop = elementTopPosition;
      }
    }
  }, {
    key: "onItemSelected",
    value: function onItemSelected(item) {
      this.props.onSelect(item);
      this.toggleDropdown();
    }
  }, {
    key: "onBlur",
    value: function onBlur() {
      if (this.state.dropdownIsActive) {
        this.setState({
          dropdownIsActive: false
        });
        var selectedItemIndex = this.getPropsSelectedItemIndex();
        if (selectedItemIndex !== this.state.selectedItemIndex) {
          this.selectItem();
        }
      }
    }
  }, {
    key: "toggleDropdown",
    value: function toggleDropdown() {
      var dropdownIsActive = this.state.dropdownIsActive;
      var newDropdownState = !dropdownIsActive;
      if (this.state.selectedItemIndex == -1 && newDropdownState) this.setState({
        selectedItemIndex: 0
      });
      this.setState({
        dropdownIsActive: newDropdownState
      });
    }
  }, {
    key: "setFocus",
    value: function setFocus() {
      if (this.dropdown) {
        this.dropdown.focus();
      }
    }
  }, {
    key: "getItemRow",
    value: function getItemRow(item, index) {
      var _this3 = this;
      return /*#__PURE__*/external_react_default().createElement(DropDown_ItemRow, {
        getRowContent: this.props.getRowContent,
        liRef: function liRef(el) {
          return _this3.li = el;
        },
        item: item,
        index: index,
        key: index,
        selectedItemIndex: this.state.selectedItemIndex,
        titleFieldName: this.props.titleFieldName,
        onItemSelected: this.onItemSelected,
        contentClassName: this.props.contentClassName,
        dataFieldName: this.props.dataFieldName
      });
    }
  }, {
    key: "getDropDown",
    value: function getDropDown() {
      var _this4 = this;
      var items = this.props.items;
      return /*#__PURE__*/external_react_default().createElement("ul", {
        ref: function ref(_ref) {
          return _this4.ul = _ref;
        },
        className: "tabbed-dropdown-menu"
      }, items.map(function (item, index) {
        return _this4.getItemRow(item, index);
      }));
    }
  }, {
    key: "onSpaceHandler",
    value: function onSpaceHandler() {
      if (this.props.items && this.props.items.length > 0 && this.state.dropdownIsActive) {
        this.selectItem();
        return;
      }
      this.toggleDropdown();
    }
  }, {
    key: "onDownArrowHandler",
    value: function onDownArrowHandler() {
      var currentIndex = this.state.selectedItemIndex;
      var newIndex = currentIndex < this.props.items.length - 1 ? currentIndex + 1 : 0;
      this.setState({
        selectedItemIndex: newIndex
      });
      if (!this.state.dropdownIsActive) {
        var item = this.props.items[newIndex];
        this.props.onSelect(item);
      }
    }
  }, {
    key: "onUpArrowHandler",
    value: function onUpArrowHandler() {
      var currentIndex = this.state.selectedItemIndex;
      var newIndex = currentIndex <= 0 ? this.props.items.length - 1 : currentIndex - 1;
      this.setState({
        selectedItemIndex: newIndex
      });
      if (!this.state.dropdownIsActive) {
        var item = this.props.items[newIndex];
        this.props.onSelect(item);
      }
    }
  }, {
    key: "onShiftTabHandler",
    value: function onShiftTabHandler(e) {
      this.props.moveFocusBack();
      e.preventDefault();
    }
  }, {
    key: "onEnterHandler",
    value: function onEnterHandler() {
      this.selectItem();
    }
  }, {
    key: "onTabHandler",
    value: function onTabHandler(e) {
      this.selectItem();
      e.preventDefault();
    }
  }, {
    key: "selectItem",
    value: function selectItem() {
      var item = this.props.items[this.state.selectedItemIndex];
      this.onItemSelected(item);
    }
  }, {
    key: "onKeyDown",
    value: function onKeyDown(e) {
      if (this.props.isDisabled) return;
      if ((0,EventUtilities/* isSpacePressed */.l_)(e)) {
        this.onSpaceHandler();
        e.preventDefault();
        return;
      }
      if ((0,EventUtilities/* downArrowPressed */.Ur)(e)) {
        this.onDownArrowHandler();
        e.preventDefault();
        return;
      }
      if ((0,EventUtilities/* upArrowPressed */.P7)(e)) {
        this.onUpArrowHandler();
        e.preventDefault();
        return;
      }
      if (((0,EventUtilities/* isTabPressed */.Wz)(e) || (0,EventUtilities/* isEnterPressed */.DV)(e)) && this.state.dropdownIsActive) {
        this.selectItem();
      }
      if ((0,EventUtilities/* isTabPressed */.Wz)(e) && (0,EventUtilities/* isShiftPressed */.Hk)(e) && this.props.moveFocusBack) {
        this.props.moveFocusBack();
        e.preventDefault();
      }
      if ((0,EventUtilities/* isEscPressed */.e0)(e) && this.state.dropdownIsActive) {
        var selectedItemIndex = this.props.items.indexOf(this.props.selectedItem);
        this.setState({
          selectedItemIndex: selectedItemIndex
        });
        this.toggleDropdown();
      }
    }
  }, {
    key: "getDropDownButton",
    value: function getDropDownButton() {
      var _this5 = this;
      var selectedItem = this.props.selectedItem;
      var dataFieldName = this.props.dataFieldName;
      var selectedItemClassName = "selected-value " + this.props.selectedItemClassName;
      var displaySelectedItem = selectedItem && selectedItem[dataFieldName] != undefined ? selectedItem[dataFieldName] : selectedItem;
      if (this.props.isDisabled) {
        return /*#__PURE__*/external_react_default().createElement("div", {
          className: "tabbed-button-dropdown disabled",
          tabIndex: this.props.tabIndex,
          name: "buttonDropdown"
        }, /*#__PURE__*/external_react_default().createElement("span", {
          className: selectedItemClassName,
          name: "selectedItemName"
        }, displaySelectedItem), /*#__PURE__*/external_react_default().createElement("span", {
          className: "ion-md-arrow-dropdown",
          name: "dropDownArrow"
        }));
      }
      return /*#__PURE__*/external_react_default().createElement("div", {
        className: "tabbed-button-dropdown",
        tabIndex: this.props.tabIndex,
        name: "buttonDropdown",
        ref: function ref(dropdown) {
          _this5.dropdown = dropdown;
        },
        onKeyDown: this.onKeyDown,
        onClick: this.toggleDropdown,
        onBlur: this.onBlur
      }, /*#__PURE__*/external_react_default().createElement("span", {
        className: selectedItemClassName,
        name: "selectedItemName",
        onClick: function onClick(e) {
          _this5.props.onDisplayItemClick(selectedItem, e);
        }
      }, displaySelectedItem), /*#__PURE__*/external_react_default().createElement("span", {
        className: "ion-md-arrow-dropdown",
        name: "dropDownArrow"
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var dropdownIsVisible = this.state.dropdownIsActive;
      var className = "tabbed-dropdown " + this.props.className;
      var showLabel = this.props.label && this.props.label.length > 0;
      return /*#__PURE__*/external_react_default().createElement("div", {
        id: this.props.id,
        className: className,
        name: this.props.name
      }, showLabel && /*#__PURE__*/external_react_default().createElement("label", null, this.props.label), this.getDropDownButton(), dropdownIsVisible && this.getDropDown(), this.props.error && /*#__PURE__*/external_react_default().createElement("div", {
        className: "validate-error-message"
      }, this.props.error));
    }
  }]);
}((external_react_default()).Component);
DropDown.defaultProps = {
  onDisplayItemClick: function onDisplayItemClick() {},
  items: [],
  dataFieldName: "",
  titleFieldName: "",
  valueFieldName: "",
  className: "",
  selectedItemClassName: "",
  contentClassName: "blue",
  autoFocus: false,
  isDisabled: false
};
 false ? 0 : void 0;
/* harmony default export */ const DropDown_DropDown = (DropDown);
;// CONCATENATED MODULE: ./src/components/DropDown/index.js


/* harmony default export */ const components_DropDown = (DropDown_DropDown);

/***/ }),

/***/ 4937:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* unused harmony export Glyph */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9155);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1949);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);


var Glyph = function Glyph(_ref) {
  var iconClass = _ref.iconClass,
    iconName = _ref.iconName,
    divClass = _ref.divClass;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: divClass
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", {
    className: iconClass,
    "aria-hidden": "true",
    name: "glyph"
  }, iconName));
};
Glyph.defaultProps = {
  iconClass: "ion-ios-arrow-forward",
  divClass: "col-xs-1 col-md-1 rightLink"
};
 false ? 0 : void 0;
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Glyph);

/***/ }),

/***/ 7434:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* unused harmony export IconView */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9155);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1949);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _entities_Icon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8607);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3368);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _constants_SvgIcons__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8754);





var IconView = function IconView(_ref) {
  var icon = _ref.icon,
    className = _ref.className,
    name = _ref.name;
  if (!icon) return null;
  var iconContent, iconClass, ariaHidden, SvgIconComponent;
  switch (icon.iconType) {
    case _entities_Icon__WEBPACK_IMPORTED_MODULE_3__/* .IconTypes */ .B["default"]:
      iconClass = classnames__WEBPACK_IMPORTED_MODULE_2___default()(className, icon.name);
      iconContent = "";
      break;
    case _entities_Icon__WEBPACK_IMPORTED_MODULE_3__/* .IconTypes */ .B.material:
      iconClass = classnames__WEBPACK_IMPORTED_MODULE_2___default()("material-icons", className);
      iconContent = icon.name;
      ariaHidden = true;
      break;
    case _entities_Icon__WEBPACK_IMPORTED_MODULE_3__/* .IconTypes */ .B.jumpstart:
      iconClass = classnames__WEBPACK_IMPORTED_MODULE_2___default()(className, "wk-icon-" + icon.name);
      iconContent = "";
      break;
    case _entities_Icon__WEBPACK_IMPORTED_MODULE_3__/* .IconTypes */ .B.svg:
      iconClass = classnames__WEBPACK_IMPORTED_MODULE_2___default()("svg-icon", className);
      SvgIconComponent = _constants_SvgIcons__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A[icon.name];
      iconContent = SvgIconComponent ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(SvgIconComponent, null) : "";
      break;
    default:
      iconClass = className;
      iconContent = icon.name;
  }
  iconClass = classnames__WEBPACK_IMPORTED_MODULE_2___default()(iconClass, icon.extraClass);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", {
    className: iconClass,
    name: name,
    "aria-hidden": ariaHidden
  }, iconContent);
};
IconView.defaultProps = {
  name: "icon"
};
 false ? 0 : void 0;
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (IconView);

/***/ }),

/***/ 144:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* unused harmony export NavigationBar */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9155);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1949);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_router_dom__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4442);
/* harmony import */ var react_router_dom__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_router_dom__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3368);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }




var NavigationBar = /*#__PURE__*/function (_React$PureComponent) {
  function NavigationBar(props) {
    var _this;
    _classCallCheck(this, NavigationBar);
    _this = _callSuper(this, NavigationBar, [props]);
    _this.setFocus = _this.setFocus.bind(_this);
    return _this;
  }
  _inherits(NavigationBar, _React$PureComponent);
  return _createClass(NavigationBar, [{
    key: "setFocus",
    value: function setFocus() {
      if (this.backLinkRef) {
        this.backLinkRef.focus();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var extraComponentClassName = classnames__WEBPACK_IMPORTED_MODULE_3___default()(this.props.extraComponent ? "col-sm-2 col-xs-2" : "hidden-sm-down", "col-md-2");
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
        className: "base-content row",
        id: "pageTitle"
      }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
        ref: function ref(div) {
          return _this2.backLinkRef = div;
        },
        className: "col-xs-2 col-md-2 back-link",
        tabIndex: this.props.backLinkTabIndex,
        onKeyDown: this.props.onKeyDown,
        name: this.props.backLinkName
      }, this.props.backLink && this.props.hasRouter ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(BackNavLink, {
        backLink: this.props.backLink,
        onClick: this.props.onClick
      }) : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(BackHref, {
        disabled: this.props.disabled,
        onClick: this.props.onClick,
        backLink: this.props.backLink
      })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
        className: "col-xs-10 col-md-8"
      }, this.props.children, !this.props.children && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", {
        name: "navBarTitle"
      }, this.props.titleText)), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
        className: extraComponentClassName
      }, this.props.extraComponent ? this.props.extraComponent : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement((react__WEBPACK_IMPORTED_MODULE_0___default().Fragment), null, "\xA0")));
    }
  }]);
}((react__WEBPACK_IMPORTED_MODULE_0___default().PureComponent));
var BackNavLink = function BackNavLink(_ref) {
  var backLink = _ref.backLink,
    onClick = _ref.onClick;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(react_router_dom__WEBPACK_IMPORTED_MODULE_2__.NavLink, {
    to: backLink,
    activeClassName: "active",
    onClick: onClick,
    name: "navBarBackLink"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", {
    className: "ion-ios-arrow-back",
    "aria-hidden": "true"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", {
    className: "backText"
  }, "\xA0\xA0Back"));
};
 false ? 0 : void 0;
var BackHref = function BackHref(_ref2) {
  var onClick = _ref2.onClick,
    disabled = _ref2.disabled,
    backLink = _ref2.backLink;
  if (backLink) {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("a", {
      onClick: onClick,
      name: "navBarBackLink",
      className: disabled ? "back-link disabled" : "back-link",
      href: backLink
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", {
      className: "ion-ios-arrow-back",
      "aria-hidden": "true"
    }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", {
      className: "backText"
    }, "\xA0\xA0Back"));
  }
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("a", {
    onClick: onClick,
    name: "navBarBackLink",
    className: disabled ? "back-link disabled" : "back-link"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", {
    className: "ion-ios-arrow-back",
    "aria-hidden": "true"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", {
    className: "backText"
  }, "\xA0\xA0Back"));
};
 false ? 0 : void 0;
NavigationBar.defaultProps = {
  titleText: "",
  onClick: function onClick() {},
  onKeyDown: function onKeyDown() {},
  disabled: false,
  hasRouter: true,
  backLinkTabIndex: 0,
  backLinkName: ""
};
 false ? 0 : void 0;
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (NavigationBar);

/***/ }),

/***/ 7113:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ components_PendingButton)
});

// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__(9155);
var external_react_default = /*#__PURE__*/__webpack_require__.n(external_react_);
// EXTERNAL MODULE: external "prop-types"
var external_prop_types_ = __webpack_require__(1949);
// EXTERNAL MODULE: ./src/components/Button.jsx
var Button = __webpack_require__(9305);
// EXTERNAL MODULE: ./src/components/IconView/IconView.jsx
var IconView = __webpack_require__(7434);
// EXTERNAL MODULE: ./src/entities/Icon.js
var Icon = __webpack_require__(8607);
// EXTERNAL MODULE: ./src/components/PendingButton/_styles.scss
var _styles = __webpack_require__(7874);
;// CONCATENATED MODULE: ./src/components/PendingButton/PendingButton.jsx
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }






var PendingButton = /*#__PURE__*/function (_PureComponent) {
  function PendingButton(props) {
    var _this;
    _classCallCheck(this, PendingButton);
    _this = _callSuper(this, PendingButton, [props]);
    _this.setFocus = _this.setFocus.bind(_this);
    return _this;
  }
  _inherits(PendingButton, _PureComponent);
  return _createClass(PendingButton, [{
    key: "setFocus",
    value: function setFocus() {
      this.button.setFocus();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var buttonProps = {};
      buttonProps["disabled"] = this.props.disabled;
      buttonProps["autoFocus"] = this.props.autoFocus;
      buttonProps["id"] = this.props.id;
      buttonProps["name"] = this.props.name;
      var defaultClassName = this.props.className;
      var pendingClassName = "btn btn-loader throbberContainer";
      if (this.props.isPending) {
        defaultClassName = defaultClassName + " hiddenBtn";
        pendingClassName = pendingClassName + " btn-updating";
      } else {
        pendingClassName = pendingClassName + " hiddenBtn";
      }
      return /*#__PURE__*/external_react_default().createElement("div", {
        className: "btn-pending"
      }, /*#__PURE__*/external_react_default().createElement("div", {
        className: pendingClassName
      }, /*#__PURE__*/external_react_default().createElement("div", null), /*#__PURE__*/external_react_default().createElement("label", null, this.props.pendingTitle)), /*#__PURE__*/external_react_default().createElement(Button["default"], _extends({
        className: defaultClassName,
        onClick: this.props.onClick,
        onKeyDown: this.props.onKeyDown,
        tabIndex: this.props.tabIndex,
        ref: function ref(button) {
          _this2.button = button;
        }
      }, buttonProps), this.props.iconName && /*#__PURE__*/external_react_default().createElement(IconView/* default */.A, {
        icon: new Icon/* default */.A(this.props.iconName, Icon/* IconTypes */.B.material),
        className: this.props.iconClassName,
        name: this.props.iconName
      }), this.props.title));
    }
  }]);
}(external_react_.PureComponent);
PendingButton.defaultProps = {
  isPending: false,
  pendingTitle: "Saving",
  className: "btn btn-success update",
  onKeyDown: function onKeyDown() {}
};
 false ? 0 : void 0;
/* harmony default export */ const PendingButton_PendingButton = (PendingButton);
;// CONCATENATED MODULE: ./src/components/PendingButton/index.js

/* harmony default export */ const components_PendingButton = (PendingButton_PendingButton);

/***/ }),

/***/ 9124:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: () => (/* binding */ EditEmail)
});

// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__(9155);
var external_react_default = /*#__PURE__*/__webpack_require__.n(external_react_);
// EXTERNAL MODULE: external "prop-types"
var external_prop_types_ = __webpack_require__(1949);
// EXTERNAL MODULE: ./src/utilities/UserUtilities.js
var UserUtilities = __webpack_require__(9840);
// EXTERNAL MODULE: ./src/components/Profile/PendingEmail.jsx
var PendingEmail = __webpack_require__(1664);
// EXTERNAL MODULE: ./src/components/ActionButtonsPanel.js
var ActionButtonsPanel = __webpack_require__(1504);
// EXTERNAL MODULE: ./src/components/NavigationBar.jsx
var NavigationBar = __webpack_require__(144);
// EXTERNAL MODULE: ./src/utilities/OrganizationUtilities.js
var OrganizationUtilities = __webpack_require__(2000);
// EXTERNAL MODULE: ./src/constants/OrganizationTypeEnum.js
var OrganizationTypeEnum = __webpack_require__(9220);
;// CONCATENATED MODULE: ./src/entities/Product.js
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
var Product = /*#__PURE__*/_createClass(function Product(json) {
  _classCallCheck(this, Product);
  if (json) {
    this.id = json.Id;
    this.name = json.Name;
    this.order = json.Order;
    this.status = json.Status;
  }
});

// EXTERNAL MODULE: ./src/constants/OrganizationStatusEnum.js
var OrganizationStatusEnum = __webpack_require__(1486);
// EXTERNAL MODULE: ./src/utilities/SortingUtilities.js
var SortingUtilities = __webpack_require__(7609);
// EXTERNAL MODULE: ./src/entities/BaseClass.js
var BaseClass = __webpack_require__(39);
// EXTERNAL MODULE: ./src/constants/ProductEnum.js
var ProductEnum = __webpack_require__(4006);
;// CONCATENATED MODULE: ./src/entities/Organization.js
function Organization_typeof(o) { "@babel/helpers - typeof"; return Organization_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, Organization_typeof(o); }
function Organization_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function Organization_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, Organization_toPropertyKey(o.key), o); } }
function Organization_createClass(e, r, t) { return r && Organization_defineProperties(e.prototype, r), t && Organization_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function Organization_toPropertyKey(t) { var i = Organization_toPrimitive(t, "string"); return "symbol" == Organization_typeof(i) ? i : i + ""; }
function Organization_toPrimitive(t, r) { if ("object" != Organization_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != Organization_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == Organization_typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }







var Organization = /*#__PURE__*/function (_BaseClass) {
  function Organization(json) {
    var _this;
    Organization_classCallCheck(this, Organization);
    _this = _callSuper(this, Organization);
    _this.address = {};
    _this.contact = {};
    _this.virtualProductIdsOfOrganizationAndSubordinates = [];
    _this.virtualProducts = [];
    _this.virtualProductIds = [];
    _this.virtualContentIds = [];
    _this.isDarwinInfrastructure = false;
    _this.tags = [];
    _this.decommissionedDate = null;
    _this.isDecommissioned = false;
    _this.isReportProblemInSepsisMonitorEnabled = false;
    _this.sonicUCompanyId = null;
    if (json) mapJsonToOrganization(json, _this);
    return _this;
  }
  _inherits(Organization, _BaseClass);
  return Organization_createClass(Organization, [{
    key: "isP1S",
    value: function isP1S() {
      return this.type == OrganizationTypeEnum/* default */.A.P1S || !this.site;
    }
  }, {
    key: "isIDN",
    value: function isIDN() {
      return this.type == OrganizationTypeEnum/* default */.A.Parent;
    }
  }, {
    key: "isSuborganization",
    value: function isSuborganization() {
      return this.type == OrganizationTypeEnum/* default */.A.Subordinate;
    }
  }, {
    key: "isSeparateOrganization",
    value: function isSeparateOrganization() {
      return this.type == OrganizationTypeEnum/* default */.A.Separate;
    }
  }, {
    key: "addressString",
    get: function get() {
      if (this.address) {
        var city = this.address.city ? this.address.city.trim() : "";
        var state = this.address.state ? this.address.state.trim() : "";
        var delimiter = city && state ? ", " : "";
        return city + delimiter + state;
      }
      return "";
    }
  }, {
    key: "getAddressToJson",
    value: function getAddressToJson() {
      if (this.address) return {
        City: this.address.city,
        Street: this.address.street,
        State: this.address.state,
        ZipCode: this.address.zipCode
      };
      return {};
    }
  }, {
    key: "getAuthenticationType",
    value: function getAuthenticationType() {
      if (this.authenticationType) return (0,OrganizationUtilities/* getAuthenticationType */.Ds)(this.authenticationType);
      return null;
    }
  }, {
    key: "hasAccessToRuleManagement",
    get: function get() {
      return this.virtualProductIds.some(function (id) {
        return id == ProductEnum/* default */.A.RuleManagement.id;
      });
    }
  }, {
    key: "hasAccessToSimplifi",
    get: function get() {
      return this.virtualProductIds.some(function (id) {
        return id == Product.Simplifi.id;
      });
    }
  }, {
    key: "hasAccessToAnalytics",
    get: function get() {
      return this.virtualProductIds.some(function (id) {
        return id == Product.Analytics.id;
      });
    }
  }, {
    key: "isAvailableForRules",
    get: function get() {
      return this.hasAccessToRuleManagement && !this.isDisabled && this.status.value != OrganizationStatusEnum/* default */.A.Locked.value;
    }
  }, {
    key: "toJson",
    value: function toJson(user, provisioningProfile, selectedProductsIds, hydraGridNumber) {
      var json = {};
      json.Name = this.name;
      json.SiloNumber = this.silo;
      json.IsDarwinInfrastructure = this.isDarwinInfrastructure;
      if (user) {
        json.DefaultUserFirstName = user.firstName;
        json.DefaultUserLastName = user.lastName;
        json.DefaultUserEmail = user.email;
        json.DefaultUserPassword = user.password;
      }
      if (this.parentOrganizationId) json.ParentOrganizationId = this.parentOrganizationId;
      if (this.address) {
        json.Address = {
          City: this.address.city,
          Street: this.address.street,
          State: this.address.state,
          ZipCode: this.address.zipCode
        };
      }
      if (this.id) json.Id = this.id;
      if (provisioningProfile) {
        json.ProvisioningProfile = provisioningProfile.id;
      }
      if (hydraGridNumber) {
        json.HydraGridNumber = hydraGridNumber;
      }
      json.VirtualProductIds = selectedProductsIds || [];
      return json;
    }
  }]);
}(BaseClass/* default */.A);

var mapJsonToOrganization = function mapJsonToOrganization(json, organization) {
  organization.id = json.Id;
  organization.name = json.Name;
  organization.site = json.Site;
  organization.parentOrganizationId = json.ParentOrganizationId;
  organization.parentOrganizationName = json.ParentOrganizationName;
  organization.activeLocationsCount = json.ActiveSubordinateOrganizationsCount || 0;
  organization.virtualUsersCount = json.VirtualUsersCount || 0;
  organization.address = {};
  organization.contact = {};
  organization.authenticationType = json.AuthenticationType;
  organization.virtualProductIds = json.VirtualProductIds;
  organization.virtualContentIds = json.VirtualContentIds;
  organization.isReportProblemInSepsisMonitorEnabled = json.IsReportProblemInSepsisMonitorEnabled;
  organization.sonicUCompanyId = json.SonicUCompanyId;
  organization.isDisabled = json.IsDisabled;
  organization.isDecommissioned = json.IsDecommissioned;
  organization.decommissionedDate = json.DecommissionedDate;
  if (json.VirtualProductIdsOfOrganizationAndSubordinates) {
    organization.virtualProductIdsOfOrganizationAndSubordinates = [];
    json.VirtualProductIdsOfOrganizationAndSubordinates.forEach(function (item) {
      organization.virtualProductIdsOfOrganizationAndSubordinates.push(item);
    });
  }
  if (json.VirtualProducts) {
    organization.virtualProducts = [];
    json.VirtualProducts.forEach(function (item) {
      organization.virtualProducts.push(new Product(item));
    });
  }
  if (json.Type) {
    organization.type = (0,OrganizationUtilities/* getOrganizationType */.Iv)(json.Type);
  }
  if (json.Status) {
    organization.status = (0,OrganizationUtilities/* getOrganizationStatus */.AU)(json.Status);
  }
  if (json.Address) {
    organization.address = {
      city: json.Address.City,
      state: json.Address.State,
      street: json.Address.Street,
      zipCode: json.Address.ZipCode
    };
  }
  if (json.PrimaryContact) {
    organization.contact = {
      firstName: json.PrimaryContact.FirstName,
      lastName: json.PrimaryContact.LastName
    };
  }
  if (json.SiloView) {
    organization.silo = json.SiloView.Number;
    organization.isDarwinInfrastructure = !json.SiloView.Number;
  }
  if (json.Tags) organization.tags = json.Tags.sort(SortingUtilities/* sortByString */.NM).slice();
};
;// CONCATENATED MODULE: ./src/entities/Permission.js
function Permission_typeof(o) { "@babel/helpers - typeof"; return Permission_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, Permission_typeof(o); }
function Permission_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, Permission_toPropertyKey(o.key), o); } }
function Permission_createClass(e, r, t) { return r && Permission_defineProperties(e.prototype, r), t && Permission_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function Permission_toPropertyKey(t) { var i = Permission_toPrimitive(t, "string"); return "symbol" == Permission_typeof(i) ? i : i + ""; }
function Permission_toPrimitive(t, r) { if ("object" != Permission_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != Permission_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function Permission_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
var Permission = /*#__PURE__*/Permission_createClass(function Permission(json) {
  Permission_classCallCheck(this, Permission);
  if (json) {
    this.id = json.Id;
    this.name = json.Name;
  }
});

;// CONCATENATED MODULE: ./src/entities/UnverifiedEmail.js
function UnverifiedEmail_typeof(o) { "@babel/helpers - typeof"; return UnverifiedEmail_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, UnverifiedEmail_typeof(o); }
function UnverifiedEmail_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function UnverifiedEmail_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, UnverifiedEmail_toPropertyKey(o.key), o); } }
function UnverifiedEmail_createClass(e, r, t) { return r && UnverifiedEmail_defineProperties(e.prototype, r), t && UnverifiedEmail_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function UnverifiedEmail_toPropertyKey(t) { var i = UnverifiedEmail_toPrimitive(t, "string"); return "symbol" == UnverifiedEmail_typeof(i) ? i : i + ""; }
function UnverifiedEmail_toPrimitive(t, r) { if ("object" != UnverifiedEmail_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != UnverifiedEmail_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var UnverifiedEmail = /*#__PURE__*/function () {
  function UnverifiedEmail(json) {
    UnverifiedEmail_classCallCheck(this, UnverifiedEmail);
    this.email = "";
    this.activatedDateTime = undefined;
    this.canBeDiscarded = false;
    if (json) mapJsonToObj(json, this);
  }
  return UnverifiedEmail_createClass(UnverifiedEmail, [{
    key: "toJson",
    value: function toJson() {
      var json = {};
      mapObjToJson(this, json);
      return json;
    }
  }]);
}();

var mapJsonToObj = function mapJsonToObj(json, unverifiedEmail) {
  unverifiedEmail.email = json.Email;
  unverifiedEmail.activatedDateTime = json.ActivatedDateTime;
  unverifiedEmail.canBeDiscarded = json.CanBeDiscarded;
};
var mapObjToJson = function mapObjToJson(unverifiedEmail, json) {
  json.Email = unverifiedEmail.email;
  json.ActivatedDateTime = unverifiedEmail.activatedDateTime;
  json.CanBeDiscarded = unverifiedEmail.canBeDiscarded;
};
// EXTERNAL MODULE: ./src/utilities/ProductUtilities.js
var ProductUtilities = __webpack_require__(2500);
;// CONCATENATED MODULE: ./src/entities/Tag.js
function Tag_typeof(o) { "@babel/helpers - typeof"; return Tag_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, Tag_typeof(o); }
function Tag_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function Tag_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, Tag_toPropertyKey(o.key), o); } }
function Tag_createClass(e, r, t) { return r && Tag_defineProperties(e.prototype, r), t && Tag_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function Tag_toPropertyKey(t) { var i = Tag_toPrimitive(t, "string"); return "symbol" == Tag_typeof(i) ? i : i + ""; }
function Tag_toPrimitive(t, r) { if ("object" != Tag_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != Tag_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Tag = /*#__PURE__*/function () {
  function Tag(json) {
    Tag_classCallCheck(this, Tag);
    this.id = -1;
    this.name = "";
    if (json) this.fromJson(json, this);
  }
  return Tag_createClass(Tag, [{
    key: "fromJson",
    value: function fromJson(json, tag) {
      tag.id = json.Id;
      tag.name = json.Name;
    }
  }, {
    key: "createCopy",
    value: function createCopy() {
      var tag = new Tag();
      tag.id = this.id;
      tag.name = this.name;
    }
  }]);
}();

// EXTERNAL MODULE: ./src/entities/ExternalIdentifiers.js
var ExternalIdentifiers = __webpack_require__(3465);
;// CONCATENATED MODULE: ./src/entities/User.js
function User_typeof(o) { "@babel/helpers - typeof"; return User_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, User_typeof(o); }
function User_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function User_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, User_toPropertyKey(o.key), o); } }
function User_createClass(e, r, t) { return r && User_defineProperties(e.prototype, r), t && User_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function User_toPropertyKey(t) { var i = User_toPrimitive(t, "string"); return "symbol" == User_typeof(i) ? i : i + ""; }
function User_toPrimitive(t, r) { if ("object" != User_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != User_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function User_callSuper(t, o, e) { return o = User_getPrototypeOf(o), User_possibleConstructorReturn(t, User_isNativeReflectConstruct() ? Reflect.construct(o, e || [], User_getPrototypeOf(t).constructor) : o.apply(t, e)); }
function User_possibleConstructorReturn(t, e) { if (e && ("object" == User_typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return User_assertThisInitialized(t); }
function User_assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function User_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (User_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function User_getPrototypeOf(t) { return User_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, User_getPrototypeOf(t); }
function User_inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && User_setPrototypeOf(t, e); }
function User_setPrototypeOf(t, e) { return User_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, User_setPrototypeOf(t, e); }










var User = /*#__PURE__*/function (_BaseClass) {
  function User(json) {
    var _this;
    User_classCallCheck(this, User);
    _this = User_callSuper(this, User);
    _this.firstName = "";
    _this.lastName = "";
    _this.email = "";
    _this.externalUserId = "";
    _this.isVirtualSuperUser = false;
    _this.hasAccessToEntireIdn = false;
    _this.activeOrganizations = [];
    _this.assignedVirtualProducts = [];
    _this.permissions = [];
    _this.organizationId = 0;
    _this.organizationName = "";
    _this.virtualProfileId = 0;
    _this.authType = "";
    _this.isActive = true;
    _this.pin = "";
    _this.pendingEmail = undefined;
    _this.isEmailLoginEnabled = false;
    _this.tags = [];
    _this.externalIdentifiers = null;
    if (json) mapJsonToUser(json, _this);
    return _this;
  }
  User_inherits(User, _BaseClass);
  return User_createClass(User, [{
    key: "getInitials",
    value: function getInitials() {
      if (this.isSystem) return "P1";else return this.firstName.substring(0, 1) + this.lastName.substring(0, 1);
    }
  }, {
    key: "fullName",
    get: function get() {
      return this.firstName + " " + this.lastName;
    }
  }, {
    key: "hasUnverifiedEmail",
    get: function get() {
      return this.pendingEmail ? true : false;
    }
  }, {
    key: "toJson",
    value: function toJson() {
      var json = {};
      mapUserToJson(this, json);
      return json;
    }
  }, {
    key: "canChangeLocation",
    get: function get() {
      return this.isVirtualSuperUser === true || this.activeOrganizations.length > 1;
    }
  }, {
    key: "hasSurveillanceProducts",
    get: function get() {
      return this.assignedVirtualProducts.filter(function (product) {
        return (0,ProductUtilities/* isSurveillanceProduct */.ZV)(product.id);
      });
    }
  }, {
    key: "hasSafetyProducts",
    get: function get() {
      return this.assignedVirtualProducts.filter(function (product) {
        return (0,ProductUtilities/* isSafetyProduct */.ih)(product.id);
      });
    }
  }, {
    key: "hasTools",
    get: function get() {
      return this.assignedVirtualProducts.filter(function (product) {
        return (0,ProductUtilities/* isTools */.gL)(product.id);
      });
    }
  }]);
}(BaseClass/* default */.A);

var mapJsonToUser = function mapJsonToUser(json, user) {
  user.id = json.Id;
  user.externalUserId = json.ExternalUserId;
  user.firstName = json.FirstName;
  user.lastName = json.LastName;
  user.email = json.Email;
  user.isActive = json.IsActive;
  user.organizationId = json.OrganizationId;
  user.organizationName = json.OrganizationName;
  user.virtualProfileId = json.VirtualProfileId;
  user.virtualProfileName = json.VirtualProfileName;
  user.isVirtualSuperUser = json.IsVirtualSuperUser;
  user.hasAccessToEntireIdn = json.HasAccessToEntireIdn;
  user.activeOrganizations = [];
  user.authType = json.AuthenticationType;
  user.pin = json.Pin;
  user.isEmailLoginEnabled = json.IsEmailLoginEnabled;
  if (json.AssignedOrganizations) {
    user.activeOrganizations = json.AssignedOrganizations.map(function (item) {
      return new Organization(item);
    }).sort(SortingUtilities/* sortByName */.VV);
  }
  if (json.AssignedVirtualProducts) {
    json.AssignedVirtualProducts.forEach(function (item) {
      user.assignedVirtualProducts.push(new Product(item));
    });

    // TODO temporary
    if (json.HasAccessToUserManagement) {
      var userManagementProduct = new Product({
        Id: ProductEnum/* default */.A.UserManagement.id,
        Name: ProductEnum/* default */.A.UserManagement.name
      });
      user.assignedVirtualProducts.push(userManagementProduct);
    }
  }
  if (json.Permissions) {
    json.Permissions.forEach(function (item) {
      user.permissions.push(new Permission(item));
    });
  }
  if (json.PendingEmail) {
    user.pendingEmail = new UnverifiedEmail(json.PendingEmail);
  }
  if (json.Tags) {
    user.tags = json.Tags.map(function (tagJson) {
      return new Tag(tagJson);
    });
  }
  if (json.ExternalIdentifiers) {
    user.externalIdentifiers = new ExternalIdentifiers/* default */.A(json.ExternalIdentifiers);
  }
};
var mapUserToJson = function mapUserToJson(user, json) {
  json.Id = user.id;
  json.ExternalUserId = user.externalUserId;
  json.FirstName = user.firstName;
  json.LastName = user.lastName;
  json.Email = user.email;
  json.IsActive = user.isActive;
  json.OrganizationId = user.organizationId;
  json.OrganizationName = user.organizationName;
  json.VirtualProfileId = user.virtualProfileId;
  json.VirtualProfileName = user.virtualProfileName;
  json.IsVirtualSuperUser = user.isVirtualSuperUser;
  if (user.pendingEmail) {
    json.PendingEmail = user.pendingEmail.toJson();
  }
  if (user.externalIdentifiers) {
    json.ExternalIdentifiers = user.externalIdentifiers.toJson();
  }
  json.AssignedOrganizations = user.activeOrganizations.map(function (o) {
    return o.id;
  });
  json.AssignedVirtualProducts = user.assignedVirtualProducts.map(function (p) {
    return p.id;
  });
  json.Permissions = user.permissions.map(function (p) {
    return p.id;
  });
  json.Pin = user.pin;
  json.Tags = user.tags.map(function (p) {
    return p.id;
  });
};
// EXTERNAL MODULE: ./src/components/TextInput.jsx
var TextInput = __webpack_require__(7642);
// EXTERNAL MODULE: ./src/utilities/EventUtilities.js
var EventUtilities = __webpack_require__(5609);
;// CONCATENATED MODULE: ./src/components/Profile/EditEmail.jsx
function EditEmail_typeof(o) { "@babel/helpers - typeof"; return EditEmail_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, EditEmail_typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function EditEmail_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function EditEmail_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, EditEmail_toPropertyKey(o.key), o); } }
function EditEmail_createClass(e, r, t) { return r && EditEmail_defineProperties(e.prototype, r), t && EditEmail_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function EditEmail_callSuper(t, o, e) { return o = EditEmail_getPrototypeOf(o), EditEmail_possibleConstructorReturn(t, EditEmail_isNativeReflectConstruct() ? Reflect.construct(o, e || [], EditEmail_getPrototypeOf(t).constructor) : o.apply(t, e)); }
function EditEmail_possibleConstructorReturn(t, e) { if (e && ("object" == EditEmail_typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return EditEmail_assertThisInitialized(t); }
function EditEmail_assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function EditEmail_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (EditEmail_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function EditEmail_getPrototypeOf(t) { return EditEmail_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, EditEmail_getPrototypeOf(t); }
function EditEmail_inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && EditEmail_setPrototypeOf(t, e); }
function EditEmail_setPrototypeOf(t, e) { return EditEmail_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, EditEmail_setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = EditEmail_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function EditEmail_toPropertyKey(t) { var i = EditEmail_toPrimitive(t, "string"); return "symbol" == EditEmail_typeof(i) ? i : i + ""; }
function EditEmail_toPrimitive(t, r) { if ("object" != EditEmail_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != EditEmail_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }









var EditEmail = /*#__PURE__*/function (_PureComponent) {
  function EditEmail(props, context) {
    var _this;
    EditEmail_classCallCheck(this, EditEmail);
    _this = EditEmail_callSuper(this, EditEmail, [props, context]);
    _defineProperty(_this, "onChange", function (event) {
      var value = event.target.value;
      return _this.setState({
        newEmail: value
      });
    });
    _defineProperty(_this, "onBackClick", function () {
      _this.props.backToProfilePage();
    });
    _defineProperty(_this, "onSave", function () {
      var user = _this.state.user;
      var newEmail = _this.state.newEmail;
      if (user && newEmail !== undefined && _this.isValid(newEmail)) {
        Promise.resolve(_this.props.onVerifyUserEmail(user, newEmail, _this.context)).then(function () {
          _this.onBackClick();
        });
      } else if (newEmail === undefined) {
        _this.props.backToProfilePage();
      }
    });
    _defineProperty(_this, "onDiscardChanges", function () {
      var user = _this.state.user;
      _this.props.discardChanges(user);
    });
    _defineProperty(_this, "onResendVerificationEmail", function () {
      var user = _this.state.user;
      var unverifiedEmail = user.pendingEmail;
      _this.props.resendVerificationEmail(user, unverifiedEmail.email, _this.context);
    });
    _defineProperty(_this, "setFocusToEmail", function () {
      _this.emailRef.setFocus();
      _this.emailRef.select();
    });
    _defineProperty(_this, "onEmailKeyDown", function (event) {
      if ((0,EventUtilities/* isTabPressed */.Wz)(event) && (0,EventUtilities/* isShiftPressed */.Hk)(event)) {
        event.preventDefault();
        _this.buttonsRef.setFocus();
      }
    });
    var _newEmail = _this.props.newEmail;
    _this.state = {
      user: props.user,
      errors: {},
      newEmail: _newEmail ? _newEmail : undefined
    };
    return _this;
  }
  EditEmail_inherits(EditEmail, _PureComponent);
  return EditEmail_createClass(EditEmail, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.emailRef) this.setFocusToEmail();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.user !== this.props.user) {
        var user = _extends(new User(), this.props.user);
        this.setState({
          user: user
        });
      }
    }
  }, {
    key: "isValid",
    value: function isValid(newEmail) {
      var errors = {};
      var validationResult = UserUtilities/* Validation */.OH.isEmailValid(newEmail);
      errors.Email = validationResult.error;
      this.setState({
        errors: errors
      });
      return validationResult.isValid;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var user = this.state.user;
      var hasUnverifiedEmail = user.hasUnverifiedEmail && user.pendingEmail.canBeDiscarded;
      var title = user ? user.firstName + " " + user.lastName : "";
      var email = this.state.newEmail !== undefined ? this.state.newEmail : user.email;
      if (!email) email = "";
      var onBackClick = function onBackClick() {
        return _this2.props.backToProfilePage();
      };
      return /*#__PURE__*/external_react_default().createElement("div", {
        className: "form-container"
      }, /*#__PURE__*/external_react_default().createElement(NavigationBar["default"], {
        onClick: onBackClick,
        titleText: title,
        hasRouter: false
      }), /*#__PURE__*/external_react_default().createElement("div", {
        className: "base-content"
      }, /*#__PURE__*/external_react_default().createElement("div", {
        className: "form form-vertical"
      }, !hasUnverifiedEmail ? /*#__PURE__*/external_react_default().createElement("fieldset", null, /*#__PURE__*/external_react_default().createElement(TextInput["default"], {
        ref: function ref(_ref) {
          return _this2.emailRef = _ref;
        },
        name: "email",
        label: "Email",
        value: email,
        autoFocus: true,
        tabIndex: 1,
        onChange: this.onChange,
        disabled: false,
        onKeyDown: this.onEmailKeyDown,
        error: this.state.errors.Email,
        placeholder: "Enter Email",
        maxlength: 60
      }), /*#__PURE__*/external_react_default().createElement("div", {
        name: "note"
      }, "Note - Editing a user's email changes how they log in, so a verification email will be sent before finalizing any changes.")) : /*#__PURE__*/external_react_default().createElement("fieldset", null, /*#__PURE__*/external_react_default().createElement(PendingEmail/* default */.A, {
        currentEmail: user.email,
        unverifiedEmail: user.pendingEmail.email,
        discardChanges: this.onDiscardChanges,
        resendVerificationEmail: this.onResendVerificationEmail
      })), /*#__PURE__*/external_react_default().createElement(ActionButtonsPanel["default"], {
        ref: function ref(_ref2) {
          return _this2.buttonsRef = _ref2;
        },
        hasExternalFocus: true,
        moveFocusBack: this.setFocusToEmail,
        onSave: hasUnverifiedEmail ? this.onBackClick : this.onSave,
        onCancel: this.onBackClick
      }))));
    }
  }]);
}(external_react_.PureComponent);

 false ? 0 : void 0;

/***/ }),

/***/ 6271:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (/* binding */ EditInfo)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9155);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1949);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _LastName__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(3206);
/* harmony import */ var _utilities_UserUtilities__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9840);
/* harmony import */ var _NavigationBar__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(144);
/* harmony import */ var _utilities_EventUtilities__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5609);
/* harmony import */ var _ActionButtonsPanel__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1504);
/* harmony import */ var _TextInput__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7642);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }









var EditInfo = /*#__PURE__*/function (_PureComponent) {
  function EditInfo(props, context) {
    var _this;
    _classCallCheck(this, EditInfo);
    _this = _callSuper(this, EditInfo, [props, context]);
    _defineProperty(_this, "onChange", function (event) {
      var field = event.target.name;
      var newState = {};
      newState[field] = event.target.value;
      _this.setState(newState);
    });
    _defineProperty(_this, "onSave", function () {
      if (_this.infoIsValid()) {
        var newUser = _this.props.user.createCopy();
        newUser.firstName = _this.state.firstName;
        newUser.lastName = _this.state.lastName;
        Promise.resolve(_this.props.updateCurrentUser(newUser, _this.context)).then(function () {
          _this.props.backToProfilePage();
        });
      }
    });
    _this.state = {
      firstName: props.user.firstName,
      lastName: props.user.lastName,
      errors: {}
    };
    _this.onCancelTab = _this.onCancelTab.bind(_this);
    _this.isAcceptableKey = _this.isAcceptableKey.bind(_this);
    _this.onFirstNamePressed = _this.onFirstNamePressed.bind(_this);
    return _this;
  }
  _inherits(EditInfo, _PureComponent);
  return _createClass(EditInfo, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.firstNameRef) {
        this.firstNameRef.setFocus();
        this.firstNameRef.select();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.user != this.props.user) {
        var firstName = this.state.firstName;
        var lastName = this.state.lastName;
        this.setState({
          firstName: firstName,
          lastName: lastName
        });
      }
    }
  }, {
    key: "infoIsValid",
    value: function infoIsValid() {
      var errors = {};
      var formIsValid = true;
      var validationResult = _utilities_UserUtilities__WEBPACK_IMPORTED_MODULE_2__/* .Validation */ .OH.isNameValid(this.state.firstName);
      errors.FirstName = validationResult.error;
      formIsValid = formIsValid && validationResult.isValid;
      validationResult = _utilities_UserUtilities__WEBPACK_IMPORTED_MODULE_2__/* .Validation */ .OH.isNameValid(this.state.lastName);
      errors.LastName = validationResult.error;
      formIsValid = formIsValid && validationResult.isValid;
      this.setState({
        errors: errors
      });
      return formIsValid;
    }
  }, {
    key: "onFirstNamePressed",
    value: function onFirstNamePressed(event) {
      if ((0,_utilities_EventUtilities__WEBPACK_IMPORTED_MODULE_3__/* .isTabPressed */ .Wz)(event) && (0,_utilities_EventUtilities__WEBPACK_IMPORTED_MODULE_3__/* .isShiftPressed */ .Hk)(event)) {
        event.preventDefault();
        this.buttonsRef.setFocus();
      }
    }
  }, {
    key: "isAcceptableKey",
    value: function isAcceptableKey(event) {
      if (!(0,_utilities_EventUtilities__WEBPACK_IMPORTED_MODULE_3__/* .isLiteralKeyFromEvent */ .fZ)(event)) {
        event.preventDefault();
      }
    }
  }, {
    key: "onCancelTab",
    value: function onCancelTab() {
      this.firstNameRef.setFocus();
      this.firstNameRef.select();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var onBackClick = function onBackClick() {
        return _this2.props.backToProfilePage();
      };
      var title = this.state.firstName + " " + this.state.lastName;
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
        className: "form-container"
      }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_NavigationBar__WEBPACK_IMPORTED_MODULE_4__["default"], {
        onClick: onBackClick,
        titleText: title,
        hasRouter: false
      }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
        className: "base-content"
      }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
        className: "form form-vertical"
      }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("legend", null, "Profile"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
        className: "form form-vertical"
      }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("fieldset", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_TextInput__WEBPACK_IMPORTED_MODULE_5__["default"], {
        ref: function ref(_ref) {
          return _this2.firstNameRef = _ref;
        },
        name: "firstName",
        label: "First Name",
        tabIndex: 1,
        value: this.state.firstName,
        autoFocus: true,
        onChange: this.onChange,
        error: this.state.errors.FirstName,
        disabled: false,
        onKeyDown: this.onFirstNamePressed,
        onKeyPress: this.isAcceptableKey,
        placeholder: "Enter First Name",
        maxlength: 30
      }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_LastName__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A, {
        tabIndex: 1,
        value: this.state.lastName,
        onChange: this.onChange,
        error: this.state.errors.LastName,
        onKeyPress: this.isAcceptableKey
      })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_ActionButtonsPanel__WEBPACK_IMPORTED_MODULE_7__["default"], {
        hasExternalFocus: true,
        ref: function ref(_ref2) {
          return _this2.buttonsRef = _ref2;
        },
        onSave: this.onSave,
        onCancel: onBackClick,
        moveFocusBack: this.onCancelTab
      })))));
    }
  }]);
}(react__WEBPACK_IMPORTED_MODULE_0__.PureComponent);

 false ? 0 : void 0;

/***/ }),

/***/ 4927:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9155);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1949);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _TextInput__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7642);



var Email = function Email(_ref) {
  var value = _ref.value,
    error = _ref.error,
    onChange = _ref.onChange,
    disabled = _ref.disabled,
    tabIndex = _ref.tabIndex,
    autoFocus = _ref.autoFocus,
    onKeyPress = _ref.onKeyPress;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_TextInput__WEBPACK_IMPORTED_MODULE_2__["default"], {
    name: "email",
    label: "Email",
    value: value,
    autoFocus: autoFocus,
    tabIndex: tabIndex,
    onChange: onChange,
    disabled: disabled,
    onKeyPress: onKeyPress,
    error: error,
    placeholder: "Enter Email",
    maxlength: 60
  });
};
 false ? 0 : void 0;
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Email);

/***/ }),

/***/ 9380:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9155);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1949);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _TextInput__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7642);



var FirstName = function FirstName(_ref) {
  var value = _ref.value,
    error = _ref.error,
    onChange = _ref.onChange,
    onKeyPress = _ref.onKeyPress,
    disabled = _ref.disabled,
    tabIndex = _ref.tabIndex,
    autoFocus = _ref.autoFocus;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_TextInput__WEBPACK_IMPORTED_MODULE_2__["default"], {
    name: "firstName",
    label: "First Name",
    tabIndex: tabIndex,
    value: value,
    autoFocus: autoFocus,
    onChange: onChange,
    error: error,
    disabled: disabled,
    onKeyPress: onKeyPress,
    placeholder: "Enter First Name",
    maxlength: 30
  });
};
 false ? 0 : void 0;
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (FirstName);

/***/ }),

/***/ 3206:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9155);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1949);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _TextInput__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7642);



var LastName = function LastName(_ref) {
  var value = _ref.value,
    error = _ref.error,
    onChange = _ref.onChange,
    onKeyPress = _ref.onKeyPress,
    disabled = _ref.disabled,
    tabIndex = _ref.tabIndex,
    autoFocus = _ref.autoFocus;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_TextInput__WEBPACK_IMPORTED_MODULE_2__["default"], {
    name: "lastName",
    label: "Last Name",
    value: value,
    autoFocus: autoFocus,
    tabIndex: tabIndex,
    onChange: onChange,
    error: error,
    onKeyPress: onKeyPress,
    disabled: disabled,
    placeholder: "Enter Last Name",
    maxlength: 30
  });
};
 false ? 0 : void 0;
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (LastName);

/***/ }),

/***/ 1546:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: () => (/* binding */ Profile_LocationList)
});

// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__(9155);
var external_react_default = /*#__PURE__*/__webpack_require__.n(external_react_);
// EXTERNAL MODULE: external "prop-types"
var external_prop_types_ = __webpack_require__(1949);
;// CONCATENATED MODULE: ./src/components/Profile/LocationsConfiguration.js
var LocationsConfiguration = {
  entireHealthSystemMessage: "Entire Health System",
  noLocationsMessage: "NONE",
  userLocationsTableOptions: {
    defaultSortName: "name",
    defaultSortOrder: "asc"
  }
};
/* harmony default export */ const Profile_LocationsConfiguration = (LocationsConfiguration);
;// CONCATENATED MODULE: ./src/components/Profile/LocationList.jsx




var LocationList = function LocationList(_ref) {
  var hasAccessToEntireIdn = _ref.hasAccessToEntireIdn,
    userOrganizations = _ref.userOrganizations,
    className = _ref.className;
  function getLocationName(location) {
    return /*#__PURE__*/external_react_default().createElement("span", null, location.name, " - ", location.site);
  }
  function getLocationString() {
    if (!userOrganizations || userOrganizations.length === 0) return Profile_LocationsConfiguration.noLocationsMessage;
    if (hasAccessToEntireIdn) return Profile_LocationsConfiguration.entireHealthSystemMessage;
    if (userOrganizations.length == 1) return getLocationName(userOrganizations[0]);
    return userOrganizations.length + " Locations";
  }
  return /*#__PURE__*/external_react_default().createElement("div", {
    className: className
  }, /*#__PURE__*/external_react_default().createElement("span", {
    className: "dark"
  }, getLocationString()));
};
 false ? 0 : void 0;
/* harmony default export */ const Profile_LocationList = (LocationList);

/***/ }),

/***/ 1664:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9155);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1949);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9305);



var PendingEmail = function PendingEmail(_ref) {
  var currentEmail = _ref.currentEmail,
    unverifiedEmail = _ref.unverifiedEmail,
    discardChanges = _ref.discardChanges,
    resendVerificationEmail = _ref.resendVerificationEmail;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("label", null, "Email"))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    id: "modal-gray",
    className: "card"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "card-body"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("label", null, "Unverified Email Address"))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    name: "note"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", null, "This users's email address has been changed, but is unverified. The user must verify their email address by clicking a secure link sent to them to confirm changes.")), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    name: "currentEmail"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", null, "Previous Email: ", /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", {
    name: "currentEmail"
  }, currentEmail))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    name: "pendingEmail"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", null, "New Email: ", /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", {
    name: "unverifiedEmail"
  }, unverifiedEmail))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_Button__WEBPACK_IMPORTED_MODULE_2__["default"], {
    id: "discard-button",
    className: "btn btn-info",
    title: "Discard this Change",
    onClick: discardChanges
  })), "\xA0", /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_Button__WEBPACK_IMPORTED_MODULE_2__["default"], {
    id: "resend-button",
    className: "btn btn-info",
    title: "Resend Verification Email",
    onClick: resendVerificationEmail
  }))))));
};
 false ? 0 : void 0;
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (PendingEmail);

/***/ }),

/***/ 2898:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: () => (/* binding */ Profile_ProductsList)
});

// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__(9155);
var external_react_default = /*#__PURE__*/__webpack_require__.n(external_react_);
// EXTERNAL MODULE: external "prop-types"
var external_prop_types_ = __webpack_require__(1949);
// EXTERNAL MODULE: ./src/components/IconView/IconView.jsx
var IconView = __webpack_require__(7434);
// EXTERNAL MODULE: ./src/utilities/ProductUtilities.js
var ProductUtilities = __webpack_require__(2500);
;// CONCATENATED MODULE: ./src/components/Profile/ProductItem.jsx




var ProductItem = function ProductItem(_ref) {
  var productId = _ref.productId;
  var productConfiguration = (0,ProductUtilities/* getProductConfigurationById */.OI)(productId);
  return productConfiguration && /*#__PURE__*/external_react_default().createElement("li", null, /*#__PURE__*/external_react_default().createElement("div", {
    className: "checkbox-icon icon-product " + productConfiguration.iconContainerClass
  }, /*#__PURE__*/external_react_default().createElement(IconView/* default */.A, {
    icon: productConfiguration.icon
  })), /*#__PURE__*/external_react_default().createElement("span", {
    className: "dark"
  }, productConfiguration.label));
};
 false ? 0 : void 0;
/* harmony default export */ const Profile_ProductItem = (ProductItem);
;// CONCATENATED MODULE: ./src/components/Profile/ProductsList.jsx



var ProductsList = function ProductsList(_ref) {
  var className = _ref.className,
    products = _ref.products;
  var noProducts = !products || products.length === 0;
  return /*#__PURE__*/external_react_default().createElement("div", {
    className: className
  }, !noProducts && /*#__PURE__*/external_react_default().createElement("ul", {
    className: "productsList"
  }, products.map(function (productId) {
    return /*#__PURE__*/external_react_default().createElement(Profile_ProductItem, {
      key: productId,
      productId: productId
    });
  })), noProducts && /*#__PURE__*/external_react_default().createElement("span", {
    className: "dark"
  }, "None"));
};
ProductsList.defaultProps = {
  products: []
};
 false ? 0 : void 0;
/* harmony default export */ const Profile_ProductsList = (ProductsList);

/***/ }),

/***/ 860:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* unused harmony export showParts */
var showParts = {
  details: 1,
  editName: 2,
  editEmail: 3,
  editExternalIds: 4
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (showParts);

/***/ }),

/***/ 8201:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9155);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1949);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3368);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Glyph__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4937);




var Row = function Row(_ref) {
  var children = _ref.children,
    rowPart = _ref.rowPart,
    onClick = _ref.onClick,
    editable = _ref.editable;
  var rowEnabledClassName = "row row-link enabled";
  var rowDisabledClassName = "row row-link inactive";
  var rowClassName = editable ? rowEnabledClassName : rowDisabledClassName;
  var labelClassName = "col-xs-2 col-md-3 NameColumn";
  var iconClass = classnames__WEBPACK_IMPORTED_MODULE_2___default()("iconLabel", rowPart.iconClassName || "");
  var getIcon = function getIcon() {
    return rowPart.material ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", {
      className: "iconLabel material-icons"
    }, rowPart.material) : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", {
      className: iconClass
    });
  };
  var onEdit = function onEdit() {
    if (editable) {
      onClick(rowPart);
    }
  };
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: rowClassName,
    onClick: onEdit,
    id: rowPart.id
  }, rowPart.label && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: labelClassName
  }, getIcon(), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", {
    className: "light"
  }, rowPart.label)), children, editable ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_Glyph__WEBPACK_IMPORTED_MODULE_3__["default"], {
    iconClass: rowPart.rightLinkIconClass,
    iconName: rowPart.rightLinkIconName
  }) : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "col-xs-1 col-md-1"
  }));
};
Row.defaultProps = {
  editable: true,
  rowPart: {}
};
 false ? 0 : void 0;
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Row);

/***/ }),

/***/ 7642:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* unused harmony export TextInput */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9155);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1949);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }


var TextInput = /*#__PURE__*/function (_Component) {
  function TextInput(props, context) {
    var _this;
    _classCallCheck(this, TextInput);
    _this = _callSuper(this, TextInput, [props, context]);
    _this.setFocus = _this.setFocus.bind(_this);
    return _this;
  }
  _inherits(TextInput, _Component);
  return _createClass(TextInput, [{
    key: "setFocus",
    value: function setFocus() {
      this.textInput.focus();
    }
  }, {
    key: "select",
    value: function select() {
      this.textInput.select();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var wrapperClass = "form-group";
      if (this.props.error && this.props.error.length > 0 || this.props.isInvalid) {
        wrapperClass += " " + "has-error";
      }
      if (this.props.className) wrapperClass += " " + this.props.className;
      var inputProps = {};
      inputProps["disabled"] = this.props.disabled;
      inputProps["autoFocus"] = this.props.autoFocus;
      if (this.props.readonly) {
        inputProps["readOnly"] = this.props.readonly;
      }
      if (this.props.autoComplete !== undefined) inputProps["autoComplete"] = this.props.autoComplete ? "on" : "off";
      var componentName = this.props.name + "Field";
      var labelId = this.props.name + "Label";
      var inputId = this.props.name + "Input";
      var inputType = this.props.isPassword ? "password" : "text";
      var inputFinalClassName = this.props.inputClassName ? "form-control " + this.props.inputClassName : "form-control";
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
        className: wrapperClass,
        name: componentName
      }, this.props.label && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("label", {
        id: labelId,
        htmlFor: this.props.name
      }, this.props.label), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("input", _extends({
        id: inputId,
        type: inputType,
        ref: function ref(input) {
          _this2.textInput = input;
        },
        name: this.props.name,
        tabIndex: this.props.tabIndex,
        className: inputFinalClassName,
        placeholder: this.props.placeholder,
        maxLength: this.props.maxlength,
        value: this.props.value
      }, inputProps, {
        onChange: this.props.onChange,
        onKeyPress: this.props.onKeyPress,
        onKeyDown: this.props.onKeyDown,
        onFocus: this.props.onFocus,
        onBlur: this.props.onBlur,
        size: "",
        "aria-describedby": this.props.ariaDescribedBy,
        "aria-labelledby": this.props.ariaLabelledBy
      })), this.props.error && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
        className: "validate-error-message"
      }, this.props.error));
    }
  }]);
}(react__WEBPACK_IMPORTED_MODULE_0__.Component);
TextInput.defaultProps = {
  isInvalid: false
};
 false ? 0 : void 0;
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (TextInput);

/***/ }),

/***/ 9778:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ components_UnverifiedEmailControl)
});

// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__(9155);
var external_react_default = /*#__PURE__*/__webpack_require__.n(external_react_);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(3368);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: external "prop-types"
var external_prop_types_ = __webpack_require__(1949);
;// CONCATENATED MODULE: ./src/utilities/DateUtilities.js
var formatDate = function formatDate(date, options) {
  var isUtc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return formatDateTime("toLocaleDateString", date, options, isUtc);
};
var formatTime = function formatTime(time, options) {
  var isUtc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return formatDateTime("toLocaleTimeString", time, options, isUtc);
};
var addDays = function addDays(date, daysCount) {
  date.setDate(date.getDate() + daysCount);
  return date;
};
var formatDateTime = function formatDateTime(methodName, date, options, isUtc) {
  if (isUtc) {
    date = date + "Z";
  }
  var d = new Date(date);
  if (isNaN(d)) return "";
  return d[methodName]("en-US", options).replace(",", "").replace(new RegExp(String.fromCharCode(8206), "g"), ""); // https://www.csgpro.com/blog/2016/08/a-bad-date-with-internet-explorer-11-trouble-with-new-unicode-characters-in-javascript-date-strings
};
var isYearly = function isYearly(frequencyInMonth) {
  return frequencyInMonth % 12 === 0;
};
var isMonthly = function isMonthly(frequencyInMonth) {
  return frequencyInMonth % 12 !== 0;
};
var getYearsFromMonths = function getYearsFromMonths(frequencyInMonth) {
  return frequencyInMonth / 12;
};
var getTimeMinutes = function getTimeMinutes(dueTime) {
  var timeArr = dueTime.split(":");
  var hours = timeArr[0];
  var minutes = timeArr[1];
  var minutesCount = 60 * hours + 1 * minutes;
  return minutesCount;
};
var getTimeFromMinutes = function getTimeFromMinutes(time) {
  var hours = Math.floor(time / 60);
  hours = hours < 10 ? "0" + hours : hours;
  var minutes = time % 60;
  minutes = minutes < 10 ? "0" + minutes : minutes;
  var formattedTime = hours + ":" + minutes;
  return formattedTime;
};
var showDate = function showDate(date) {
  if (!date || isNaN(date)) return "";
  var dd = date.getDate();
  if (isNaN(dd)) return "";
  if (dd < 10) dd = "0" + dd;
  var mm = date.getMonth() + 1;
  if (mm < 10) mm = "0" + mm;
  var yy = date.getFullYear();
  return mm + "/" + dd + "/" + yy;
};
var parseDate = function parseDate(date) {
  var result = Date.parse(date);
  if (result) return new Date(result);
  return undefined;
};
;// CONCATENATED MODULE: ./src/components/UnverifiedEmailControl.jsx





var UnverifiedEmailControl = function UnverifiedEmailControl(_ref) {
  var user = _ref.user,
    resendVerificationEmail = _ref.resendVerificationEmail,
    sentRecently = _ref.sentRecently,
    waitForSend = _ref.waitForSend;
  if (!user) return null;
  var hasUnverifiedEmail = user.hasUnverifiedEmail;
  if (!hasUnverifiedEmail) return null;
  var options = {
    month: "2-digit",
    day: "2-digit",
    year: "numeric"
  };
  return /*#__PURE__*/external_react_default().createElement("div", {
    className: "notification-container"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: "notification-block"
  }, /*#__PURE__*/external_react_default().createElement("h5", {
    className: "user-header"
  }, "Unverified Email Address"), sentRecently ? /*#__PURE__*/external_react_default().createElement("span", {
    name: "sent-just",
    className: "card-text"
  }, "Verification email was just sent") : user.pendingEmail.activatedDateTime && /*#__PURE__*/external_react_default().createElement("span", {
    name: "sent-note",
    className: "card-text"
  }, "Verification email was sent on", /*#__PURE__*/external_react_default().createElement("span", {
    name: "sent-date"
  }, " " + formatDate(user.pendingEmail.activatedDateTime, options, true)))), /*#__PURE__*/external_react_default().createElement("div", {
    className: "notification-block button-block"
  }, sentRecently ? /*#__PURE__*/external_react_default().createElement("span", {
    className: "notification-sent"
  }, /*#__PURE__*/external_react_default().createElement("span", {
    className: "ion-md-checkmark"
  }, "\xA0"), /*#__PURE__*/external_react_default().createElement("span", {
    name: "verification-note"
  }, "Verification Sent")) : /*#__PURE__*/external_react_default().createElement("a", {
    name: "verification-button",
    href: "#",
    className: classnames_default()("btn btn-primary", {
      "disabled": waitForSend
    }),
    onClick: resendVerificationEmail
  }, "Resend Verification")));
};
 false ? 0 : void 0;
/* harmony default export */ const components_UnverifiedEmailControl = (UnverifiedEmailControl);

/***/ }),

/***/ 4143:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Ay: () => (__WEBPACK_DEFAULT_EXPORT__),
/* harmony export */   Rl: () => (/* binding */ getAuthenticationTypeByValue)
/* harmony export */ });
/* unused harmony export AuthenticationTypeEnum */
var AuthenticationTypeEnum = {
  User: {
    value: "User",
    label: "Site/User/Password",
    text: "Site/User/Password",
    description: "Users log in with site number, user number, and password.",
    iconClass: "material-icons",
    materialIcon: "settings_input_component"
  },
  Sso: {
    value: "Sso",
    label: "Single Sign-On",
    text: "SSO",
    description: "Users log in using credentials managed by their organization.",
    iconClass: "material-icons",
    materialIcon: "vpn_key"
  },
  Password: {
    value: "Password",
    label: "Password",
    text: "Password",
    description: "Users log in using passwords they create and manage themselves.",
    iconClass: "material-icons",
    materialIcon: "lock"
  }
};
var getAuthenticationTypeByValue = function getAuthenticationTypeByValue(value) {
  var authenticationType = null;
  switch (value) {
    case AuthenticationTypeEnum.User.value:
      authenticationType = AuthenticationTypeEnum.User;
      break;
    case AuthenticationTypeEnum.Sso.value:
      authenticationType = AuthenticationTypeEnum.Sso;
      break;
    case AuthenticationTypeEnum.Password.value:
      authenticationType = AuthenticationTypeEnum.Password;
      break;
  }
  return authenticationType;
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (AuthenticationTypeEnum);

/***/ }),

/***/ 1486:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* unused harmony export OrganizationStatusEnum */
var OrganizationStatusEnum = {
  Active: {
    value: "Active",
    label: "Active"
  },
  Locked: {
    value: "Locked",
    label: "Locked"
  },
  SuperUsersOnly: {
    value: "SuperUsersOnly",
    label: "Superuser Only"
  }
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (OrganizationStatusEnum);

/***/ }),

/***/ 9220:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* unused harmony export OrganizationTypeEnum */
var OrganizationTypeEnum = {
  Separate: "separate",
  Subordinate: "subordinate",
  Parent: "parent",
  P1S: "p1s"
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (OrganizationTypeEnum);

/***/ }),

/***/ 4006:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* unused harmony export ProductEnum */
/* harmony import */ var _entities_Icon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8607);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9155);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _ProductTypeEnum__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2382);



var productIds = {
  pharmacyProductId: 1,
  quantifyProductId: 2,
  infectionPreventionProductId: 3,
  veriFormProductId: 4,
  ruleProductId: 5,
  analyticsProductId: 6,
  simplifiProductId: 7,
  pocAdvisorProductId: 8,
  medStorageProductId: 9,
  sepsisMonitorProductId: 10,
  medTraysProductId: 11,
  patientDecompensationId: 12,
  documentationProductId: 13,
  aurReportingProductId: 14,
  flowlyticsProductId: 15,
  ivWorkflowProductId: 16,
  userManagementProductId: 99,
  superUserProductId: 101
};

// structure of enum:
//         id -  product id in Identifi, should be the same in all applications
//         name -  name of product,
//         abbreviation -
//         type - type of product (for grouping),
//         icon - object of type Icon like new Icon("icon-pill"),
//         iconContainerClass - class of patent element,
//         label - visible product name in left menu (if there is no override in "leftMenuLabel") and in Product Selector in Identifi,
//         iconClass - string of icon class name in Identifi (Product Selector),
//         iconName - string of icon name in Identifi (Product Selector),
//         tileClassName - class name for tile in Identifi Product Selector,
//         leftMenuLabel - visible product name in left menu
//         ariaLabel - aria-label attribute
var ProductEnum = {
  Pharmacy: {
    id: productIds.pharmacyProductId,
    name: "Sentri7 Pharmacy",
    abbreviation: "s7",
    type: _ProductTypeEnum__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A.surveillance,
    icon: new _entities_Icon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A("icon-pill"),
    iconContainerClass: "icon-product",
    label: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", null, "Pharmacy"),
    iconClass: "custom-icon icon-pill",
    tileClassName: "pharmacy"
  },
  Quantifi: {
    id: productIds.quantifyProductId,
    name: "Quantifi",
    abbreviation: "q",
    type: _ProductTypeEnum__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A.surveillance,
    icon: new _entities_Icon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A("ion-md-stats"),
    iconContainerClass: "icon-product",
    iconClass: "icon ion-stats-bars",
    tileClassName: "quantifi",
    label: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", null, "Quantifi", /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("sup", null, "\xAE"))
  },
  InfectionPrevention: {
    id: productIds.infectionPreventionProductId,
    name: "Sentri7 Infection Prevention",
    abbreviation: "s7",
    type: _ProductTypeEnum__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A.surveillance,
    icon: new _entities_Icon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A("ion-md-bug"),
    iconContainerClass: "icon-product",
    iconClass: "icon bug_report",
    tileClassName: "ip",
    label: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", null, "Infection Prevention")
  },
  Veriform: {
    id: productIds.veriFormProductId,
    name: "Veriform",
    abbreviation: "v",
    type: _ProductTypeEnum__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A.safety,
    icon: new _entities_Icon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A("ion-md-clipboard"),
    iconContainerClass: "icon-product",
    iconClass: "custom-icon list-alt--outline",
    tileClassName: "veriform",
    label: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", null, "VeriForm", /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("sup", null, "\xAE"))
  },
  Simplifi: {
    id: productIds.simplifiProductId,
    name: "Simplifi 797",
    abbreviation: "s",
    type: _ProductTypeEnum__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A.safety,
    icon: new _entities_Icon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A("icon-syringe"),
    iconContainerClass: "icon-product",
    iconClass: "icon-syringe",
    tileClassName: "simplifi",
    label: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", null, "Simplifi 797", /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("sup", null, "\xAE"))
  },
  Analytics: {
    id: productIds.analyticsProductId,
    name: "Analytics",
    abbreviation: "a",
    type: _ProductTypeEnum__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A.tools,
    icon: new _entities_Icon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A("ion-md-pulse"),
    iconContainerClass: "permission-analytics",
    iconClass: "icon ion-ios-pulse-strong",
    tileClassName: "analytics",
    label: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", null, "Analytics")
  },
  UserManagement: {
    id: productIds.userManagementProductId,
    name: "Settings & User Management",
    abbreviation: "cm",
    type: _ProductTypeEnum__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A.tools,
    icon: new _entities_Icon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A("icon-cogs"),
    iconContainerClass: "permission-userManagement",
    iconClass: "icon settings",
    tileClassName: "admin",
    label: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", null, "Settings & User Management")
  },
  RuleManagement: {
    id: productIds.ruleProductId,
    name: "Rules Management",
    abbreviation: "rm",
    type: _ProductTypeEnum__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A.tools,
    icon: new _entities_Icon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A("widgets"),
    iconContainerClass: "permission-ruleManagement",
    iconClass: "icon widgets",
    tileClassName: "rules",
    label: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", null, "Rules Management")
  },
  PocAdvisor: {
    id: productIds.pocAdvisorProductId,
    name: "POC Advisor",
    abbreviation: "pa",
    type: _ProductTypeEnum__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A.surveillance,
    icon: new _entities_Icon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A("flag"),
    iconContainerClass: "icon-product",
    iconClass: "icon flag",
    tileClassName: "pocadvisor",
    label: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", null, "POC Advisor", /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("sup", null, "\xAE"))
  },
  SuperUser: {
    id: productIds.superUserProductId,
    name: "Super User",
    abbreviation: "",
    type: _ProductTypeEnum__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A.tools,
    icon: new _entities_Icon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A("ion-ios-color-wand"),
    iconContainerClass: "icon-product",
    iconClass: "icon ion-ios-color-wand",
    tileClassName: "superuser",
    label: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", null, "Super User")
  },
  MedStorage: {
    id: productIds.medStorageProductId,
    name: "Simplifi+ MedStorage",
    abbreviation: "m",
    type: _ProductTypeEnum__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A.safety,
    icon: new _entities_Icon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A("checklist"),
    iconContainerClass: "icon-product",
    iconClass: "checklist",
    tileClassName: "med-storage",
    label: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", null, "Simplifi+", /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("sup", null, "\xAE"), " MedStorage"),
    leftMenuLabel: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", null, "MedStorage"),
    ariaLabel: "Simplify Plus MedStorage"
  },
  MedTrays: {
    id: productIds.medTraysProductId,
    name: "Simplifi+ MedTrays",
    abbreviation: "mt",
    type: _ProductTypeEnum__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A.safety,
    icon: new _entities_Icon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A("view_quilt"),
    iconContainerClass: "icon-product med-trays",
    iconClass: "icon view_quilt",
    tileClassName: "med-trays",
    label: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", null, "Simplifi+", /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("sup", null, "\xAE"), " MedTrays"),
    leftMenuLabel: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", null, "MedTrays"),
    ariaLabel: "Simplify Plus MedTrays"
  },
  SepsisMonitor: {
    id: productIds.sepsisMonitorProductId,
    name: "Sepsis Monitor",
    abbreviation: "fl",
    type: _ProductTypeEnum__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A.surveillance,
    icon: new _entities_Icon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A("custom-icon icon-policy"),
    iconContainerClass: "icon-product",
    iconClass: "custom-icon icon-policy",
    tileClassName: "sepsis-monitor",
    label: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", null, "Sepsis Monitor")
  },
  PatientDecompensation: {
    id: productIds.patientDecompensationId,
    name: "Pharmacy (New)",
    abbreviation: "pd",
    type: _ProductTypeEnum__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A.surveillance,
    // Icon name should be in pascal case for svg icons both here and in assets/svg as they will be converted to react components
    icon: new _entities_Icon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A("SvgPharmacyNew", _entities_Icon__WEBPACK_IMPORTED_MODULE_2__/* .IconTypes */ .B.svg, "pharmacy-new"),
    iconContainerClass: "icon-product",
    iconClass: "pharmacy-new",
    tileClassName: "pharmacy-new-tile",
    label: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", null, "Pharmacy (New)"),
    ariaLabel: "Pharmacy New"
  },
  AurReporting: {
    id: productIds.aurReportingProductId,
    name: "AUR Reporting",
    abbreviation: "aur",
    type: _ProductTypeEnum__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A.surveillance,
    iconClass: "material-symbols-outlined",
    icon: new _entities_Icon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A("icon-data-exploration"),
    iconContainerClass: "icon-product",
    tileClassName: "S7AurOnly",
    label: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", null, "AUR Reporting")
  },
  Flowlytics: {
    id: productIds.flowlyticsProductId,
    name: "Drug Diversion",
    abbreviation: "fl",
    type: _ProductTypeEnum__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A.surveillance,
    icon: new _entities_Icon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A("icon-alt-route"),
    iconContainerClass: "icon-product",
    label: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", null, "Drug Diversion"),
    iconClass: "material-symbols-outlined",
    tileClassName: "flowlytics"
  },
  IVWorkflow: {
    id: productIds.ivWorkflowProductId,
    name: "Simplifi+ IV Workflow",
    abbreviation: "ivw",
    type: _ProductTypeEnum__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A.safety,
    icon: new _entities_Icon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A("iv-workflow"),
    iconContainerClass: "icon-product",
    label: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", null, "Simplifi+", /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("sup", null, "\xAE"), " IV Workflow"),
    iconClass: "iv-workflow",
    tileClassName: "ivWorkflow",
    ariaLabel: "Simplify Plus IV Workflow"
  }
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ProductEnum);

/***/ }),

/***/ 2382:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* unused harmony export ProductType */
var ProductType = {
  surveillance: 0,
  safety: 1,
  tools: 2
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ProductType);

/***/ }),

/***/ 8754:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9155);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

var SvgPharmacyNew = function SvgPharmacyNew(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 240 240",
    preserveAspectRatio: "none"
  }, props), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("path", {
    fill: "#007AC3",
    fillRule: "evenodd",
    d: "M201 40h-16v24h-24v16h24v24h16V80h24V64h-24zM56 168H40v16H24v16h16v16h16v-16h16v-16H56zM144 16h-16v8h-8v16h8v8h16v-8h8V24h-8zM31.147 40.147c28.285-28.284 59.397-8.485 67.882 0l101.824 101.824c8.485 8.485 28.284 39.598 0 67.882s-59.397 8.485-67.882 0L31.147 108.029c-8.485-8.485-28.284-39.597 0-67.882m56.569 101.824L42.46 96.716c-5.657-5.657-18.385-26.87 0-45.255s39.598-5.657 45.255 0l45.255 45.255zm11.313 11.313 45.255 45.255c5.657 5.657 26.87 18.385 45.255 0s5.657-39.598 0-45.255l-45.255-45.255z",
    clipRule: "evenodd"
  }));
};
var SvgIcons = {
  SvgPharmacyNew: SvgPharmacyNew
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SvgIcons);

/***/ }),

/***/ 39:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (/* binding */ BaseClass)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var BaseClass = /*#__PURE__*/function () {
  function BaseClass() {
    _classCallCheck(this, BaseClass);
  }
  return _createClass(BaseClass, [{
    key: "createCopy",
    value: function createCopy() {
      var copy = new this.__proto__.constructor();
      for (var attr in this) {
        // eslint-disable-next-line no-use-before-define,no-prototype-builtins
        if (this.hasOwnProperty(attr)) {
          if (this[attr] instanceof Array) {
            copy[attr] = this[attr].map(function (item) {
              return getCopy(item);
            });
          } else {
            copy[attr] = getCopy(this[attr]);
          }
        }
      }
      return copy;
    }
  }]);
}();

var getCopy = function getCopy(item) {
  if (item instanceof BaseClass) {
    return item.createCopy();
  } else return item;
};

/***/ }),

/***/ 3465:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (/* binding */ ExternalIdentifiers)
/* harmony export */ });
/* harmony import */ var _BaseClass__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }

var ExternalIdentifiers = /*#__PURE__*/function (_BaseClass) {
  function ExternalIdentifiers(json) {
    var _this;
    _classCallCheck(this, ExternalIdentifiers);
    _this = _callSuper(this, ExternalIdentifiers);
    if (json) {
      _this.externalIdentifiersId = json.ExternalIdentifiersId;
      _this.nationalProviderIdentifier = json.NationalProviderIdentifier;
      _this.nabpEPid = json.NabpEPid;
      _this.dateOfBirth = json.DateOfBirth;
      _this.nabpRoleId = json.NabpRoleId;
      _this.hasNoNabp = json.HasNoNabp;
    }
    return _this;
  }
  _inherits(ExternalIdentifiers, _BaseClass);
  return _createClass(ExternalIdentifiers, [{
    key: "toJson",
    value: function toJson() {
      return {
        ExternalIdentifiersId: this.externalIdentifiersId,
        NationalProviderIdentifier: this.nationalProviderIdentifier,
        NabpEPid: this.nabpEPid,
        DateOfBirth: this.dateOfBirth,
        NabpRoleId: this.nabpRoleId,
        HasNoNabp: this.hasNoNabp
      };
    }
  }]);
}(_BaseClass__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A);


/***/ }),

/***/ 8607:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (/* binding */ Icon),
/* harmony export */   B: () => (/* binding */ IconTypes)
/* harmony export */ });
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3368);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

var IconTypes = {
  "default": 0,
  material: 1,
  jumpstart: 2,
  svg: 3
};
var Icon = /*#__PURE__*/function () {
  function Icon(name) {
    var _this = this;
    var iconType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : IconTypes["default"];
    var extraClass = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
    _classCallCheck(this, Icon);
    _defineProperty(this, "addClasses", function (extraClasses) {
      return _this.extraClass = classnames__WEBPACK_IMPORTED_MODULE_0___default()(_this.extraClass, extraClasses);
    });
    this.name = name;
    this.iconType = iconType;
    this.extraClass = extraClass;
  }

  /**
   * @deprecated use IconView
   */
  return _createClass(Icon, [{
    key: "isMaterial",
    get: function get() {
      return this.iconType === IconTypes.material;
    }
  }]);
}();


/***/ }),

/***/ 5609:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   DV: () => (/* binding */ isEnterPressed),
/* harmony export */   Db: () => (/* binding */ isNumberKeyFromEvent),
/* harmony export */   Hk: () => (/* binding */ isShiftPressed),
/* harmony export */   P7: () => (/* binding */ upArrowPressed),
/* harmony export */   Ur: () => (/* binding */ downArrowPressed),
/* harmony export */   Wz: () => (/* binding */ isTabPressed),
/* harmony export */   e0: () => (/* binding */ isEscPressed),
/* harmony export */   fZ: () => (/* binding */ isLiteralKeyFromEvent),
/* harmony export */   l_: () => (/* binding */ isSpacePressed)
/* harmony export */ });
/* unused harmony exports isNumberKey, isDecimalPointFromEvent, isDecimalPoint, isZeroFromEvent, isZeroPoint, isBackSlashPressed, isDeletePressed, descriptionAcceptableSymbol, conceptAcceptableSymbol, ruleLogicValueAcceptableSymbol, backSpacePressed */
//
// Helpers for handling browser events
//

//event hasn't property which IE  < 9
function isNumberKeyFromEvent(e) {
  return isNumberKey(e.which ? e.which : e.keyCode);
}
function isNumberKey(code) {
  return code >= 48 && code <= 57;
}
function isDecimalPointFromEvent(e) {
  return isDecimalPoint(e.which ? e.which : e.keyCode);
}
function isDecimalPoint(code) {
  return code == 46;
}
function isZeroFromEvent(e) {
  return isZeroPoint(e.which ? e.which : e.keyCode);
}
function isZeroPoint(code) {
  return code == 48;
}
function isLiteralKeyFromEvent(e) {
  return isAcceptableKey(e.which ? e.which : e.keyCode);
}
function isEnterPressed(e) {
  var code = e.which ? e.which : e.keyCode;
  return code == 13;
}
function isTabPressed(e) {
  var code = e.which ? e.which : e.keyCode;
  return code == 9;
}
function isShiftPressed(e) {
  return e.shiftKey;
}
function isBackSlashPressed(e) {
  var code = e.which ? e.which : e.keyCode;
  return code == 92;
}
function isDeletePressed(e) {
  var code = e.which ? e.which : e.keyCode;
  return code == 46;
}
function isEscPressed(e) {
  return e.keyCode == 27;
}
function isSpacePressed(e) {
  var code = e.which ? e.which : e.keyCode;
  return code == 32;
}
function upArrowPressed(e) {
  var code = e.which ? e.which : e.keyCode;
  return code == 38;
}
function downArrowPressed(e) {
  var code = e.which ? e.which : e.keyCode;
  return code == 40;
}
function descriptionAcceptableSymbol(e) {
  var code = e.which ? e.which : e.keyCode;
  return code > 0 && code < 256;
}
function conceptAcceptableSymbol(e) {
  return !isBackSlashPressed(e);
}
function ruleLogicValueAcceptableSymbol(e) {
  var code = e.which ? e.which : e.keyCode;
  return isLiteralKey(code) || code == 32 || code == 40 || code == 41;
}
function isAcceptableKey(code) {
  return isLiteralKey(code) || isAcceptableSymbol(code);
}
// 0-9A-Za-z
function isLiteralKey(code) {
  return code >= 48 && code <= 57 || code >= 65 && code <= 90 || code >= 97 && code <= 122;
}
// space'-.
function isAcceptableSymbol(code) {
  return code == 32 || code == 39 || code == 45 || code == 46;
}
function backSpacePressed(e) {
  var code = e.which ? e.which : e.keyCode;
  return code == 8;
}

/***/ }),

/***/ 2000:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   AU: () => (/* binding */ getOrganizationStatus),
/* harmony export */   Ds: () => (/* binding */ getAuthenticationType),
/* harmony export */   Iv: () => (/* binding */ getOrganizationType)
/* harmony export */ });
/* unused harmony exports createTreeList, getTags, getCurrentP1s, getCurrentIdn */
/* harmony import */ var _constants_OrganizationTypeEnum__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9220);
/* harmony import */ var _constants_OrganizationStatusEnum__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1486);
/* harmony import */ var _constants_AuthenticationTypeEnum__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4143);
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }




var getOrganizationType = function getOrganizationType(typeValue) {
  if (typeValue && typeValue.length > 0) {
    switch (typeValue.toLowerCase()) {
      case _constants_OrganizationTypeEnum__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.P1S:
        return _constants_OrganizationTypeEnum__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.P1S;
      case _constants_OrganizationTypeEnum__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.Parent:
        return _constants_OrganizationTypeEnum__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.Parent;
      case _constants_OrganizationTypeEnum__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.Separate:
        return _constants_OrganizationTypeEnum__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.Separate;
      case _constants_OrganizationTypeEnum__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.Subordinate:
        return _constants_OrganizationTypeEnum__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.Subordinate;
    }
  }
  return null;
};
var getOrganizationStatus = function getOrganizationStatus(value) {
  var organizationStatus;
  switch (value) {
    case _constants_OrganizationStatusEnum__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A.Active.value:
      organizationStatus = _constants_OrganizationStatusEnum__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A.Active;
      break;
    case _constants_OrganizationStatusEnum__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A.Locked.value:
      organizationStatus = _constants_OrganizationStatusEnum__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A.Locked;
      break;
    case _constants_OrganizationStatusEnum__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A.SuperUsersOnly.value:
      organizationStatus = _constants_OrganizationStatusEnum__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A.SuperUsersOnly;
      break;
  }
  return organizationStatus;
};
var getAuthenticationType = function getAuthenticationType(value) {
  var authenticationType = null;
  switch (value) {
    case _constants_AuthenticationTypeEnum__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Ay.User.value:
      authenticationType = _constants_AuthenticationTypeEnum__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Ay.User;
      break;
    case _constants_AuthenticationTypeEnum__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Ay.Sso.value:
      authenticationType = _constants_AuthenticationTypeEnum__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Ay.Sso;
      break;
    case _constants_AuthenticationTypeEnum__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Ay.Password.value:
      authenticationType = _constants_AuthenticationTypeEnum__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Ay.Password;
      break;
  }
  return authenticationType;
};
var createTreeList = function createTreeList(organizations) {
  var result = [];
  organizations.filter(function (o) {
    return !o.isSuborganization();
  }).forEach(function (organization) {
    result = [].concat(_toConsumableArray(result), [organization]);
    if (organization.isIDN()) {
      organization.suborganizations = organizations.filter(function (o) {
        return o.parentOrganizationId === organization.id;
      }).sort(sortByName);
    }
  });
  var notSubordinateIds = result.map(function (o) {
    return o.id;
  });
  var organizationsWithoutParent = organizations.filter(function (o) {
    return o.isSuborganization() && !notSubordinateIds.includes(o.parentOrganizationId);
  });
  result = [].concat(_toConsumableArray(result), _toConsumableArray(organizationsWithoutParent)).sort(sortByName);
  if (result.length === 0 && organizations.length > 0) return organizations;
  return result;
};
var getTags = function getTags(organizations) {
  var tags = [];
  organizations.forEach(function (organization) {
    tags = tags.concat(organization.tags);
    if (organizations.suborganizations) {
      organizations.suborganizations.forEach(function (subOrganization) {
        tags = tags.concat(subOrganization.tags);
      });
    }
  });
  return _toConsumableArray(new Set(tags));
};
var getCurrentP1s = function getCurrentP1s(organizations) {
  return organizations.find(function (o) {
    return o.site === 1;
  });
};
var getCurrentIdn = function getCurrentIdn(organizations, currentOrganization) {
  if (!currentOrganization) return undefined;
  if (currentOrganization.isSuborganization()) {
    var parent = organizations.find(function (org) {
      return org.id === currentOrganization.parentOrganizationId;
    });
    return parent ? parent : currentOrganization;
  }
  return currentOrganization;
};

/***/ }),

/***/ 2500:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   OI: () => (/* binding */ getProductConfigurationById),
/* harmony export */   ZV: () => (/* binding */ isSurveillanceProduct),
/* harmony export */   gL: () => (/* binding */ isTools),
/* harmony export */   ih: () => (/* binding */ isSafetyProduct)
/* harmony export */ });
/* unused harmony exports isProductNeedsAnalytics, isSuperUserProduct, isLegacyProduct */
/* harmony import */ var _constants_ProductEnum__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4006);
var _ProductsMemo;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

var ProductsMemo = (_ProductsMemo = {}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_ProductsMemo, _constants_ProductEnum__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.Pharmacy.id, _constants_ProductEnum__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.Pharmacy), _constants_ProductEnum__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.InfectionPrevention.id, _constants_ProductEnum__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.InfectionPrevention), _constants_ProductEnum__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.RuleManagement.id, _constants_ProductEnum__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.RuleManagement), _constants_ProductEnum__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.SuperUser.id, _constants_ProductEnum__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.SuperUser), _constants_ProductEnum__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.Quantifi.id, _constants_ProductEnum__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.Quantifi), _constants_ProductEnum__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.Veriform.id, _constants_ProductEnum__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.Veriform), _constants_ProductEnum__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.PocAdvisor.id, _constants_ProductEnum__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.PocAdvisor), _constants_ProductEnum__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.MedStorage.id, _constants_ProductEnum__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.MedStorage), _constants_ProductEnum__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.Simplifi.id, _constants_ProductEnum__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.Simplifi), _constants_ProductEnum__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.MedTrays.id, _constants_ProductEnum__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.MedTrays), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_ProductsMemo, _constants_ProductEnum__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.SepsisMonitor.id, _constants_ProductEnum__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.SepsisMonitor), _constants_ProductEnum__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.PatientDecompensation.id, _constants_ProductEnum__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.PatientDecompensation), _constants_ProductEnum__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.Analytics.id, _constants_ProductEnum__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.Analytics), _constants_ProductEnum__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.UserManagement.id, _constants_ProductEnum__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.UserManagement), _constants_ProductEnum__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.AurReporting.id, _constants_ProductEnum__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.AurReporting), _constants_ProductEnum__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.Flowlytics.id, _constants_ProductEnum__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.Flowlytics), _constants_ProductEnum__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.IVWorkflow.id, _constants_ProductEnum__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.IVWorkflow));
var getProductConfigurationById = function getProductConfigurationById(productId) {
  return ProductsMemo[productId];
};
var isProductNeedsAnalytics = function isProductNeedsAnalytics(product) {
  return product.id === Products.Pharmacy.id || product.id === Products.InfectionPrevention.id || product.id === Products.RuleManagement.id;
};
var isSuperUserProduct = function isSuperUserProduct(product) {
  return product.id === Products.SuperUser.id;
};

// legacyProduct
var legacyProductIds = [_constants_ProductEnum__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.Pharmacy.id, _constants_ProductEnum__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.Quantifi.id, _constants_ProductEnum__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.InfectionPrevention.id, _constants_ProductEnum__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.Veriform.id];
var isLegacyProduct = function isLegacyProduct(productId) {
  return legacyProductIds.indexOf(productId) > -1;
};

// toolsProduct
var tools = [_constants_ProductEnum__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.RuleManagement.id, _constants_ProductEnum__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.Analytics.id, _constants_ProductEnum__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.UserManagement.id, _constants_ProductEnum__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.SuperUser.id];
var isTools = function isTools(productId) {
  return tools.indexOf(productId) > -1;
};

// surveillanceProduct
var surveillanceProductIds = [_constants_ProductEnum__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.Pharmacy.id, _constants_ProductEnum__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.Quantifi.id, _constants_ProductEnum__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.InfectionPrevention.id, _constants_ProductEnum__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.PocAdvisor.id, _constants_ProductEnum__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.SepsisMonitor.id, _constants_ProductEnum__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.PatientDecompensation.id, _constants_ProductEnum__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.AurReporting.id, _constants_ProductEnum__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.Flowlytics.id];
var isSurveillanceProduct = function isSurveillanceProduct(productId) {
  return surveillanceProductIds.indexOf(productId) > -1;
};

// safetyProduct
var safetyProductIds = [_constants_ProductEnum__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.Veriform.id, _constants_ProductEnum__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.MedStorage.id, _constants_ProductEnum__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.Simplifi.id, _constants_ProductEnum__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.MedTrays.id, _constants_ProductEnum__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.IVWorkflow.id];
var isSafetyProduct = function isSafetyProduct(productId) {
  return safetyProductIds.indexOf(productId) > -1;
};

/***/ }),

/***/ 7609:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   NM: () => (/* binding */ sortByString),
/* harmony export */   VV: () => (/* binding */ sortByName)
/* harmony export */ });
/* unused harmony exports sortByOrder, sortByFields, sortByDueDate, sortByField, sortByBoolean, sortByNumber, sortByDate, sortByNameAsc, sortStringByFieldAsc */
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var sortByName = function sortByName(item1, item2, order) {
  return sortByField(item1, item2, order, "name");
};
var sortByOrder = function sortByOrder(item1, item2, order) {
  return sortByField(item1, item2, order, "order");
};
var sortByFields = function sortByFields(item1, item2, fields) {
  if (fields && fields.length > 0) {
    var result = 0;
    fields.forEach(function (field) {
      if (result == 0) {
        var fieldName = field.name ? field.name : field;
        var fieldOrder = field.order;
        result = sortByField(item1, item2, fieldOrder, fieldName);
      }
    });
    return result;
  }
  return -1;
};
var sortByDueDate = function sortByDueDate(item1, item2, order) {
  return sortByField(item1, item2, order, "dueAtTime");
};
var sortByField = function sortByField(item1, item2, order, field) {
  var value1 = field ? item1[field] : item1;
  var value2 = field ? item2[field] : item2;
  if (value1 == value2) return 0;
  var orderByDesc = order && order.toLowerCase() === "desc";
  // believe that undefined is the lowest
  if (value1 == undefined) return orderByDesc ? 1 : -1;
  if (value2 == undefined) return orderByDesc ? -1 : 1;
  if (_typeof(value1) != _typeof(value2)) return sortByString(_typeof(value1), _typeof(value2), order);
  if (typeof value1 == "boolean") return sortByBoolean(value1, value2, order);
  if (typeof value1 == "string") return sortByString(value1, value2, order);
  if (typeof value1 == "number") return sortByNumber(value1, value2, order);
  if (value1 instanceof Date) return sortByDate(value1, value2, order);
};
var sortByBoolean = function sortByBoolean(value1, value2, order) {
  if (value1 == value2) return 0;
  var result = 1;
  if (order && order.toLowerCase() === "desc") result = -1;
  if (value1 && !value2) {
    return result;
  }
  if (!value1 && value2) {
    return -result;
  }
  return 0;
};
var sortByString = function sortByString(value1, value2, order) {
  if (value1 == undefined && value2 == undefined) return 0;
  var orderByDesc = order && order.toLowerCase() === "desc";

  // believe that undefined is the lowest
  if (value1 == undefined) return orderByDesc ? 1 : -1;
  if (value2 == undefined) return orderByDesc ? -1 : 1;
  if (value1.toLowerCase() == value2.toLowerCase()) return 0;
  var result = orderByDesc ? -1 : 1;
  return value1.toLowerCase() > value2.toLowerCase() ? result : -result;
};
var sortByNumber = function sortByNumber(value1, value2, order) {
  if (value1 == value2) return 0;
  var orderByDesc = order && order.toLowerCase() === "desc";

  // believe that undefined is the lowest
  if (value1 == undefined) return orderByDesc ? 1 : -1;
  if (value2 == undefined) return orderByDesc ? -1 : 1;
  var result = orderByDesc ? -1 : 1;
  return value1 > value2 ? result : -result;
};
var sortByDate = function sortByDate(value1, value2, order) {
  if (value1 == value2) return 0;
  if (value1 instanceof Date && value2 instanceof Date) {
    if (value1.getTime() === value2.getTime()) return 0;
  }
  var orderByDesc = order && order.toLowerCase() === "desc";
  var result = orderByDesc ? -1 : 1;

  // believe that undefined is the lowest
  if (value1 == undefined) return -result;
  if (value2 == undefined) return result;
  return value1 > value2 ? result : -result;
};
var sortByNameAsc = function sortByNameAsc(a, b) {
  return sortByName(a, b, "asc");
};
var sortStringByFieldAsc = function sortStringByFieldAsc(a, b, field) {
  return a[field] == "" || a[field].toLowerCase() > b[field].toLowerCase() ? 1 : -1;
};

/***/ }),

/***/ 9840:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   OH: () => (/* binding */ Validation)
/* harmony export */ });
/* unused harmony exports getAssignedOrganizationById, getAuthenticationTypeByValue */
/* harmony import */ var _ValidationUtilities__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4708);


var getAssignedOrganizationById = function getAssignedOrganizationById(user, orgId, assignedOrganizations) {
  if (user == null || assignedOrganizations.length === 0) return null;
  var assignedOrganization = assignedOrganizations.find(function (o) {
    return o.id === orgId;
  });
  if (assignedOrganization != null) return assignedOrganization;
  if (user.organizationId == orgId) return user.getParentOrganization(true);
  return null;
};
var getAuthenticationTypeByValue = function getAuthenticationTypeByValue(value) {
  var authenticationType = null;
  switch (value) {
    case AuthenticationTypeEnum.User.value:
      authenticationType = AuthenticationTypeEnum.User;
      break;
    case AuthenticationTypeEnum.Sso.value:
      authenticationType = AuthenticationTypeEnum.Sso;
      break;
    case AuthenticationTypeEnum.Password.value:
      authenticationType = AuthenticationTypeEnum.Password;
      break;
  }
  return authenticationType;
};
var Validation = {
  isNameValid: function isNameValid(name) {
    var error = null;
    if ((0,_ValidationUtilities__WEBPACK_IMPORTED_MODULE_0__/* .isNullOrEmpty */ .uJ)(name)) error = "Required field.";else if (!(0,_ValidationUtilities__WEBPACK_IMPORTED_MODULE_0__/* .isValidUserName */ .b5)(name)) error = "Invalid characters in Name.";
    return (0,_ValidationUtilities__WEBPACK_IMPORTED_MODULE_0__/* .createValidationResult */ .vQ)(error === null, error);
  },
  isEmailValid: function isEmailValid(email) {
    var error = null;
    if ((0,_ValidationUtilities__WEBPACK_IMPORTED_MODULE_0__/* .isNullOrEmpty */ .uJ)(email)) error = "Required field.";else if (!(0,_ValidationUtilities__WEBPACK_IMPORTED_MODULE_0__/* .isValidEmailFormat */ .cJ)(email)) error = "Please enter a valid email address.";
    return (0,_ValidationUtilities__WEBPACK_IMPORTED_MODULE_0__/* .createValidationResult */ .vQ)(error === null, error);
  },
  isExternalUserIdValid: function isExternalUserIdValid(externalUserId) {
    var error = null;
    if ((0,_ValidationUtilities__WEBPACK_IMPORTED_MODULE_0__/* .isNullOrEmpty */ .uJ)(externalUserId)) error = "Required field.";
    return (0,_ValidationUtilities__WEBPACK_IMPORTED_MODULE_0__/* .createValidationResult */ .vQ)(error === null, error);
  },
  isPINValid: function isPINValid(pin) {
    var error = null;
    if (!(0,_ValidationUtilities__WEBPACK_IMPORTED_MODULE_0__/* .isDigitsOnly */ .Db)(pin)) error = "PIN should consist of digits.";
    if ((0,_ValidationUtilities__WEBPACK_IMPORTED_MODULE_0__/* .isNullOrEmpty */ .uJ)(pin)) error = "Required field.";
    if (pin.length < 4) error = "PIN should be more than 4 digits.";
    if (pin.length > 10) error = "PIN should be less than 10 digits.";
    return (0,_ValidationUtilities__WEBPACK_IMPORTED_MODULE_0__/* .createValidationResult */ .vQ)(error === null, error);
  },
  validateNationalProviderIdentifier: function validateNationalProviderIdentifier(npi) {
    if (npi && !(0,_ValidationUtilities__WEBPACK_IMPORTED_MODULE_0__/* .isDigitsOnly */ .Db)(npi)) return (0,_ValidationUtilities__WEBPACK_IMPORTED_MODULE_0__/* .createValidationResult */ .vQ)(false, "NPI should consist of digits.");
    if (npi && npi.length !== 10) return (0,_ValidationUtilities__WEBPACK_IMPORTED_MODULE_0__/* .createValidationResult */ .vQ)(false, "NPI must be ten digits.");
    if (npi && !(0,_ValidationUtilities__WEBPACK_IMPORTED_MODULE_0__/* .isValidNpi */ .G9)(npi)) return (0,_ValidationUtilities__WEBPACK_IMPORTED_MODULE_0__/* .createValidationResult */ .vQ)(false, "Invalid NPI value.");
    return (0,_ValidationUtilities__WEBPACK_IMPORTED_MODULE_0__/* .createValidationResult */ .vQ)(true, null);
  },
  validateNabp: function validateNabp(nabp) {
    var error = null;
    if (nabp && !(0,_ValidationUtilities__WEBPACK_IMPORTED_MODULE_0__/* .isDigitsOnly */ .Db)(nabp)) error = "NABP e-Profile ID should consist of digits.";
    return (0,_ValidationUtilities__WEBPACK_IMPORTED_MODULE_0__/* .createValidationResult */ .vQ)(error === null, error);
  },
  validateNabpBirthDate: function validateNabpBirthDate(birthdate, nabp) {
    if (nabp && !birthdate) return (0,_ValidationUtilities__WEBPACK_IMPORTED_MODULE_0__/* .createValidationResult */ .vQ)(false, "Required if NABP e-Profile ID is populated.");
    if (birthdate && !(0,_ValidationUtilities__WEBPACK_IMPORTED_MODULE_0__/* .isMonthAndDayDateFormat */ .F$)(birthdate)) return (0,_ValidationUtilities__WEBPACK_IMPORTED_MODULE_0__/* .createValidationResult */ .vQ)(false, "Enter a date.");
    return (0,_ValidationUtilities__WEBPACK_IMPORTED_MODULE_0__/* .createValidationResult */ .vQ)(true, null);
  },
  validateNabpRole: function validateNabpRole(nabpRole, nabp) {
    var error = null;
    if (nabp && !nabpRole) error = "Required if NABP e-Profile ID is populated.";
    return (0,_ValidationUtilities__WEBPACK_IMPORTED_MODULE_0__/* .createValidationResult */ .vQ)(error === null, error);
  }
};

/***/ }),

/***/ 4708:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Db: () => (/* binding */ isDigitsOnly),
/* harmony export */   F$: () => (/* binding */ isMonthAndDayDateFormat),
/* harmony export */   G9: () => (/* binding */ isValidNpi),
/* harmony export */   b5: () => (/* binding */ isValidUserName),
/* harmony export */   cJ: () => (/* binding */ isValidEmailFormat),
/* harmony export */   uJ: () => (/* binding */ isNullOrEmpty),
/* harmony export */   vQ: () => (/* binding */ createValidationResult)
/* harmony export */ });
/* unused harmony exports isValidIdentifier, isValidSiloNumber, exceedsMaxLength, isValidDecimalFormat, isValidName, isHex, isStandardKeyboardCharset, isStandardKeyboardCharsetWithRows, isHtmlDisplaySafeCharset, isDateFormat, isTimeFormat, isDecimalFormat, isNotEmptyDecimalFormat, isIntegerPositiveFormat, isIntegerPositiveFormatFixed, isDecimalCharset, isLimitedDecimalCharset, isPositiveDecimalCharset, isPositiveCharset, doNotAllowBackspace */

var isNullOrEmpty = function isNullOrEmpty(value) {
  return !value || value.trim().length === 0;
};
var isValidIdentifier = function isValidIdentifier(value) {
  return value && value.toString().length > 0 && value > 0;
};
var isValidSiloNumber = function isValidSiloNumber(value) {
  return !value || value && value.toString().length > 0 && value > 0;
};
var exceedsMaxLength = function exceedsMaxLength(value, maxLength) {
  return !value || value.trim().length > maxLength;
};
var isValidEmailFormat = function isValidEmailFormat(value) {
  /* eslint-disable */
  var regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return regex.test(value);
};
var isValidDecimalFormat = function isValidDecimalFormat(value) {
  var decimalCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  var regex = new RegExp("(^-?\\d+(.\\d{1," + decimalCount + "})?$)");
  return regex.test(value);
};
var isDigitsOnly = function isDigitsOnly(value) {
  var regex = /^[0-9]*$/;
  return regex.test(value);
};
var isValidName = function isValidName(value) {
  // Starts end ends with literal. Can contain ".", "-", "'" and space. Can be one character.
  /* eslint-disable */
  var regex = /(^[a-zA-Z]+[a-zA-Z\s.'\-]*[a-zA-Z]+$)|(^[a-zA-Z]$)/;
  return regex.test(value);
};
var isValidUserName = function isValidUserName(value) {
  // Starts end ends with literal. Can contain ".", "-", "'" and space. Can be one character.
  var regex = /(^[a-zA-Z]+[a-zA-Z\s.'-]*[a-zA-Z.'-]+$)|(^[a-zA-Z]$)/;
  return regex.test(value);
};
var isHex = function isHex(value) {
  var hex = parseInt(value, 16);
  return hex.toString(16) === value.toLowerCase();
};
var createValidationResult = function createValidationResult(isValid, error) {
  return {
    isValid: isValid,
    error: error
  };
};
var isStandardKeyboardCharset = function isStandardKeyboardCharset(value, additionalPattern) {
  var regexString = "^$|[\\w\\s\\!\\@\\#\\$\\%\\&\\'\\(\\)\\*\\+\\,\\-\\.\\:\\;\\<\\=\\>\\?\\^\\/\\`\\{\\}\\[\\]\\|\\~\"\\\\" + additionalPattern + "]+$";
  var regex = new RegExp(regexString);
  return regex.test(value);
};
var isStandardKeyboardCharsetWithRows = function isStandardKeyboardCharsetWithRows(value) {
  return isStandardKeyboardCharset(value, "\\r\\n");
};
var isHtmlDisplaySafeCharset = function isHtmlDisplaySafeCharset(value) {
  return isStandardKeyboardCharset(value, "¡¢£¤¥¦§¨©ª«¬1®¯°±²³´µ¶·¸¹º»¼½¾¿ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖ×ØÙÚÛÜÝÞßàáâãäåæçèéêëìíîïðñòóôõö÷øùúûüýþÿŒœŠšŸŽž");
};
var isDateFormat = function isDateFormat(value) {
  var date = /(^$|(^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20|21)\d{2})+$)/;
  return date.test(value);
};
var isTimeFormat = function isTimeFormat(value) {
  var regex = /^[0-2]\d:[0-5]\d$/;
  return regex.test(value);
};
var isDecimalFormat = function isDecimalFormat(value) {
  var regex = /(^$|^-?\d+(\.\d{1,3})?$|^-?\.\d{1,3}$)/;
  return regex.test(value);
};
var isNotEmptyDecimalFormat = function isNotEmptyDecimalFormat(value) {
  var regex = /^-?\d+(\.\d{1,3})?$|^-?\.\d{1,3}$/;
  return regex.test(value);
};
var isIntegerPositiveFormat = function isIntegerPositiveFormat(value) {
  var regex = /^[1-9]\d*$/;
  return regex.test(value);
};
var isIntegerPositiveFormatFixed = function isIntegerPositiveFormatFixed(value, numbersCount) {
  var regex = new RegExp("^[1-9]\\d{0," + (numbersCount - 1) + "}$");
  return regex.test(value);
};
var isDecimalCharset = function isDecimalCharset(value) {
  var decimalCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  var regex = new RegExp("(^$|^-?\\d*\\.?(\\d{1," + decimalCount + "})?$)"); // /(^$|^-?\d*\.?(\d{1,2})?$)/;
  return regex.test(value);
};
var isLimitedDecimalCharset = function isLimitedDecimalCharset(value, integerCount, decimalCount) {
  var regex = new RegExp("(^(^$|^-)?\\d{0," + integerCount + "}?(\\.\\d{0," + decimalCount + "})?)$"); //   /(^\d{0,2}?(\.[0-9]{0,2})?)$/
  return regex.test(value);
};
var isPositiveDecimalCharset = function isPositiveDecimalCharset(value, integerCount, decimalCount) {
  var regex = new RegExp("(^\\d{0," + integerCount + "}?(\\.\\d{0," + decimalCount + "})?)$"); //   /(^\d{0,2}?(\.[0-9]{0,2})?)$/
  return regex.test(value);
};
var isPositiveCharset = function isPositiveCharset(value) {
  var integerCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 18;
  var regex = new RegExp("(^\\d{0," + integerCount + "})$");
  return regex.test(value);
};
var doNotAllowBackspace = function doNotAllowBackspace(event, textInput) {
  var value = event.target.value;
  if (value.length === 1 && backSpacePressed(event)) {
    event.preventDefault();
    textInput.select();
  }
};

// https://www.eclaims.com/articles/how-to-calculate-the-npi-check-digit/
var isValidNpi = function isValidNpi(npi) {
  if (!npi) return false;
  if (npi.length !== 10) return false;
  var sum;
  sum = sumDigits(npi[8] * 2) + sumDigits(npi[6] * 2) + sumDigits(npi[4] * 2) + sumDigits(npi[2] * 2) + sumDigits(npi[0] * 2) + 24;
  sum += +npi[1] + +npi[3] + +npi[5] + +npi[7];

  //Subtract the next highest number divisible by 10 from the sum (gives us check digit)
  if (sum % 10 !== 0) {
    sum = sum + (10 - sum % 10) - sum;
  } else {
    sum = 0; //Check digit must be zero
  }
  //Check if our calculated check-digit matches the one originally provided by the user
  return sum === +npi[9];
};
var sumDigits = function sumDigits(number) {
  var sum = 0;
  while (number > 0) {
    sum += number % 10;
    number = Math.trunc(number / 10);
  }
  return sum;
};
var isMonthAndDayDateFormat = function isMonthAndDayDateFormat(value) {
  var date = /(^$|(^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01]))+$)/;
  return date.test(value);
};

/***/ }),

/***/ 5355:
/***/ ((module, exports, __webpack_require__) => {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__(8532);
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".accordion{box-shadow:0 2px 1px -1px rgba(0,0,0,.2),0 1px 1px 0px rgba(0,0,0,.14),0 1px 3px 0 rgba(0,0,0,.12)}.accordion .accordion-header-container{padding:0 16px;display:inline-flex;justify-content:space-between;align-items:center;cursor:pointer;width:100%;height:48px}.accordion .accordion-header-container .accordion-header-icon-container{transform:rotate(0);transition:transform 200ms ease-in-out}.accordion .accordion-header-container:focus-visible{outline:none;background-color:#ececec}.accordion .accordion-content-container{display:none}.accordion.expanded .accordion-header-container{height:64px}.accordion.expanded .accordion-header-container .accordion-header-icon-container{transform:rotate(-180deg)}.accordion.expanded .accordion-content-container{display:flex;padding:10px 16px 0 16px}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ 9530:
/***/ ((module, exports, __webpack_require__) => {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__(8532);
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sl-checkbox{display:table;padding-bottom:10px;text-align:right}.sl-checkbox>div{padding:4px 2px 3px 2px;display:table-cell;vertical-align:middle}.sl-checkbox>div .icon{font-size:40px;line-height:40px}.sl-checkbox>div.blueCheckBox{padding:2px 5px 1px 5px;outline:none;vertical-align:middle}.sl-checkbox>div.blueCheckBox input[type=checkbox]:checked+i{color:#007ac3}.sl-checkbox>div.blueCheckBox:focus{outline:#a6c7ff solid 2px}.sl-checkbox .inactive{color:#999}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ 9802:
/***/ ((module, exports, __webpack_require__) => {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__(8532);
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".btn-pending{display:inline-block;line-height:49px}.btn-pending .hiddenBtn{left:-9999px;position:absolute}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ 3276:
/***/ ((module, exports, __webpack_require__) => {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__(8532);
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#profile .italic{font-style:italic}#profile .inactive{color:#999}#profile .inactive .dark{color:#999}#profile .inactive .rightLink{display:none}#profile .icon-roles{color:#007ac3}#profile .permission-userManagement{background-color:#474747;border:2px solid #474747 !important;color:#fff !important}#profile .permission-ruleManagement{background-color:#007ac3;color:#fff !important}#profile .permission-analytics{background-color:#ea8f00;border:2px solid #ea8f00 !important;color:#fff !important}#profile div.icon-product{border-radius:100%;border:2px solid #007ac3;width:29px;height:29px;text-align:center;line-height:29px -4px !important;display:inline-block;margin-right:10px;position:relative;color:#007ac3;font-size:18px !important}#profile div.icon-product>a:hover{text-decoration:none}#profile .userDetailsProductsList{list-style:none;line-height:normal;padding:7px 0}#profile .userDetailsProductsList li{padding:3px 0;line-height:28px}#profile .userDetailsProductsList li>.icon-product{display:inline-block}#profile div.icon-product{border-radius:100%;border:2px solid #007ac3;width:29px;height:29px;text-align:center;line-height:29px -4px !important;display:inline-block;margin-right:10px;position:relative;font-size:18px !important}#profile div.icon-product>a:hover{text-decoration:none}#editExternalIds .disabled{color:gray}#editExternalIds .tooltip-container{display:inline-block;position:relative;cursor:pointer}#editExternalIds .tooltip-container .tooltip{width:auto;min-width:250px;max-width:350px;white-space:normal;word-break:normal;text-align:left}#editExternalIds .tooltip-container:hover span.tooltip{opacity:1;visibility:visible}#editExternalIds .tooltip-container .external-ids-info-icon{font-size:24px;margin-left:1px;vertical-align:bottom}#editExternalIds .nabp-date-of-birth{white-space:nowrap}#editExternalIds .has-no-nabp{margin-top:5px}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ 9267:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


var content = __webpack_require__(5355);

if(typeof content === 'string') content = [[module.id, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3027)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),

/***/ 3554:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


var content = __webpack_require__(9530);

if(typeof content === 'string') content = [[module.id, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3027)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),

/***/ 7874:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


var content = __webpack_require__(9802);

if(typeof content === 'string') content = [[module.id, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3027)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),

/***/ 8004:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


var content = __webpack_require__(3276);

if(typeof content === 'string') content = [[module.id, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(3027)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),

/***/ 3027:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/

var stylesInDom = {};

var	memoize = function (fn) {
	var memo;

	return function () {
		if (typeof memo === "undefined") memo = fn.apply(this, arguments);
		return memo;
	};
};

var isOldIE = memoize(function () {
	// Test for IE <= 9 as proposed by Browserhacks
	// @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
	// Tests for existence of standard globals is to allow style-loader
	// to operate correctly into non-standard environments
	// @see https://github.com/webpack-contrib/style-loader/issues/177
	return window && document && document.all && !window.atob;
});

var getTarget = function (target, parent) {
  if (parent){
    return parent.querySelector(target);
  }
  return document.querySelector(target);
};

var getElement = (function (fn) {
	var memo = {};

	return function(target, parent) {
                // If passing function in options, then use it for resolve "head" element.
                // Useful for Shadow Root style i.e
                // {
                //   insertInto: function () { return document.querySelector("#foo").shadowRoot }
                // }
                if (typeof target === 'function') {
                        return target();
                }
                if (typeof memo[target] === "undefined") {
			var styleTarget = getTarget.call(this, target, parent);
			// Special case to return head of iframe instead of iframe itself
			if (window.HTMLIFrameElement && styleTarget instanceof window.HTMLIFrameElement) {
				try {
					// This will throw an exception if access to iframe is blocked
					// due to cross-origin restrictions
					styleTarget = styleTarget.contentDocument.head;
				} catch(e) {
					styleTarget = null;
				}
			}
			memo[target] = styleTarget;
		}
		return memo[target]
	};
})();

var singleton = null;
var	singletonCounter = 0;
var	stylesInsertedAtTop = [];

var	fixUrls = __webpack_require__(5592);

module.exports = function(list, options) {
	if (typeof DEBUG !== "undefined" && DEBUG) {
		if (typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};

	options.attrs = typeof options.attrs === "object" ? options.attrs : {};

	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (!options.singleton && typeof options.singleton !== "boolean") options.singleton = isOldIE();

	// By default, add <style> tags to the <head> element
        if (!options.insertInto) options.insertInto = "head";

	// By default, add <style> tags to the bottom of the target
	if (!options.insertAt) options.insertAt = "bottom";

	var styles = listToStyles(list, options);

	addStylesToDom(styles, options);

	return function update (newList) {
		var mayRemove = [];

		for (var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];

			domStyle.refs--;
			mayRemove.push(domStyle);
		}

		if(newList) {
			var newStyles = listToStyles(newList, options);
			addStylesToDom(newStyles, options);
		}

		for (var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];

			if(domStyle.refs === 0) {
				for (var j = 0; j < domStyle.parts.length; j++) domStyle.parts[j]();

				delete stylesInDom[domStyle.id];
			}
		}
	};
};

function addStylesToDom (styles, options) {
	for (var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];

		if(domStyle) {
			domStyle.refs++;

			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}

			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];

			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}

			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles (list, options) {
	var styles = [];
	var newStyles = {};

	for (var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = options.base ? item[0] + options.base : item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};

		if(!newStyles[id]) styles.push(newStyles[id] = {id: id, parts: [part]});
		else newStyles[id].parts.push(part);
	}

	return styles;
}

function insertStyleElement (options, style) {
	var target = getElement(options.insertInto)

	if (!target) {
		throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
	}

	var lastStyleElementInsertedAtTop = stylesInsertedAtTop[stylesInsertedAtTop.length - 1];

	if (options.insertAt === "top") {
		if (!lastStyleElementInsertedAtTop) {
			target.insertBefore(style, target.firstChild);
		} else if (lastStyleElementInsertedAtTop.nextSibling) {
			target.insertBefore(style, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			target.appendChild(style);
		}
		stylesInsertedAtTop.push(style);
	} else if (options.insertAt === "bottom") {
		target.appendChild(style);
	} else if (typeof options.insertAt === "object" && options.insertAt.before) {
		var nextSibling = getElement(options.insertAt.before, target);
		target.insertBefore(style, nextSibling);
	} else {
		throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");
	}
}

function removeStyleElement (style) {
	if (style.parentNode === null) return false;
	style.parentNode.removeChild(style);

	var idx = stylesInsertedAtTop.indexOf(style);
	if(idx >= 0) {
		stylesInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement (options) {
	var style = document.createElement("style");

	if(options.attrs.type === undefined) {
		options.attrs.type = "text/css";
	}

	if(options.attrs.nonce === undefined) {
		var nonce = getNonce();
		if (nonce) {
			options.attrs.nonce = nonce;
		}
	}

	addAttrs(style, options.attrs);
	insertStyleElement(options, style);

	return style;
}

function createLinkElement (options) {
	var link = document.createElement("link");

	if(options.attrs.type === undefined) {
		options.attrs.type = "text/css";
	}
	options.attrs.rel = "stylesheet";

	addAttrs(link, options.attrs);
	insertStyleElement(options, link);

	return link;
}

function addAttrs (el, attrs) {
	Object.keys(attrs).forEach(function (key) {
		el.setAttribute(key, attrs[key]);
	});
}

function getNonce() {
	if (false) {}

	return __webpack_require__.nc;
}

function addStyle (obj, options) {
	var style, update, remove, result;

	// If a transform function was defined, run it on the css
	if (options.transform && obj.css) {
	    result = typeof options.transform === 'function'
		 ? options.transform(obj.css) 
		 : options.transform.default(obj.css);

	    if (result) {
	    	// If transform returns a value, use that instead of the original css.
	    	// This allows running runtime transformations on the css.
	    	obj.css = result;
	    } else {
	    	// If the transform function returns a falsy value, don't add this css.
	    	// This allows conditional loading of css
	    	return function() {
	    		// noop
	    	};
	    }
	}

	if (options.singleton) {
		var styleIndex = singletonCounter++;

		style = singleton || (singleton = createStyleElement(options));

		update = applyToSingletonTag.bind(null, style, styleIndex, false);
		remove = applyToSingletonTag.bind(null, style, styleIndex, true);

	} else if (
		obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function"
	) {
		style = createLinkElement(options);
		update = updateLink.bind(null, style, options);
		remove = function () {
			removeStyleElement(style);

			if(style.href) URL.revokeObjectURL(style.href);
		};
	} else {
		style = createStyleElement(options);
		update = applyToTag.bind(null, style);
		remove = function () {
			removeStyleElement(style);
		};
	}

	update(obj);

	return function updateStyle (newObj) {
		if (newObj) {
			if (
				newObj.css === obj.css &&
				newObj.media === obj.media &&
				newObj.sourceMap === obj.sourceMap
			) {
				return;
			}

			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;

		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag (style, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (style.styleSheet) {
		style.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = style.childNodes;

		if (childNodes[index]) style.removeChild(childNodes[index]);

		if (childNodes.length) {
			style.insertBefore(cssNode, childNodes[index]);
		} else {
			style.appendChild(cssNode);
		}
	}
}

function applyToTag (style, obj) {
	var css = obj.css;
	var media = obj.media;

	if(media) {
		style.setAttribute("media", media)
	}

	if(style.styleSheet) {
		style.styleSheet.cssText = css;
	} else {
		while(style.firstChild) {
			style.removeChild(style.firstChild);
		}

		style.appendChild(document.createTextNode(css));
	}
}

function updateLink (link, options, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	/*
		If convertToAbsoluteUrls isn't defined, but sourcemaps are enabled
		and there is no publicPath defined then lets turn convertToAbsoluteUrls
		on by default.  Otherwise default to the convertToAbsoluteUrls option
		directly
	*/
	var autoFixUrls = options.convertToAbsoluteUrls === undefined && sourceMap;

	if (options.convertToAbsoluteUrls || autoFixUrls) {
		css = fixUrls(css);
	}

	if (sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = link.href;

	link.href = URL.createObjectURL(blob);

	if(oldSrc) URL.revokeObjectURL(oldSrc);
}


/***/ }),

/***/ 1949:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__1949__;

/***/ }),

/***/ 9155:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__9155__;

/***/ }),

/***/ 4442:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__4442__;

/***/ }),

/***/ 3368:
/***/ ((module, exports) => {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
  'use strict';

  var hasOwn = {}.hasOwnProperty;
  function classNames() {
    var classes = '';
    for (var i = 0; i < arguments.length; i++) {
      var arg = arguments[i];
      if (arg) {
        classes = appendClass(classes, parseValue(arg));
      }
    }
    return classes;
  }
  function parseValue(arg) {
    if (typeof arg === 'string' || typeof arg === 'number') {
      return arg;
    }
    if (typeof arg !== 'object') {
      return '';
    }
    if (Array.isArray(arg)) {
      return classNames.apply(null, arg);
    }
    if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
      return arg.toString();
    }
    var classes = '';
    for (var key in arg) {
      if (hasOwn.call(arg, key) && arg[key]) {
        classes = appendClass(classes, key);
      }
    }
    return classes;
  }
  function appendClass(value, newClass) {
    if (!newClass) {
      return value;
    }
    if (value) {
      return value + ' ' + newClass;
    }
    return value + newClass;
  }
  if ( true && module.exports) {
    classNames.default = classNames;
    module.exports = classNames;
  } else if (true) {
    // register as 'classnames', consistent with npm package name
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
      return classNames;
    }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {}
})();

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			id: moduleId,
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/nonce */
/******/ 	(() => {
/******/ 		__webpack_require__.nc = undefined;
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be in strict mode.
(() => {
"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  EditEmail: () => (/* reexport */ EditEmail/* default */.A),
  EditInfo: () => (/* reexport */ EditInfo/* default */.A),
  Email: () => (/* reexport */ Email/* default */.A),
  FirstName: () => (/* reexport */ FirstName/* default */.A),
  LastName: () => (/* reexport */ LastName/* default */.A),
  LocationList: () => (/* reexport */ LocationList/* default */.A),
  PendingEmail: () => (/* reexport */ PendingEmail/* default */.A),
  ProductsList: () => (/* reexport */ ProductsList/* default */.A),
  ShowParts: () => (/* reexport */ ProfileParts/* default */.A),
  "default": () => (/* binding */ components_Profile)
});

// EXTERNAL MODULE: ./src/components/Profile/EditInfo.jsx
var EditInfo = __webpack_require__(6271);
// EXTERNAL MODULE: ./src/components/Profile/EditEmail.jsx + 6 modules
var EditEmail = __webpack_require__(9124);
// EXTERNAL MODULE: ./src/components/Profile/LocationList.jsx + 1 modules
var LocationList = __webpack_require__(1546);
// EXTERNAL MODULE: ./src/components/Profile/ProductsList.jsx + 1 modules
var ProductsList = __webpack_require__(2898);
// EXTERNAL MODULE: ./src/components/Profile/FirstName.jsx
var FirstName = __webpack_require__(9380);
// EXTERNAL MODULE: ./src/components/Profile/LastName.jsx
var LastName = __webpack_require__(3206);
// EXTERNAL MODULE: ./src/components/Profile/Email.jsx
var Email = __webpack_require__(4927);
// EXTERNAL MODULE: ./src/components/Profile/PendingEmail.jsx
var PendingEmail = __webpack_require__(1664);
// EXTERNAL MODULE: ./src/components/Profile/ProfileParts.js
var ProfileParts = __webpack_require__(860);
// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__(9155);
var external_react_default = /*#__PURE__*/__webpack_require__.n(external_react_);
// EXTERNAL MODULE: external "prop-types"
var external_prop_types_ = __webpack_require__(1949);
// EXTERNAL MODULE: ./src/components/Profile/_styles.scss
var _styles = __webpack_require__(8004);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(3368);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/constants/AuthenticationTypeEnum.js
var Profile_AuthenticationTypeEnum = __webpack_require__(4143);
;// CONCATENATED MODULE: ./src/components/Profile/DetailsPageConfiguration.js
var detailsPageNames = {
  Name: {
    id: "nameDetails",
    title: "User Information",
    iconClassName: "ion-ios-person",
    label: "Name"
  },
  Email: {
    id: "emailDetails",
    title: "User Information",
    iconClassName: "ion-ios-mail",
    label: "Email"
  },
  ExternalUserId: {
    id: "externalUserId",
    title: "User Information",
    iconClassName: "ion-ios-lock",
    label: "SSO Account"
  },
  AuthenticationPassword: {
    id: "authenticationPassword",
    title: "Authentication",
    iconClassName: "ion-ios-lock",
    label: "Authentication"
  },
  AuthenticationSso: {
    id: "authenticationSso",
    title: "Authentication",
    iconClassName: "ion-ios-lock",
    label: "Authentication"
  },
  Roles: {
    id: "roleDetails",
    title: "User Role",
    iconClassName: "ion-ios-flag",
    label: "Role"
  },
  Permission: {
    id: "permissionsDetails",
    title: "Tools",
    iconClassName: "ion-ios-pricetag",
    label: "Tools"
  },
  Products: {
    id: "productsDetails",
    title: "Clinical Products",
    iconClassName: "ion-ios-medkit",
    label: "Products"
  },
  Surveillance: {
    id: "surveillanceDetails",
    title: "Sentri7® Surveillance Products",
    iconClassName: "ion-ios-medkit",
    label: "Sentri7® Surveillance"
  },
  SafetyProduct: {
    id: "safetyDetails",
    title: "Simplifi+® Compliance Products",
    iconClassName: "ion-ios-medkit",
    label: "Simplifi+® Compliance"
  },
  Locations: {
    id: "locationsDetails",
    title: "Location Access",
    iconClassName: "ion-ios-navigate",
    label: "Locations"
  },
  Accounts: {
    id: "accounts",
    title: "Accounts",
    iconClassName: "accounts",
    label: "Accounts"
  },
  ExternalIds: {
    id: "externalIds",
    title: "External Identifiers",
    iconClassName: "externalIds",
    label: "External Ids"
  },
  getPageByName: function getPageByName(formPart) {
    switch (formPart.toLowerCase()) {
      case detailsPageNames.Name.id.toLowerCase():
        return detailsPageNames.Name;
      case detailsPageNames.Email.id.toLowerCase():
        return detailsPageNames.Email;
      case detailsPageNames.ExternalUserId.id.toLowerCase():
        return detailsPageNames.ExternalUserId;
      case detailsPageNames.AuthenticationPassword.id.toLowerCase():
        return detailsPageNames.AuthenticationPassword;
      case detailsPageNames.AuthenticationSso.id.toLowerCase():
        return detailsPageNames.AuthenticationSso;
      case detailsPageNames.Roles.id.toLowerCase():
        return detailsPageNames.Roles;
      case detailsPageNames.Permission.id.toLowerCase():
        return detailsPageNames.Permission;
      case detailsPageNames.Surveillance.id.toLowerCase():
        return detailsPageNames.Surveillance;
      case detailsPageNames.SafetyProduct.id.toLowerCase():
        return detailsPageNames.SafetyProduct;
      case detailsPageNames.Locations.id.toLowerCase():
        return detailsPageNames.Locations;
      case detailsPageNames.Accounts.id.toLowerCase():
        return detailsPageNames.Accounts;
      case detailsPageNames.ExternalIds.id.toLowerCase():
        return detailsPageNames.ExternalIds;
      default:
        return detailsPageNames.Name;
    }
  }
};
// EXTERNAL MODULE: ./src/entities/Icon.js
var Icon = __webpack_require__(8607);
;// CONCATENATED MODULE: ./src/constants/UserRolesEnum.js
var UserRolesEnum = {
  StandardUserProfileId: 1,
  HealthSystemAdminProfileId: 3,
  UserManagerProfileId: 4,
  SafetyAdminProfileId: 5,
  SurveillanceAdminProfileId: 6
};
/* harmony default export */ const constants_UserRolesEnum = (UserRolesEnum);
;// CONCATENATED MODULE: ./src/utilities/UserRolesUtilities.js


var UserRolesUtilities = {
  getUserRoleIconClass: function getUserRoleIconClass(roleId) {
    return UserRolesUtilities.getUserRoleIcon(roleId).name;
  },
  getUserRoleIcon: function getUserRoleIcon(roleId) {
    var icon = new Icon/* default */.A();
    switch (roleId) {
      case constants_UserRolesEnum.StandardUserProfileId:
        icon = new Icon/* default */.A("ion-md-person");
        break;
      case constants_UserRolesEnum.HealthSystemAdminProfileId:
        icon = new Icon/* default */.A("ion-md-globe");
        break;
      case constants_UserRolesEnum.UserManagerProfileId:
        icon = new Icon/* default */.A("ion-ios-people");
        break;
      case constants_UserRolesEnum.SafetyAdminProfileId:
        icon = new Icon/* default */.A("icon-syringe");
        break;
      case constants_UserRolesEnum.SurveillanceAdminProfileId:
        icon = new Icon/* default */.A("remove_red_eye", Icon/* IconTypes */.B.material);
        break;
    }
    return icon;
  },
  getOrder: function getOrder(roleId) {
    var order = 0;
    switch (roleId) {
      case constants_UserRolesEnum.StandardUserProfileId:
        order = 1;
        break;
      case constants_UserRolesEnum.HealthSystemAdminProfileId:
        order = 4;
        break;
      case constants_UserRolesEnum.UserManagerProfileId:
        order = 5;
        break;
      case constants_UserRolesEnum.SafetyAdminProfileId:
        order = 2;
        break;
      case constants_UserRolesEnum.SurveillanceAdminProfileId:
        order = 3;
        break;
    }
    return order;
  },
  filter: function filter(a, b) {
    var orderA = UserRolesUtilities.getOrder(a.id);
    var orderB = UserRolesUtilities.getOrder(b.id);
    return orderA - orderB;
  }
};
/* harmony default export */ const utilities_UserRolesUtilities = (UserRolesUtilities);
// EXTERNAL MODULE: ./src/components/NavigationBar.jsx
var NavigationBar = __webpack_require__(144);
// EXTERNAL MODULE: ./src/components/UnverifiedEmailControl.jsx + 1 modules
var UnverifiedEmailControl = __webpack_require__(9778);
// EXTERNAL MODULE: ./src/components/Row.jsx
var Row = __webpack_require__(8201);
;// CONCATENATED MODULE: ./src/components/Profile/AuthenticationCell.jsx




var AuthenticationCell = function AuthenticationCell(_ref) {
  var user = _ref.user,
    dataClassName = _ref.dataClassName;
  var authenticationType = (0,Profile_AuthenticationTypeEnum/* getAuthenticationTypeByValue */.Rl)(user.authType);
  var headerClassName = "authentication-title";
  var detailsClassName = "authentication-details";
  switch (authenticationType) {
    case Profile_AuthenticationTypeEnum/* default */.Ay.Sso:
      return /*#__PURE__*/external_react_default().createElement("div", {
        className: dataClassName
      }, /*#__PURE__*/external_react_default().createElement("div", {
        className: headerClassName
      }, /*#__PURE__*/external_react_default().createElement("span", {
        className: "dark"
      }, authenticationType.text)), /*#__PURE__*/external_react_default().createElement("div", {
        className: detailsClassName
      }, /*#__PURE__*/external_react_default().createElement("span", {
        className: "maxTruncate"
      }, user.externalUserId || "ADD")));
    case Profile_AuthenticationTypeEnum/* default */.Ay.Password:
      return /*#__PURE__*/external_react_default().createElement("div", {
        className: dataClassName
      }, /*#__PURE__*/external_react_default().createElement("div", {
        className: headerClassName
      }, /*#__PURE__*/external_react_default().createElement("span", {
        className: "dark"
      }, authenticationType.text)), /*#__PURE__*/external_react_default().createElement("div", {
        className: detailsClassName
      }, /*#__PURE__*/external_react_default().createElement("span", null, "PIN: ", user.pin)));
    case Profile_AuthenticationTypeEnum/* default */.Ay.User:
      return /*#__PURE__*/external_react_default().createElement("div", {
        className: dataClassName
      }, /*#__PURE__*/external_react_default().createElement("div", null, /*#__PURE__*/external_react_default().createElement("span", {
        className: "light"
      }, authenticationType.text)));
    default:
      return /*#__PURE__*/external_react_default().createElement("div", {
        className: dataClassName
      }, /*#__PURE__*/external_react_default().createElement("div", null, /*#__PURE__*/external_react_default().createElement("span", {
        className: "light"
      }, "None")));
  }
};
 false ? 0 : void 0;
/* harmony default export */ const Profile_AuthenticationCell = (AuthenticationCell);
// EXTERNAL MODULE: ./src/components/IconView/IconView.jsx
var IconView = __webpack_require__(7434);
// EXTERNAL MODULE: ./src/utilities/ProductUtilities.js
var ProductUtilities = __webpack_require__(2500);
;// CONCATENATED MODULE: ./src/components/Profile/Details.jsx
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }















var Details = /*#__PURE__*/function (_PureComponent) {
  function Details() {
    var _this;
    _classCallCheck(this, Details);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Details, [].concat(args));
    _defineProperty(_this, "onResendVerificationEmail", function () {
      if (!_this.props.waitForSend) {
        var user = _this.props.currentUser;
        _this.props.onVerifyUserEmail(user, user.pendingEmail.email);
      }
    });
    return _this;
  }
  _inherits(Details, _PureComponent);
  return _createClass(Details, [{
    key: "render",
    value: function render() {
      var user = this.props.currentUser;
      if (user == null) return null;
      var dataClassName = "col-xs-9 col-md-8 ValueColumn";
      var showHealthSystemRow = user.isVirtualSuperUser;
      var hasUnverifiedEmail = user.hasUnverifiedEmail;
      var emailRowClassName = classnames_default()(dataClassName, hasUnverifiedEmail ? "italic" : "");
      var email = (hasUnverifiedEmail ? user.pendingEmail.email + " (Unverified)" : user.email) || "ADD";
      var authenticationType = (0,Profile_AuthenticationTypeEnum/* getAuthenticationTypeByValue */.Rl)(user.authType);
      var authenticationPart = authenticationType === Profile_AuthenticationTypeEnum/* default */.Ay.Sso ? detailsPageNames.AuthenticationSso : detailsPageNames.AuthenticationPassword;
      var roleIcon = utilities_UserRolesUtilities.getUserRoleIcon(user.virtualProfileId);
      var productIds = user.assignedVirtualProducts.map(function (product) {
        return product.id;
      });
      return /*#__PURE__*/external_react_default().createElement("div", {
        id: "profileContainer"
      }, /*#__PURE__*/external_react_default().createElement(NavigationBar["default"], {
        backLink: this.props.currentUrl,
        titleText: getTitleText(user),
        hasRouter: this.props.hasRouter
      }), /*#__PURE__*/external_react_default().createElement(UnverifiedEmailControl["default"], {
        user: user,
        resendVerificationEmail: this.onResendVerificationEmail,
        sentRecently: this.props.sentRecently,
        waitForSend: this.props.waitForSend
      }), /*#__PURE__*/external_react_default().createElement("div", {
        className: "user-header"
      }, /*#__PURE__*/external_react_default().createElement("h4", null, "User Details")), /*#__PURE__*/external_react_default().createElement("div", {
        className: "base-content rowList detailsPage",
        id: "profile"
      }, /*#__PURE__*/external_react_default().createElement(Row["default"], {
        rowPart: detailsPageNames.Name,
        onClick: this.props.onEditName,
        editable: true
      }, /*#__PURE__*/external_react_default().createElement("div", {
        className: dataClassName
      }, /*#__PURE__*/external_react_default().createElement("span", {
        className: "dark"
      }, user.firstName, " ", user.lastName))), showHealthSystemRow && getHealthSystemRow(dataClassName), /*#__PURE__*/external_react_default().createElement(Row["default"], {
        rowPart: detailsPageNames.Email,
        onClick: this.props.onEditEmail,
        editable: true
      }, /*#__PURE__*/external_react_default().createElement("div", {
        className: emailRowClassName
      }, /*#__PURE__*/external_react_default().createElement("span", {
        className: hasUnverifiedEmail ? "light" : "dark"
      }, email))), /*#__PURE__*/external_react_default().createElement(Row["default"], {
        rowPart: authenticationPart,
        editable: false
      }, /*#__PURE__*/external_react_default().createElement(Profile_AuthenticationCell, {
        user: user,
        dataClassName: dataClassName
      })), /*#__PURE__*/external_react_default().createElement(Row["default"], {
        rowPart: detailsPageNames.Roles,
        editable: false
      }, /*#__PURE__*/external_react_default().createElement("div", {
        className: dataClassName
      }, /*#__PURE__*/external_react_default().createElement("div", null, /*#__PURE__*/external_react_default().createElement(IconView/* default */.A, {
        icon: roleIcon,
        className: "icon-roles"
      }), /*#__PURE__*/external_react_default().createElement("span", {
        className: "dark"
      }, user.virtualProfileName)))), /*#__PURE__*/external_react_default().createElement(Row["default"], {
        rowPart: detailsPageNames.Surveillance,
        onClick: this.onEditRow,
        editable: false
      }, /*#__PURE__*/external_react_default().createElement(ProductsList/* default */.A, {
        products: productIds.filter(function (productId) {
          return (0,ProductUtilities/* isSurveillanceProduct */.ZV)(productId);
        }),
        className: dataClassName
      })), /*#__PURE__*/external_react_default().createElement(Row["default"], {
        rowPart: detailsPageNames.SafetyProduct,
        onClick: this.onEditRow,
        editable: false
      }, /*#__PURE__*/external_react_default().createElement(ProductsList/* default */.A, {
        products: productIds.filter(function (productId) {
          return (0,ProductUtilities/* isSafetyProduct */.ih)(productId);
        }),
        className: dataClassName
      })), /*#__PURE__*/external_react_default().createElement(Row["default"], {
        rowPart: detailsPageNames.Permission,
        onClick: this.onEditRow,
        editable: false
      }, /*#__PURE__*/external_react_default().createElement(ProductsList/* default */.A, {
        products: productIds.filter(function (productId) {
          return (0,ProductUtilities/* isTools */.gL)(productId);
        }),
        className: dataClassName
      })), /*#__PURE__*/external_react_default().createElement(Row["default"], {
        rowPart: detailsPageNames.Locations,
        editable: false
      }, /*#__PURE__*/external_react_default().createElement(LocationList/* default */.A, {
        userOrganizations: user.activeOrganizations,
        hasAccessToEntireIdn: user.hasAccessToEntireIdn,
        className: dataClassName
      })), /*#__PURE__*/external_react_default().createElement(Row["default"], {
        rowPart: detailsPageNames.ExternalIds,
        onClick: this.props.onEditExternalIds,
        editable: this.props.enableExternalIdsEditing
      }, /*#__PURE__*/external_react_default().createElement("div", {
        className: dataClassName
      }, "NPI, NABP e-Profile ID"))));
    }
  }]);
}(external_react_.PureComponent);
var getTitleText = function getTitleText(user) {
  return user.isActive ? /*#__PURE__*/external_react_default().createElement("span", {
    className: "truncate dark",
    name: "userTitle"
  }, user.firstName, " ", user.lastName) : /*#__PURE__*/external_react_default().createElement("div", {
    className: "truncate light"
  }, /*#__PURE__*/external_react_default().createElement("span", {
    className: "material-icons"
  }, "\uE888"), /*#__PURE__*/external_react_default().createElement("span", {
    name: "userTitle"
  }, "Inactive - ", user.firstName, " ", user.lastName));
};
var getHealthSystemRow = function getHealthSystemRow(dataClassName) {
  var rowDisabledClassName = "row row-link inactive";
  var labelClassName = "col-xs-2 col-md-3 NameColumn";
  return /*#__PURE__*/external_react_default().createElement("div", {
    className: rowDisabledClassName,
    id: "hsDetails"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    className: labelClassName
  }, /*#__PURE__*/external_react_default().createElement("span", {
    className: "light"
  }, "Health System")), /*#__PURE__*/external_react_default().createElement("div", {
    className: dataClassName
  }, /*#__PURE__*/external_react_default().createElement("span", {
    className: "dark"
  }, "P1S")), /*#__PURE__*/external_react_default().createElement("div", {
    className: "col-xs-1 col-md-1"
  }));
};
 false ? 0 : void 0;
/* harmony default export */ const Profile_Details = (Details);
// EXTERNAL MODULE: ./src/utilities/UserUtilities.js
var UserUtilities = __webpack_require__(9840);
// EXTERNAL MODULE: ./src/components/TextInput.jsx
var TextInput = __webpack_require__(7642);
// EXTERNAL MODULE: ./src/components/DateInput.jsx
var DateInput = __webpack_require__(1789);
// EXTERNAL MODULE: ./src/components/DropDown/index.js + 2 modules
var DropDown = __webpack_require__(3615);
// EXTERNAL MODULE: ./src/components/ActionButtonsPanel.js
var ActionButtonsPanel = __webpack_require__(1504);
// EXTERNAL MODULE: ./src/utilities/EventUtilities.js
var EventUtilities = __webpack_require__(5609);
// EXTERNAL MODULE: ./src/utilities/ValidationUtilities.js
var ValidationUtilities = __webpack_require__(4708);
// EXTERNAL MODULE: ./src/components/Accordion/index.js + 1 modules
var Accordion = __webpack_require__(2696);
// EXTERNAL MODULE: ./src/components/CheckBox/CheckBox.jsx
var CheckBox = __webpack_require__(9692);
;// CONCATENATED MODULE: ./src/components/Profile/ExternalIdentifiers.jsx
function ExternalIdentifiers_typeof(o) { "@babel/helpers - typeof"; return ExternalIdentifiers_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, ExternalIdentifiers_typeof(o); }
function ExternalIdentifiers_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function ExternalIdentifiers_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, ExternalIdentifiers_toPropertyKey(o.key), o); } }
function ExternalIdentifiers_createClass(e, r, t) { return r && ExternalIdentifiers_defineProperties(e.prototype, r), t && ExternalIdentifiers_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function ExternalIdentifiers_callSuper(t, o, e) { return o = ExternalIdentifiers_getPrototypeOf(o), ExternalIdentifiers_possibleConstructorReturn(t, ExternalIdentifiers_isNativeReflectConstruct() ? Reflect.construct(o, e || [], ExternalIdentifiers_getPrototypeOf(t).constructor) : o.apply(t, e)); }
function ExternalIdentifiers_possibleConstructorReturn(t, e) { if (e && ("object" == ExternalIdentifiers_typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return ExternalIdentifiers_assertThisInitialized(t); }
function ExternalIdentifiers_assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function ExternalIdentifiers_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (ExternalIdentifiers_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function ExternalIdentifiers_getPrototypeOf(t) { return ExternalIdentifiers_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, ExternalIdentifiers_getPrototypeOf(t); }
function ExternalIdentifiers_inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && ExternalIdentifiers_setPrototypeOf(t, e); }
function ExternalIdentifiers_setPrototypeOf(t, e) { return ExternalIdentifiers_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, ExternalIdentifiers_setPrototypeOf(t, e); }
function ExternalIdentifiers_defineProperty(e, r, t) { return (r = ExternalIdentifiers_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function ExternalIdentifiers_toPropertyKey(t) { var i = ExternalIdentifiers_toPrimitive(t, "string"); return "symbol" == ExternalIdentifiers_typeof(i) ? i : i + ""; }
function ExternalIdentifiers_toPrimitive(t, r) { if ("object" != ExternalIdentifiers_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != ExternalIdentifiers_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }













var ExternalIdentifiers = /*#__PURE__*/function (_Component) {
  function ExternalIdentifiers(props, context) {
    var _this$props$externalI, _this$props$externalI2, _this$props$externalI3, _this$props$externalI4;
    var _this;
    ExternalIdentifiers_classCallCheck(this, ExternalIdentifiers);
    _this = ExternalIdentifiers_callSuper(this, ExternalIdentifiers, [props, context]);
    ExternalIdentifiers_defineProperty(_this, "getLabel", function (name, tooltip) {
      return /*#__PURE__*/external_react_default().createElement("div", null, name, /*#__PURE__*/external_react_default().createElement("span", {
        className: "tooltip-container"
      }, /*#__PURE__*/external_react_default().createElement("span", {
        className: "material-icons row-icon external-ids-info-icon",
        "data-name": "infoIcon"
      }, "info"), /*#__PURE__*/external_react_default().createElement("span", {
        className: "tooltip"
      }, tooltip)));
    });
    ExternalIdentifiers_defineProperty(_this, "onNumericInputKeyPress", function (event) {
      if (!(0,EventUtilities/* isNumberKeyFromEvent */.Db)(event)) {
        event.preventDefault();
      }
    });
    ExternalIdentifiers_defineProperty(_this, "onNpiChange", function (event) {
      if ((0,ValidationUtilities/* isDigitsOnly */.Db)(event.target.value)) {
        _this.props.onNpiChange(event);
      }
    });
    ExternalIdentifiers_defineProperty(_this, "onNabpEPidChange", function (event) {
      if ((0,ValidationUtilities/* isDigitsOnly */.Db)(event.target.value)) {
        _this.props.onNabpEPidChange(event);
      }
    });
    ExternalIdentifiers_defineProperty(_this, "setFocusOnNabpEPid", function () {
      _this.nabpEPidInput.setFocus();
      _this.nabpEPidInput.select();
    });
    ExternalIdentifiers_defineProperty(_this, "onCheckboxCheck", function () {
      var value = !_this.state.hasNoNabp;
      _this.setState({
        hasNoNabp: value
      });
      _this.setState({
        accordionExpanded: !value
      });
      _this.props.onHasNabpChange(value);
    });
    ExternalIdentifiers_defineProperty(_this, "accordionChange", function () {
      _this.setState({
        accordionExpanded: !_this.state.accordionExpanded
      });
    });
    ExternalIdentifiers_defineProperty(_this, "onBackKeyDown", function (event) {
      if ((0,EventUtilities/* isTabPressed */.Wz)(event) && (0,EventUtilities/* isShiftPressed */.Hk)(event)) {
        event.preventDefault();
        _this.buttonsRef.setFocus();
      }
    });
    _this.state = {
      hasNoNabp: (_this$props$externalI = (_this$props$externalI2 = _this.props.externalIds) === null || _this$props$externalI2 === void 0 ? void 0 : _this$props$externalI2.hasNoNabp) !== null && _this$props$externalI !== void 0 ? _this$props$externalI : false,
      accordionExpanded: (_this$props$externalI3 = (_this$props$externalI4 = _this.props.externalIds) === null || _this$props$externalI4 === void 0 ? void 0 : _this$props$externalI4.nabpEPid) !== null && _this$props$externalI3 !== void 0 ? _this$props$externalI3 : false
    };
    _this.onCancelTab = _this.onCancelTab.bind(_this);
    _this.setFocusOnNabpEPid = _this.setFocusOnNabpEPid.bind(_this);
    return _this;
  }
  ExternalIdentifiers_inherits(ExternalIdentifiers, _Component);
  return ExternalIdentifiers_createClass(ExternalIdentifiers, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.setFocusOnNabpEPid) {
        this.setFocusOnNabpEPid();
      } else if (this.npiRef) {
        this.npiRef.setFocus();
        this.npiRef.select();
      }
    }
  }, {
    key: "onCancelTab",
    value: function onCancelTab() {
      this.navBarRef.setFocus();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props$nabpRoles,
        _this2 = this,
        _this$props$externalI5,
        _this$props$externalI6,
        _this$props$externalI7;
      var npiLabel = this.getLabel("National Provider Identifier", "Enter a National Provider Identifier to use integrated intervention notes in Sentri7 Pharmacy");
      var nabpEPidLabel = this.getLabel("NABP e-Profile ID", "Enter an NABP e-Profile ID to use CE reporting features for Simplifi 797");
      var options = {
        date: true,
        datePattern: ["m", "d"]
      };
      var items = ((_this$props$nabpRoles = this.props.nabpRoles) === null || _this$props$nabpRoles === void 0 ? void 0 : _this$props$nabpRoles.map(function (x) {
        return {
          name: x.name,
          value: x.nabpRoleId
        };
      })) || [];
      var selected = items === null || items === void 0 ? void 0 : items.find(function (r) {
        var _this2$props$external;
        return r.value === ((_this2$props$external = _this2.props.externalIds) === null || _this2$props$external === void 0 ? void 0 : _this2$props$external.nabpRoleId);
      });
      var isAccordionExpanded = this.state.accordionExpanded;
      var isDateOfBirthDisabled = this.props.isNabpOptionsDisabled || this.props.disabled || this.state.hasNoNabp;
      var isNabpRoleDisabled = this.props.isNabpOptionsDisabled || this.props.disabled || this.state.hasNoNabp;
      return /*#__PURE__*/external_react_default().createElement("div", {
        className: "form-container"
      }, /*#__PURE__*/external_react_default().createElement(NavigationBar["default"], {
        onClick: this.props.onBackClick,
        titleText: this.props.title,
        hasRouter: false,
        backLinkTabIndex: 1,
        ref: function ref(_ref) {
          return _this2.navBarRef = _ref;
        },
        onKeyDown: this.onBackKeyDown
      }), /*#__PURE__*/external_react_default().createElement("div", {
        className: "base-content"
      }, /*#__PURE__*/external_react_default().createElement("div", {
        id: "editExternalIds",
        className: "form form-vertical"
      }, /*#__PURE__*/external_react_default().createElement("fieldset", null, /*#__PURE__*/external_react_default().createElement("div", {
        className: "row"
      }, /*#__PURE__*/external_react_default().createElement(TextInput["default"], {
        ref: function ref(_ref2) {
          return _this2.npiRef = _ref2;
        },
        name: "nationalProviderIdentifier",
        label: npiLabel,
        tabIndex: 1,
        value: ((_this$props$externalI5 = this.props.externalIds) === null || _this$props$externalI5 === void 0 ? void 0 : _this$props$externalI5.nationalProviderIdentifier) || "",
        onChange: this.onNpiChange,
        error: this.props.npiError,
        disabled: this.props.disabled,
        placeholder: "(Optional)",
        maxlength: 10,
        className: "col-md-6",
        onKeyPress: this.onNumericInputKeyPress
      })), /*#__PURE__*/external_react_default().createElement(Accordion["default"], {
        id: "nabpEPidAccordion",
        header: "Enter NABP e-Profile ID",
        tabIndex: 1,
        "aria-controls": "nabpEPidAccordion",
        expanded: isAccordionExpanded,
        onChange: this.accordionChange
      }, /*#__PURE__*/external_react_default().createElement("div", {
        className: "container"
      }, /*#__PURE__*/external_react_default().createElement("div", {
        className: "row"
      }, /*#__PURE__*/external_react_default().createElement(TextInput["default"], {
        name: "nabpEPid",
        label: nabpEPidLabel,
        tabIndex: 1,
        value: ((_this$props$externalI6 = this.props.externalIds) === null || _this$props$externalI6 === void 0 ? void 0 : _this$props$externalI6.nabpEPid) || "",
        onChange: this.onNabpEPidChange,
        error: this.props.nabpEPidError,
        disabled: this.props.disabled || this.state.hasNoNabp,
        placeholder: "(Optional)",
        maxlength: 10,
        className: "col-md-12",
        onKeyPress: this.onNumericInputKeyPress,
        ref: function ref(input) {
          return _this2.nabpEPidInput = input;
        }
      })), /*#__PURE__*/external_react_default().createElement("div", {
        className: "row"
      }, /*#__PURE__*/external_react_default().createElement(DateInput["default"], {
        name: "dateOfBirth",
        value: ((_this$props$externalI7 = this.props.externalIds) === null || _this$props$externalI7 === void 0 ? void 0 : _this$props$externalI7.dateOfBirth) || "",
        label: "Date Of Birth (Month and Day)",
        placeholder: "MM/DD",
        className: "form-group col-md-12 nabp-date-of-birth",
        tabIndex: 1,
        options: options,
        onChange: this.props.onDateOfBirthChange,
        error: this.props.dateOfBirthError,
        disabled: isDateOfBirthDisabled,
        inputClassName: this.props.dateOfBirthClassName
      })), /*#__PURE__*/external_react_default().createElement("div", {
        className: "row"
      }, /*#__PURE__*/external_react_default().createElement("div", {
        className: "form-group col-md-12"
      }, /*#__PURE__*/external_react_default().createElement(DropDown["default"], {
        id: "nabpRole",
        items: items,
        label: "NABP Role",
        selectedItem: selected,
        dataFieldName: "name",
        name: "nabpRole",
        onSelect: this.props.onNabpRoleChanged,
        error: this.props.nabpRoleError,
        tabIndex: isNabpRoleDisabled ? -1 : 1,
        isDisabled: isNabpRoleDisabled
      }))))), /*#__PURE__*/external_react_default().createElement(CheckBox/* default */.A, {
        name: "dontHaveNabp",
        label: "I don't have an NABP e-Profile ID",
        checked: this.state.hasNoNabp,
        value: this.state.hasNoNabp,
        tabIndex: 1,
        onChange: this.onCheckboxCheck,
        className: "has-no-nabp"
      })), /*#__PURE__*/external_react_default().createElement(ActionButtonsPanel["default"], {
        hasExternalFocus: true,
        ref: function ref(_ref3) {
          return _this2.buttonsRef = _ref3;
        },
        onSave: this.props.onSave,
        onCancel: this.props.onCancel,
        isDisabled: this.props.isSaveButtonDisabled,
        moveFocusBack: this.onCancelTab
      }))));
    }
  }]);
}(external_react_.Component);
 false ? 0 : void 0;
/* harmony default export */ const Profile_ExternalIdentifiers = (ExternalIdentifiers);
// EXTERNAL MODULE: ./src/entities/ExternalIdentifiers.js
var entities_ExternalIdentifiers = __webpack_require__(3465);
;// CONCATENATED MODULE: ./src/constants/ExternalIdsErrors.js
var externalIdsErrors = {
  NationalProviderIdentifier: "NPI must be unique within the IDN.",
  NabpEPid: "NABP e-Profile ID must be unique within the IDN."
};
var fieldTypes = {
  nationalProviderIdentifier: "NationalProviderIdentifier",
  nabpEPid: "NabpEPid"
};
;// CONCATENATED MODULE: ./src/components/Profile/EditExternalIds.jsx
function EditExternalIds_typeof(o) { "@babel/helpers - typeof"; return EditExternalIds_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, EditExternalIds_typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == EditExternalIds_typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(EditExternalIds_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function EditExternalIds_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function EditExternalIds_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, EditExternalIds_toPropertyKey(o.key), o); } }
function EditExternalIds_createClass(e, r, t) { return r && EditExternalIds_defineProperties(e.prototype, r), t && EditExternalIds_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function EditExternalIds_callSuper(t, o, e) { return o = EditExternalIds_getPrototypeOf(o), EditExternalIds_possibleConstructorReturn(t, EditExternalIds_isNativeReflectConstruct() ? Reflect.construct(o, e || [], EditExternalIds_getPrototypeOf(t).constructor) : o.apply(t, e)); }
function EditExternalIds_possibleConstructorReturn(t, e) { if (e && ("object" == EditExternalIds_typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return EditExternalIds_assertThisInitialized(t); }
function EditExternalIds_assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function EditExternalIds_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (EditExternalIds_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function EditExternalIds_getPrototypeOf(t) { return EditExternalIds_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, EditExternalIds_getPrototypeOf(t); }
function EditExternalIds_inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && EditExternalIds_setPrototypeOf(t, e); }
function EditExternalIds_setPrototypeOf(t, e) { return EditExternalIds_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, EditExternalIds_setPrototypeOf(t, e); }
function EditExternalIds_defineProperty(e, r, t) { return (r = EditExternalIds_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function EditExternalIds_toPropertyKey(t) { var i = EditExternalIds_toPrimitive(t, "string"); return "symbol" == EditExternalIds_typeof(i) ? i : i + ""; }
function EditExternalIds_toPrimitive(t, r) { if ("object" != EditExternalIds_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != EditExternalIds_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }






var EditExternalIds = /*#__PURE__*/function (_Component) {
  function EditExternalIds(props, context) {
    var _props$user$externalI, _props$user$externalI2;
    var _this;
    EditExternalIds_classCallCheck(this, EditExternalIds);
    _this = EditExternalIds_callSuper(this, EditExternalIds, [props, context]);
    EditExternalIds_defineProperty(_this, "onNabpRoleChanged", function (item) {
      _this.resetForm();
      var externalIds = _this.state.externalIds;
      if (!externalIds) externalIds = new entities_ExternalIdentifiers/* default */.A();
      externalIds.nabpRoleId = item.value;
      _this.setState({
        externalIds: externalIds
      });
    });
    EditExternalIds_defineProperty(_this, "onSave", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var user, externalIds, duplicatedFields;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            user = _this.state.user;
            externalIds = _this.state.externalIds;
            if (!(externalIds && _this.isValid(externalIds))) {
              _context.next = 16;
              break;
            }
            _context.next = 5;
            return _this.props.checkExternalIdsUniqueness(user, externalIds);
          case 5:
            duplicatedFields = _context.sent;
            if (!(!duplicatedFields || duplicatedFields.length === 0)) {
              _context.next = 13;
              break;
            }
            _this.removeValuesIfNoNabp(externalIds);
            _context.next = 10;
            return _this.props.updateUserExternalIds(user, externalIds);
          case 10:
            _this.props.backToProfilePage();
            _context.next = 14;
            break;
          case 13:
            _this.setState({
              duplicatedFields: duplicatedFields
            });
          case 14:
            _context.next = 21;
            break;
          case 16:
            if (!_this.isValid(externalIds)) {
              _context.next = 21;
              break;
            }
            _this.removeValuesIfNoNabp(externalIds);
            _context.next = 20;
            return _this.props.updateUserExternalIds(user, externalIds);
          case 20:
            _this.props.backToProfilePage();
          case 21:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    EditExternalIds_defineProperty(_this, "onChange", function (event) {
      _this.resetForm();
      var field = event.target.name;
      var externalIds = _this.state.externalIds;
      if (!externalIds) externalIds = new entities_ExternalIdentifiers/* default */.A();
      externalIds[field] = event.target.value;
      _this.setState({
        externalIds: externalIds
      });
    });
    EditExternalIds_defineProperty(_this, "onNabpEPidChange", function (event) {
      _this.resetForm();
      var value = event.target.value;
      var externalIds = _this.state.externalIds;
      if (!externalIds) externalIds = new entities_ExternalIdentifiers/* default */.A();
      if (!value) {
        externalIds.nabpRoleId = undefined;
        externalIds.dateOfBirth = "";
      }
      externalIds.nabpEPid = value;
      _this.setState({
        isNabpOptionsDisabled: !value
      });
      _this.setState({
        externalIds: externalIds
      });
    });
    EditExternalIds_defineProperty(_this, "onHasNoNabpChange", function (hasNoNabp) {
      _this.resetForm();
      var externalIds = _this.state.externalIds;
      if (!externalIds) {
        externalIds = new entities_ExternalIdentifiers/* default */.A();
      }
      externalIds.hasNoNabp = hasNoNabp;
      _this.setState({
        externalIds: externalIds
      });
    });
    EditExternalIds_defineProperty(_this, "removeValuesIfNoNabp", function (externalIds) {
      if (externalIds.hasNoNabp) {
        externalIds.nabpRoleId = undefined;
        externalIds.dateOfBirth = "";
        externalIds.nabpEPid = "";
      }
      return externalIds;
    });
    EditExternalIds_defineProperty(_this, "isValid", function (externalIds) {
      var errors = {};
      var formIsValid = true;
      if (!externalIds) return formIsValid;
      var validations = [{
        target: "NationalProviderIdentifier",
        validator: UserUtilities/* Validation */.OH.validateNationalProviderIdentifier(externalIds.nationalProviderIdentifier)
      }, {
        target: "NabpEPid",
        validator: UserUtilities/* Validation */.OH.validateNabp(externalIds.nabpEPid)
      }, {
        target: "DateOfBirth",
        validator: UserUtilities/* Validation */.OH.validateNabpBirthDate(externalIds.dateOfBirth, externalIds.nabpEPid)
      }, {
        target: "NabpRoleId",
        validator: UserUtilities/* Validation */.OH.validateNabpRole(externalIds.nabpRoleId, externalIds.nabpEPid)
      }];
      validations.filter(function (el) {
        return !el.validator.isValid;
      }).forEach(function (_ref2) {
        var target = _ref2.target,
          validator = _ref2.validator;
        errors[target] = validator.error;
      });
      formIsValid = !validations.some(function (el) {
        return !el.validator.isValid;
      });
      _this.setState({
        formIsValid: formIsValid
      });
      _this.setState({
        errors: errors
      });
      return formIsValid;
    });
    EditExternalIds_defineProperty(_this, "getExternalIdsError", function (field) {
      if (_this.hasError()) {
        var foundField = _this.state.duplicatedFields.find(function (x) {
          return x === field;
        });
        if (!foundField) return "";
        return externalIdsErrors[foundField];
      }
    });
    EditExternalIds_defineProperty(_this, "hasError", function () {
      return _this.state.duplicatedFields && _this.state.duplicatedFields.length > 0;
    });
    EditExternalIds_defineProperty(_this, "resetForm", function () {
      if (_this.hasError()) _this.resetExternalIdsValidation();
      _this.setState({
        formIsValid: true
      });
    });
    EditExternalIds_defineProperty(_this, "resetExternalIdsValidation", function () {
      _this.setState({
        duplicatedFields: null
      });
    });
    _this.state = {
      errors: {},
      user: props.user.createCopy(),
      isLoading: false,
      isNabpOptionsDisabled: !((_props$user$externalI = props.user.externalIdentifiers) !== null && _props$user$externalI !== void 0 && _props$user$externalI.nabpEPid),
      formIsValid: true,
      externalIds: (_props$user$externalI2 = props.user.externalIdentifiers) === null || _props$user$externalI2 === void 0 ? void 0 : _props$user$externalI2.createCopy(),
      duplicatedFields: null
    };
    _this.onSave = _this.onSave.bind(_this);
    _this.onChange = _this.onChange.bind(_this);
    _this.onNabpRoleChanged = _this.onNabpRoleChanged.bind(_this);
    _this.onNabpEPidChange = _this.onNabpEPidChange.bind(_this);
    return _this;
  }
  EditExternalIds_inherits(EditExternalIds, _Component);
  return EditExternalIds_createClass(EditExternalIds, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.getNabpRoles();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state$errors$Na,
        _this$state$errors$Na2,
        _this2 = this;
      var user = this.state.user;
      if (!user) return null;
      var dateOfBirthClassName = "form-control";
      dateOfBirthClassName += this.state.isNabpOptionsDisabled ? " disabled" : "";
      var npiError = (_this$state$errors$Na = this.state.errors.NationalProviderIdentifier) !== null && _this$state$errors$Na !== void 0 ? _this$state$errors$Na : this.getExternalIdsError(fieldTypes.nationalProviderIdentifier);
      var nabpEPidError = (_this$state$errors$Na2 = this.state.errors.NabpEPid) !== null && _this$state$errors$Na2 !== void 0 ? _this$state$errors$Na2 : this.getExternalIdsError(fieldTypes.nabpEPid);
      var isValid = this.state.formIsValid && !this.hasError();
      var onBackClick = function onBackClick() {
        return _this2.props.backToProfilePage();
      };
      var title = user.firstName + " " + user.lastName;
      return /*#__PURE__*/external_react_default().createElement(Profile_ExternalIdentifiers, {
        onSave: this.onSave,
        onCancel: onBackClick,
        isSaveButtonDisabled: !isValid,
        onNpiChange: this.onChange,
        npiError: npiError,
        nabpEPidError: nabpEPidError,
        dateOfBirthError: this.state.errors.DateOfBirth,
        nabpRoleError: this.state.errors.NabpRoleId,
        onNabpEPidChange: this.onNabpEPidChange,
        onDateOfBirthChange: this.onChange,
        onNabpRoleChanged: this.onNabpRoleChanged,
        isNabpOptionsDisabled: this.state.isNabpOptionsDisabled,
        disabled: this.state.isLoading,
        dateOfBirthClassName: dateOfBirthClassName,
        nabpRoles: this.props.nabpRoles,
        externalIds: this.state.externalIds,
        title: title,
        onBackClick: onBackClick,
        setFocusOnNabpEPid: this.props.setFocusOnNabpEPid,
        onHasNabpChange: this.onHasNoNabpChange
      });
    }
  }]);
}(external_react_.Component);

 false ? 0 : void 0;
;// CONCATENATED MODULE: ./src/components/Profile/Profile.jsx
function Profile_typeof(o) { "@babel/helpers - typeof"; return Profile_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, Profile_typeof(o); }
function Profile_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function Profile_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, Profile_toPropertyKey(o.key), o); } }
function Profile_createClass(e, r, t) { return r && Profile_defineProperties(e.prototype, r), t && Profile_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function Profile_callSuper(t, o, e) { return o = Profile_getPrototypeOf(o), Profile_possibleConstructorReturn(t, Profile_isNativeReflectConstruct() ? Reflect.construct(o, e || [], Profile_getPrototypeOf(t).constructor) : o.apply(t, e)); }
function Profile_possibleConstructorReturn(t, e) { if (e && ("object" == Profile_typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return Profile_assertThisInitialized(t); }
function Profile_assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function Profile_isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (Profile_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function Profile_getPrototypeOf(t) { return Profile_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, Profile_getPrototypeOf(t); }
function Profile_inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && Profile_setPrototypeOf(t, e); }
function Profile_setPrototypeOf(t, e) { return Profile_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, Profile_setPrototypeOf(t, e); }
function Profile_defineProperty(e, r, t) { return (r = Profile_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function Profile_toPropertyKey(t) { var i = Profile_toPrimitive(t, "string"); return "symbol" == Profile_typeof(i) ? i : i + ""; }
function Profile_toPrimitive(t, r) { if ("object" != Profile_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != Profile_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }










var Profile = /*#__PURE__*/function (_Component) {
  function Profile(props, context) {
    var _this;
    Profile_classCallCheck(this, Profile);
    _this = Profile_callSuper(this, Profile, [props, context]);
    Profile_defineProperty(_this, "onEditName", function () {
      _this.setState({
        view: ProfileParts/* default */.A.editName
      });
    });
    Profile_defineProperty(_this, "onEditEmail", function () {
      _this.setState({
        view: ProfileParts/* default */.A.editEmail
      });
    });
    Profile_defineProperty(_this, "onEditExternalIds", function () {
      _this.setState({
        view: ProfileParts/* default */.A.editExternalIds
      });
    });
    Profile_defineProperty(_this, "backToDetails", function () {
      _this.setState({
        view: ProfileParts/* default */.A.details
      });
    });
    _this.state = {
      view: _this.props.showPart || ProfileParts/* default */.A.details
    };
    return _this;
  }
  Profile_inherits(Profile, _Component);
  return Profile_createClass(Profile, [{
    key: "render",
    value: function render() {
      var user = this.props.currentUser;
      var setFocusOnNabpEPid = this.props.showPart === ProfileParts/* default */.A.editExternalIds;
      if (user == null) return null;
      if (this.state.view === ProfileParts/* default */.A.editName) return /*#__PURE__*/external_react_default().createElement(EditInfo/* default */.A, {
        user: user,
        updateCurrentUser: this.props.onUserSave,
        backToProfilePage: this.backToDetails
      });
      if (this.state.view === ProfileParts/* default */.A.editEmail) return /*#__PURE__*/external_react_default().createElement(EditEmail/* default */.A, {
        user: user,
        backToProfilePage: this.backToDetails,
        discardChanges: this.props.discardEmailChanges,
        onVerifyUserEmail: this.props.verifyUserEmailAction,
        resendVerificationEmail: this.props.resendVerificationEmail
      });
      if (this.state.view === ProfileParts/* default */.A.editExternalIds) return /*#__PURE__*/external_react_default().createElement(EditExternalIds, {
        user: user,
        backToProfilePage: this.backToDetails,
        checkExternalIdsUniqueness: this.props.checkExternalIdsUniqueness,
        updateUserExternalIds: this.props.updateExternalIds,
        getNabpRoles: this.props.getNabpRoles,
        nabpRoles: this.props.nabpRoles,
        setFocusOnNabpEPid: setFocusOnNabpEPid
      });
      return /*#__PURE__*/external_react_default().createElement(Profile_Details, {
        currentUser: user,
        hasRouter: this.props.hasRouter,
        onEditEmail: this.onEditEmail,
        waitForSend: this.props.waitForSend,
        sentRecently: this.props.sentRecently,
        onEditName: this.onEditName,
        onEditExternalIds: this.onEditExternalIds,
        onVerifyUserEmail: this.props.verifyUserEmailAction,
        currentUrl: this.props.currentUrl,
        enableExternalIdsEditing: this.props.enableExternalIdsEditing
      });
    }
  }]);
}(external_react_.Component);

Profile.defaultProps = {
  enableExternalIdsEditing: false
};
 false ? 0 : void 0;
;// CONCATENATED MODULE: ./src/components/Profile/index.js










/* harmony default export */ const components_Profile = (Profile);
})();

/******/ 	return __webpack_exports__;
/******/ })()
;
});